var Ss = Object.defineProperty;
var Os = (e, t, r) => t in e ? Ss(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var at = (e, t, r) => Os(e, typeof t != "symbol" ? t + "" : t, r);
var Gr = function(e, t) {
  return Gr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Gr(e, t);
};
function De(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Gr(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var v = function() {
  return v = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, v.apply(this, arguments);
};
function Pe(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function xe(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (h) {
        a(h);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (h) {
        a(h);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function Me(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = s(0), a.throw = s(1), a.return = s(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (r = 0)), r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function se(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Pr = "Invariant Violation", ti = Object.setPrototypeOf, Ts = ti === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : ti, wo = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = Pr);
      var n = e.call(this, typeof r == "number" ? Pr + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = Pr, Ts(n, t.prototype), n;
    }
    return t;
  })(Error)
);
function Ye(e, t) {
  if (!e)
    throw new wo(t);
}
var Eo = ["debug", "log", "warn", "error", "silent"], Ds = Eo.indexOf("log");
function Ht(e) {
  return function() {
    if (Eo.indexOf(e) >= Ds) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = Ht("debug"), e.log = Ht("log"), e.warn = Ht("warn"), e.error = Ht("error");
})(Ye || (Ye = {}));
var En = "3.14.1";
function Oe(e) {
  try {
    return e();
  } catch {
  }
}
const lr = Oe(function() {
  return globalThis;
}) || Oe(function() {
  return window;
}) || Oe(function() {
  return self;
}) || Oe(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Oe(function() {
  return Oe.constructor("return this")();
});
var ri = /* @__PURE__ */ new Map();
function Kr(e) {
  var t = ri.get(e) || 1;
  return ri.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function ko(e, t) {
  t === void 0 && (t = 0);
  var r = Kr("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function Yt(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = kn(i), t || (t = Sn(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var D = Object.assign(function(t, r) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  t || Ye(t, kn(r, n) || Sn(r, n));
}, {
  debug: Yt(Ye.debug),
  log: Yt(Ye.log),
  warn: Yt(Ye.warn),
  error: Yt(Ye.error)
});
function ve(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new wo(kn(e, t) || Sn(e, t));
}
var ni = Symbol.for("ApolloErrorMessageHandler_" + En);
function So(e) {
  if (typeof e == "string")
    return e;
  try {
    return ko(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function kn(e, t) {
  if (t === void 0 && (t = []), !!e)
    return lr[ni] && lr[ni](e, t.map(So));
}
function Sn(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: En,
      message: e,
      args: t.map(So)
    })));
}
var K = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function Is(e, t) {
  var r = !!e;
  if (!r)
    throw new Error("Unexpected invariant triggered.");
}
var Hr = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function Oo(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || Is(0), e.prototype.inspect = t, Hr && (e.prototype[Hr] = t);
}
var zs = /* @__PURE__ */ (function() {
  function e(r, n, i) {
    this.start = r.start, this.end = n.end, this.startToken = r, this.endToken = n, this.source = i;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
})();
Oo(zs);
var Rs = /* @__PURE__ */ (function() {
  function e(r, n, i, o, a, s, u) {
    this.kind = r, this.start = n, this.end = i, this.line = o, this.column = a, this.value = u, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
})();
Oo(Rs);
function ii(e) {
  return e != null && typeof e.kind == "string";
}
function nr(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? nr = function(r) {
    return typeof r;
  } : nr = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, nr(e);
}
var Ps = 10, To = 2;
function Fs(e) {
  return _r(e, []);
}
function _r(e, t) {
  switch (nr(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : Cs(e, t);
    default:
      return String(e);
  }
}
function Cs(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var r = [].concat(t, [e]), n = xs(e);
  if (n !== void 0) {
    var i = n.call(e);
    if (i !== e)
      return typeof i == "string" ? i : _r(i, r);
  } else if (Array.isArray(e))
    return As(e, r);
  return Ns(e, r);
}
function Ns(e, t) {
  var r = Object.keys(e);
  if (r.length === 0)
    return "{}";
  if (t.length > To)
    return "[" + Ms(e) + "]";
  var n = r.map(function(i) {
    var o = _r(e[i], t);
    return i + ": " + o;
  });
  return "{ " + n.join(", ") + " }";
}
function As(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > To)
    return "[Array]";
  for (var r = Math.min(Ps, e.length), n = e.length - r, i = [], o = 0; o < r; ++o)
    i.push(_r(e[o], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push("... ".concat(n, " more items")), "[" + i.join(", ") + "]";
}
function xs(e) {
  var t = e[String(Hr)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function Ms(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
function js(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = e.indexOf(`
`) === -1, i = e[0] === " " || e[0] === "	", o = e[e.length - 1] === '"', a = e[e.length - 1] === "\\", s = !n || o || a || r, u = "";
  return s && !(n && i) && (u += `
` + t), u += t ? e.replace(/\n/g, `
` + t) : e, s && (u += `
`), '"""' + u.replace(/"""/g, '\\"""') + '"""';
}
var $s = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, wr = Object.freeze({});
function Te(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $s, n = void 0, i = Array.isArray(e), o = [e], a = -1, s = [], u = void 0, c = void 0, l = void 0, h = [], d = [], f = e;
  do {
    a++;
    var p = a === o.length, m = p && s.length !== 0;
    if (p) {
      if (c = d.length === 0 ? void 0 : h[h.length - 1], u = l, l = d.pop(), m) {
        if (i)
          u = u.slice();
        else {
          for (var g = {}, y = 0, _ = Object.keys(u); y < _.length; y++) {
            var w = _[y];
            g[w] = u[w];
          }
          u = g;
        }
        for (var S = 0, O = 0; O < s.length; O++) {
          var T = s[O][0], F = s[O][1];
          i && (T -= S), i && F === null ? (u.splice(T, 1), S++) : u[T] = F;
        }
      }
      a = n.index, o = n.keys, s = n.edits, i = n.inArray, n = n.prev;
    } else {
      if (c = l ? i ? a : o[a] : void 0, u = l ? l[c] : f, u == null)
        continue;
      l && h.push(c);
    }
    var R = void 0;
    if (!Array.isArray(u)) {
      if (!ii(u))
        throw new Error("Invalid AST Node: ".concat(Fs(u), "."));
      var x = Ls(t, u.kind, p);
      if (x) {
        if (R = x.call(t, u, c, l, h, d), R === wr)
          break;
        if (R === !1) {
          if (!p) {
            h.pop();
            continue;
          }
        } else if (R !== void 0 && (s.push([c, R]), !p))
          if (ii(R))
            u = R;
          else {
            h.pop();
            continue;
          }
      }
    }
    if (R === void 0 && m && s.push([c, u]), p)
      h.pop();
    else {
      var L;
      n = {
        inArray: i,
        index: a,
        keys: o,
        edits: s,
        prev: n
      }, i = Array.isArray(u), o = i ? u : (L = r[u.kind]) !== null && L !== void 0 ? L : [], a = -1, s = [], l && d.push(l), l = u;
    }
  } while (n !== void 0);
  return s.length !== 0 && (f = s[s.length - 1][1]), f;
}
function Ls(e, t, r) {
  var n = e[t];
  if (n) {
    if (!r && typeof n == "function")
      return n;
    var i = r ? n.leave : n.enter;
    if (typeof i == "function")
      return i;
  } else {
    var o = r ? e.leave : e.enter;
    if (o) {
      if (typeof o == "function")
        return o;
      var a = o[t];
      if (typeof a == "function")
        return a;
    }
  }
}
function Vs(e) {
  return Te(e, {
    leave: Zs
  });
}
var qs = 80, Zs = {
  Name: function(t) {
    return t.value;
  },
  Variable: function(t) {
    return "$" + t.name;
  },
  // Document
  Document: function(t) {
    return z(t.definitions, `

`) + `
`;
  },
  OperationDefinition: function(t) {
    var r = t.operation, n = t.name, i = G("(", z(t.variableDefinitions, ", "), ")"), o = z(t.directives, " "), a = t.selectionSet;
    return !n && !o && !i && r === "query" ? a : z([r, z([n, i]), o, a], " ");
  },
  VariableDefinition: function(t) {
    var r = t.variable, n = t.type, i = t.defaultValue, o = t.directives;
    return r + ": " + n + G(" = ", i) + G(" ", z(o, " "));
  },
  SelectionSet: function(t) {
    var r = t.selections;
    return Se(r);
  },
  Field: function(t) {
    var r = t.alias, n = t.name, i = t.arguments, o = t.directives, a = t.selectionSet, s = G("", r, ": ") + n, u = s + G("(", z(i, ", "), ")");
    return u.length > qs && (u = s + G(`(
`, ir(z(i, `
`)), `
)`)), z([u, z(o, " "), a], " ");
  },
  Argument: function(t) {
    var r = t.name, n = t.value;
    return r + ": " + n;
  },
  // Fragments
  FragmentSpread: function(t) {
    var r = t.name, n = t.directives;
    return "..." + r + G(" ", z(n, " "));
  },
  InlineFragment: function(t) {
    var r = t.typeCondition, n = t.directives, i = t.selectionSet;
    return z(["...", G("on ", r), z(n, " "), i], " ");
  },
  FragmentDefinition: function(t) {
    var r = t.name, n = t.typeCondition, i = t.variableDefinitions, o = t.directives, a = t.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(r).concat(G("(", z(i, ", "), ")"), " ") + "on ".concat(n, " ").concat(G("", z(o, " "), " ")) + a
    );
  },
  // Value
  IntValue: function(t) {
    var r = t.value;
    return r;
  },
  FloatValue: function(t) {
    var r = t.value;
    return r;
  },
  StringValue: function(t, r) {
    var n = t.value, i = t.block;
    return i ? js(n, r === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(t) {
    var r = t.value;
    return r ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(t) {
    var r = t.value;
    return r;
  },
  ListValue: function(t) {
    var r = t.values;
    return "[" + z(r, ", ") + "]";
  },
  ObjectValue: function(t) {
    var r = t.fields;
    return "{" + z(r, ", ") + "}";
  },
  ObjectField: function(t) {
    var r = t.name, n = t.value;
    return r + ": " + n;
  },
  // Directive
  Directive: function(t) {
    var r = t.name, n = t.arguments;
    return "@" + r + G("(", z(n, ", "), ")");
  },
  // Type
  NamedType: function(t) {
    var r = t.name;
    return r;
  },
  ListType: function(t) {
    var r = t.type;
    return "[" + r + "]";
  },
  NonNullType: function(t) {
    var r = t.type;
    return r + "!";
  },
  // Type System Definitions
  SchemaDefinition: ke(function(e) {
    var t = e.directives, r = e.operationTypes;
    return z(["schema", z(t, " "), Se(r)], " ");
  }),
  OperationTypeDefinition: function(t) {
    var r = t.operation, n = t.type;
    return r + ": " + n;
  },
  ScalarTypeDefinition: ke(function(e) {
    var t = e.name, r = e.directives;
    return z(["scalar", t, z(r, " ")], " ");
  }),
  ObjectTypeDefinition: ke(function(e) {
    var t = e.name, r = e.interfaces, n = e.directives, i = e.fields;
    return z(["type", t, G("implements ", z(r, " & ")), z(n, " "), Se(i)], " ");
  }),
  FieldDefinition: ke(function(e) {
    var t = e.name, r = e.arguments, n = e.type, i = e.directives;
    return t + (oi(r) ? G(`(
`, ir(z(r, `
`)), `
)`) : G("(", z(r, ", "), ")")) + ": " + n + G(" ", z(i, " "));
  }),
  InputValueDefinition: ke(function(e) {
    var t = e.name, r = e.type, n = e.defaultValue, i = e.directives;
    return z([t + ": " + r, G("= ", n), z(i, " ")], " ");
  }),
  InterfaceTypeDefinition: ke(function(e) {
    var t = e.name, r = e.interfaces, n = e.directives, i = e.fields;
    return z(["interface", t, G("implements ", z(r, " & ")), z(n, " "), Se(i)], " ");
  }),
  UnionTypeDefinition: ke(function(e) {
    var t = e.name, r = e.directives, n = e.types;
    return z(["union", t, z(r, " "), n && n.length !== 0 ? "= " + z(n, " | ") : ""], " ");
  }),
  EnumTypeDefinition: ke(function(e) {
    var t = e.name, r = e.directives, n = e.values;
    return z(["enum", t, z(r, " "), Se(n)], " ");
  }),
  EnumValueDefinition: ke(function(e) {
    var t = e.name, r = e.directives;
    return z([t, z(r, " ")], " ");
  }),
  InputObjectTypeDefinition: ke(function(e) {
    var t = e.name, r = e.directives, n = e.fields;
    return z(["input", t, z(r, " "), Se(n)], " ");
  }),
  DirectiveDefinition: ke(function(e) {
    var t = e.name, r = e.arguments, n = e.repeatable, i = e.locations;
    return "directive @" + t + (oi(r) ? G(`(
`, ir(z(r, `
`)), `
)`) : G("(", z(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + z(i, " | ");
  }),
  SchemaExtension: function(t) {
    var r = t.directives, n = t.operationTypes;
    return z(["extend schema", z(r, " "), Se(n)], " ");
  },
  ScalarTypeExtension: function(t) {
    var r = t.name, n = t.directives;
    return z(["extend scalar", r, z(n, " ")], " ");
  },
  ObjectTypeExtension: function(t) {
    var r = t.name, n = t.interfaces, i = t.directives, o = t.fields;
    return z(["extend type", r, G("implements ", z(n, " & ")), z(i, " "), Se(o)], " ");
  },
  InterfaceTypeExtension: function(t) {
    var r = t.name, n = t.interfaces, i = t.directives, o = t.fields;
    return z(["extend interface", r, G("implements ", z(n, " & ")), z(i, " "), Se(o)], " ");
  },
  UnionTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.types;
    return z(["extend union", r, z(n, " "), i && i.length !== 0 ? "= " + z(i, " | ") : ""], " ");
  },
  EnumTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.values;
    return z(["extend enum", r, z(n, " "), Se(i)], " ");
  },
  InputObjectTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.fields;
    return z(["extend input", r, z(n, " "), Se(i)], " ");
  }
};
function ke(e) {
  return function(t) {
    return z([t.description, e(t)], `
`);
  };
}
function z(e) {
  var t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e == null ? void 0 : e.filter(function(n) {
    return n;
  }).join(r)) !== null && t !== void 0 ? t : "";
}
function Se(e) {
  return G(`{
`, ir(z(e, `
`)), `
}`);
}
function G(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + r : "";
}
function ir(e) {
  return G("  ", e.replace(/\n/g, `
  `));
}
function Qs(e) {
  return e.indexOf(`
`) !== -1;
}
function oi(e) {
  return e != null && e.some(Qs);
}
function ai(e) {
  return e.kind === K.FIELD || e.kind === K.FRAGMENT_SPREAD || e.kind === K.INLINE_FRAGMENT;
}
function Gt(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : Ws(r).every(function(n) {
    var i = n.directive, o = n.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = t && t[o.value.name.value], D(a !== void 0, 105, i.name.value)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function qt(e, t, r) {
  var n = new Set(e), i = n.size;
  return Te(t, {
    Directive: function(o) {
      if (n.delete(o.name.value) && (!r || !n.size))
        return wr;
    }
  }), r ? !n.size : n.size < i;
}
function Us(e) {
  return e && qt(["client", "export"], e, !0);
}
function Bs(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function Ws(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (Bs(r)) {
      var n = r.arguments, i = r.name.value;
      D(n && n.length === 1, 106, i);
      var o = n[0];
      D(o.name && o.name.value === "if", 107, i);
      var a = o.value;
      D(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 108, i), t.push({ directive: r, ifArgument: o });
    }
  }), t;
}
function Js(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(o) {
    var a = o.name;
    return a.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(o) {
    var a = o.name;
    return a.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === K.VARIABLE ? globalThis.__DEV__ !== !1 && D.warn(109) : i.value.kind !== K.STRING ? globalThis.__DEV__ !== !1 && D.warn(110) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && D.warn(111, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const Gs = () => /* @__PURE__ */ Object.create(null), { forEach: Ks, slice: si } = Array.prototype, { hasOwnProperty: Hs } = Object.prototype;
class Ne {
  constructor(t = !0, r = Gs) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return Ks.call(t, (n) => r = r.getChildTrie(n)), Hs.call(r, "data") ? r.data : r.data = this.makeData(si.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const o = r.mapFor(t[n], !1);
      r = o && o.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), o = i && i.get(n);
      o && (r = o.removeArray(si.call(t, 1)), !o.data && !o.weak && !(o.strong && o.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new Ne(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && Ys(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function Ys(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var Xs = Oe(function() {
  return navigator.product;
}) == "ReactNative", nt = typeof WeakMap == "function" && !(Xs && !global.HermesInternal), On = typeof WeakSet == "function", Do = typeof Symbol == "function" && typeof Symbol.for == "function", Er = Do && Symbol.asyncIterator;
Oe(function() {
  return window.document.createElement;
});
Oe(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function W(e) {
  return e !== null && typeof e == "object";
}
function eu(e, t) {
  var r = t, n = [];
  e.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw ve(
        112,
        o.operation,
        o.name ? " named '".concat(o.name.value, "'") : ""
      );
    o.kind === "FragmentDefinition" && n.push(o);
  }), typeof r > "u" && (D(n.length === 1, 113, n.length), r = n[0].name.value);
  var i = v(v({}, e), { definitions: se([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: r
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function St(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function kr(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return D(n, 114, r), n || null;
    }
    default:
      return null;
  }
}
function tu(e) {
  var t = !0;
  return Te(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return wr;
    }
  }), t;
}
function ru() {
}
class Yr {
  constructor(t = 1 / 0, r = ru) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function Xr() {
}
const nu = Xr, iu = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, ou = typeof WeakMap < "u" ? WeakMap : Map, au = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: Xr,
    unregister: Xr
  };
}, su = 10024;
class fr {
  constructor(t = 1 / 0, r = nu) {
    this.max = t, this.dispose = r, this.map = new ou(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < su; i++) {
        const o = n.next().value;
        if (!o)
          break;
        this.unfinalizedNodes.delete(o);
        const a = o.key;
        delete o.key, o.keyRef = new iu(a), this.registry.register(a, o, o);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new au(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var Fr = /* @__PURE__ */ new WeakSet();
function Io(e) {
  e.size <= (e.max || -1) || Fr.has(e) || (Fr.add(e), setTimeout(function() {
    e.clean(), Fr.delete(e);
  }, 100));
}
var zo = function(e, t) {
  var r = new fr(e, t);
  return r.set = function(n, i) {
    var o = fr.prototype.set.call(this, n, i);
    return Io(this), o;
  }, r;
}, uu = function(e, t) {
  var r = new Yr(e, t);
  return r.set = function(n, i) {
    var o = Yr.prototype.set.call(this, n, i);
    return Io(this), o;
  }, r;
}, cu = Symbol.for("apollo.cacheSize"), Fe = v({}, lr[cu]), Ke = {};
function Ro(e, t) {
  Ke[e] = t;
}
var lu = globalThis.__DEV__ !== !1 ? pu : void 0, fu = globalThis.__DEV__ !== !1 ? vu : void 0, hu = globalThis.__DEV__ !== !1 ? Po : void 0;
function du() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      Fe[r] || n
    ];
  }));
}
function pu() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: du(),
    sizes: v({ print: (e = Ke.print) === null || e === void 0 ? void 0 : e.call(Ke), parser: (t = Ke.parser) === null || t === void 0 ? void 0 : t.call(Ke), canonicalStringify: (r = Ke.canonicalStringify) === null || r === void 0 ? void 0 : r.call(Ke), links: tn(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: Co(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function Po() {
  return {
    cache: {
      fragmentQueryDocuments: je(this.getFragmentDoc)
    }
  };
}
function vu() {
  var e = this.config.fragments;
  return v(v({}, Po.apply(this)), { addTypenameDocumentTransform: Co(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: je(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: je(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: je(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: je(e == null ? void 0 : e.findFragmentSpreads),
    lookup: je(e == null ? void 0 : e.lookup),
    transform: je(e == null ? void 0 : e.transform)
  } });
}
function mu(e) {
  return !!e && "dirtyKey" in e;
}
function je(e) {
  return mu(e) ? e.size : void 0;
}
function Fo(e) {
  return e != null;
}
function Co(e) {
  return en(e).map(function(t) {
    return { cache: t };
  });
}
function en(e) {
  return e ? se(se([
    je(e == null ? void 0 : e.performWork)
  ], en(e == null ? void 0 : e.left), !0), en(e == null ? void 0 : e.right), !0).filter(Fo) : [];
}
function tn(e) {
  var t;
  return e ? se(se([
    (t = e == null ? void 0 : e.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], tn(e == null ? void 0 : e.left), !0), tn(e == null ? void 0 : e.right), !0).filter(Fo) : [];
}
var Ve = Object.assign(function(t) {
  return JSON.stringify(t, yu);
}, {
  reset: function() {
    ct = new uu(
      Fe.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && Ro("canonicalStringify", function() {
  return ct.size;
});
var ct;
Ve.reset();
function yu(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(gu))
        return t;
      var i = JSON.stringify(n), o = ct.get(i);
      if (!o) {
        n.sort();
        var a = JSON.stringify(n);
        o = ct.get(a) || n, ct.set(i, o), ct.set(a, o);
      }
      var s = Object.create(r);
      return o.forEach(function(u) {
        s[u] = t[u];
      }), s;
    }
  }
  return t;
}
function gu(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function pt(e) {
  return { __ref: String(e) };
}
function q(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function bu(e) {
  return W(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function _u(e) {
  return e.kind === "StringValue";
}
function wu(e) {
  return e.kind === "BooleanValue";
}
function Eu(e) {
  return e.kind === "IntValue";
}
function ku(e) {
  return e.kind === "FloatValue";
}
function Su(e) {
  return e.kind === "Variable";
}
function Ou(e) {
  return e.kind === "ObjectValue";
}
function Tu(e) {
  return e.kind === "ListValue";
}
function Du(e) {
  return e.kind === "EnumValue";
}
function Iu(e) {
  return e.kind === "NullValue";
}
function bt(e, t, r, n) {
  if (Eu(r) || ku(r))
    e[t.value] = Number(r.value);
  else if (wu(r) || _u(r))
    e[t.value] = r.value;
  else if (Ou(r)) {
    var i = {};
    r.fields.map(function(a) {
      return bt(i, a.name, a.value, n);
    }), e[t.value] = i;
  } else if (Su(r)) {
    var o = (n || {})[r.name.value];
    e[t.value] = o;
  } else if (Tu(r))
    e[t.value] = r.values.map(function(a) {
      var s = {};
      return bt(s, t, a, n), s[t.value];
    });
  else if (Du(r))
    e[t.value] = r.value;
  else if (Iu(r))
    e[t.value] = null;
  else
    throw ve(123, t.value, r.kind);
}
function zu(e, t) {
  var r = null;
  e.directives && (r = {}, e.directives.forEach(function(i) {
    r[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return bt(r[i.name.value], a, s, t);
    });
  }));
  var n = null;
  return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return bt(n, o, a, t);
  })), No(e.name.value, n, r);
}
var Ru = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Rt = Ve, No = Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(Rt(i), ")");
    } else
      return r.connection.key;
  var o = e;
  if (t) {
    var a = Rt(t);
    o += "(".concat(a, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    Ru.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? o += "@".concat(s, "(").concat(Rt(r[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(e) {
    var t = Rt;
    return Rt = e, t;
  }
});
function Sr(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, o = n.value;
      return bt(r, i, o, t);
    }), r;
  }
  return null;
}
function Ce(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function rn(e, t, r) {
  for (var n, i = 0, o = t.selections; i < o.length; i++) {
    var a = o[i];
    if (qe(a)) {
      if (a.name.value === "__typename")
        return e[Ce(a)];
    } else n ? n.push(a) : n = [a];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (n)
    for (var s = 0, u = n; s < u.length; s++) {
      var a = u[s], c = rn(e, kr(a, r).selectionSet, r);
      if (typeof c == "string")
        return c;
    }
}
function qe(e) {
  return e.kind === "Field";
}
function Pu(e) {
  return e.kind === "InlineFragment";
}
function Ot(e) {
  D(e && e.kind === "Document", 115);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw ve(116, r.kind);
    return r;
  });
  return D(t.length <= 1, 117, t.length), e;
}
function et(e) {
  return Ot(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function At(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function Tt(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function Ao(e) {
  var t = et(e);
  return D(t && t.operation === "query", 118), t;
}
function xo(e) {
  D(e.kind === "Document", 119), D(e.definitions.length <= 1, 120);
  var t = e.definitions[0];
  return D(t.kind === "FragmentDefinition", 121), t;
}
function Dt(e) {
  Ot(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw ve(122);
}
function Tn(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && bt(t, n.variable.name, n.defaultValue);
  }), t;
}
let ae = null;
const ui = {};
let Fu = 1;
const Cu = () => class {
  constructor() {
    this.id = [
      "slot",
      Fu++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let t = ae; t; t = t.parent)
      if (this.id in t.slots) {
        const r = t.slots[this.id];
        if (r === ui)
          break;
        return t !== ae && (ae.slots[this.id] = r), !0;
      }
    return ae && (ae.slots[this.id] = ui), !1;
  }
  getValue() {
    if (this.hasValue())
      return ae.slots[this.id];
  }
  withValue(t, r, n, i) {
    const o = {
      __proto__: null,
      [this.id]: t
    }, a = ae;
    ae = { parent: a, slots: o };
    try {
      return r.apply(i, n);
    } finally {
      ae = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(t) {
    const r = ae;
    return function() {
      const n = ae;
      try {
        return ae = r, t.apply(this, arguments);
      } finally {
        ae = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(t, r, n) {
    if (ae) {
      const i = ae;
      try {
        return ae = null, t.apply(n, r);
      } finally {
        ae = i;
      }
    } else
      return t.apply(n, r);
  }
};
function ci(e) {
  try {
    return e();
  } catch {
  }
}
const Cr = "@wry/context:Slot", Nu = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  ci(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  ci(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), li = Nu, It = li[Cr] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Cr] || (function(e) {
  try {
    Object.defineProperty(li, Cr, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(Cu()), { bind: Mm, noContext: jm } = It, Or = new It(), { hasOwnProperty: Au } = Object.prototype, Dn = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function In(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const Zt = [], xu = 100;
function _t(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function Mo(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function jo(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function $o(e) {
  return e.slice(0);
}
class Tr {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Tr.count;
  }
  peek() {
    if (this.value.length === 1 && !Ze(this))
      return fi(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return _t(!this.recomputing, "already recomputing"), fi(this), Ze(this) ? Mu(this, t) : jo(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, Lo(this), In(this));
  }
  dispose() {
    this.setDirty(), Uo(this), zn(this, (t, r) => {
      t.setDirty(), Bo(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = Zt.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (Dn(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Zt.push(this.deps), this.deps = null);
  }
}
Tr.count = 0;
function fi(e) {
  const t = Or.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Ze(e) ? qo(t, e) : Zo(t, e), t;
}
function Mu(e, t) {
  return Uo(e), Or.withValue(e, ju, [e, t]), Lu(e, t) && $u(e), jo(e.value);
}
function ju(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = $o(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !Mo(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Ze(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function $u(e) {
  e.dirty = !1, !Ze(e) && Vo(e);
}
function Lo(e) {
  zn(e, qo);
}
function Vo(e) {
  zn(e, Zo);
}
function zn(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = Dn(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function qo(e, t) {
  _t(e.childValues.has(t)), _t(Ze(t));
  const r = !Ze(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = Zt.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && Lo(e);
}
function Zo(e, t) {
  _t(e.childValues.has(t)), _t(!Ze(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, $o(t.value)) : Mo(r, t.value) || e.setDirty(), Qo(e, t), !Ze(e) && Vo(e);
}
function Qo(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (Zt.length < xu && Zt.push(r), e.dirtyChildren = null));
}
function Uo(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    Bo(e, r);
  }), e.forgetDeps(), _t(e.dirtyChildren === null);
}
function Bo(e, t) {
  t.parents.delete(e), e.childValues.delete(t), Qo(e, t);
}
function Lu(e, t) {
  if (typeof e.subscribe == "function")
    try {
      In(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const Vu = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function Wo(e) {
  const t = /* @__PURE__ */ new Map();
  function r(n) {
    const i = Or.getValue();
    if (i) {
      let o = t.get(n);
      o || t.set(n, o = /* @__PURE__ */ new Set()), i.dependOn(o);
    }
  }
  return r.dirty = function(i, o) {
    const a = t.get(i);
    if (a) {
      const s = o && Au.call(Vu, o) ? o : "setDirty";
      Dn(a).forEach((u) => u[s]()), t.delete(i), In(a);
    }
  }, r;
}
let hi;
function qu(...e) {
  return (hi || (hi = new Ne(typeof WeakMap == "function"))).lookupArray(e);
}
const Nr = /* @__PURE__ */ new Set();
function Qt(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = qu, normalizeResult: i, subscribe: o, cache: a = Yr } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof a == "function" ? new a(t, (d) => d.dispose()) : a, u = function() {
    const d = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (d === void 0)
      return e.apply(null, arguments);
    let f = s.get(d);
    f || (s.set(d, f = new Tr(e)), f.normalizeResult = i, f.subscribe = o, f.forget = () => s.delete(d));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(d, f), Nr.add(s), Or.hasValue() || (Nr.forEach((m) => m.clean()), Nr.clear()), p;
  };
  Object.defineProperty(u, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(u.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: o,
    cache: s
  });
  function c(d) {
    const f = d && s.get(d);
    f && f.setDirty();
  }
  u.dirtyKey = c, u.dirty = function() {
    c(n.apply(null, arguments));
  };
  function l(d) {
    const f = d && s.get(d);
    if (f)
      return f.peek();
  }
  u.peekKey = l, u.peek = function() {
    return l(n.apply(null, arguments));
  };
  function h(d) {
    return d ? s.delete(d) : !1;
  }
  return u.forgetKey = h, u.forget = function() {
    return h(n.apply(null, arguments));
  }, u.makeCacheKey = n, u.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(u);
}
function Zu(e) {
  return e;
}
var Jo = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = On ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(Zu, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var o = t(i) ? r : n;
          return o.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new Ne(nt);
        this.performWork = Qt(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return D(Array.isArray(i), 104), r.lookupArray(i);
          },
          max: Fe["documentTransform.cache"],
          cache: fr
        });
      }
    }, e.prototype.performWork = function(t) {
      return Ot(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), jt, Le = Object.assign(function(e) {
  var t = jt.get(e);
  return t || (t = Vs(e), jt.set(e, t)), t;
}, {
  reset: function() {
    jt = new zo(
      Fe.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Le.reset();
globalThis.__DEV__ !== !1 && Ro("print", function() {
  return jt ? jt.size : 0;
});
var X = Array.isArray;
function Ie(e) {
  return Array.isArray(e) && e.length > 0;
}
var di = {
  kind: K.FIELD,
  name: {
    kind: K.NAME,
    value: "__typename"
  }
};
function Go(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === K.FRAGMENT_SPREAD && Go(t[r.name.value], t);
  });
}
function Qu(e) {
  return Go(et(e) || xo(e), St(Tt(e))) ? null : e;
}
function Uu(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(o, a) {
      a(n) && (i = o);
    }), i;
  };
}
function pi(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var i = t.get(n);
    return i || t.set(n, i = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function Ko(e, t) {
  Ot(t);
  for (var r = pi(""), n = pi(""), i = function(y) {
    for (var _ = 0, w = void 0; _ < y.length && (w = y[_]); ++_)
      if (!X(w)) {
        if (w.kind === K.OPERATION_DEFINITION)
          return r(w.name && w.name.value);
        if (w.kind === K.FRAGMENT_DEFINITION)
          return n(w.name.value);
      }
    return globalThis.__DEV__ !== !1 && D.error(124), null;
  }, o = 0, a = t.definitions.length - 1; a >= 0; --a)
    t.definitions[a].kind === K.OPERATION_DEFINITION && ++o;
  var s = Uu(e), u = function(y) {
    return Ie(y) && y.map(s).some(function(_) {
      return _ && _.remove;
    });
  }, c = /* @__PURE__ */ new Map(), l = !1, h = {
    enter: function(y) {
      if (u(y.directives))
        return l = !0, null;
    }
  }, d = Te(t, {
    // These two AST node types share the same implementation, defined above.
    Field: h,
    InlineFragment: h,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(y, _, w, S, O) {
        var T = i(O);
        T && T.variables.add(y.name.value);
      }
    },
    FragmentSpread: {
      enter: function(y, _, w, S, O) {
        if (u(y.directives))
          return l = !0, null;
        var T = i(O);
        T && T.fragmentSpreads.add(y.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(y, _, w, S) {
        c.set(JSON.stringify(S), y);
      },
      leave: function(y, _, w, S) {
        var O = c.get(JSON.stringify(S));
        if (y === O)
          return y;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          o > 0 && y.selectionSet.selections.every(function(T) {
            return T.kind === K.FIELD && T.name.value === "__typename";
          })
        )
          return n(y.name.value).removed = !0, l = !0, null;
      }
    },
    Directive: {
      leave: function(y) {
        if (s(y))
          return l = !0, null;
      }
    }
  });
  if (!l)
    return t;
  var f = function(y) {
    return y.transitiveVars || (y.transitiveVars = new Set(y.variables), y.removed || y.fragmentSpreads.forEach(function(_) {
      f(n(_)).transitiveVars.forEach(function(w) {
        y.transitiveVars.add(w);
      });
    })), y;
  }, p = /* @__PURE__ */ new Set();
  d.definitions.forEach(function(y) {
    y.kind === K.OPERATION_DEFINITION ? f(r(y.name && y.name.value)).fragmentSpreads.forEach(function(_) {
      p.add(_);
    }) : y.kind === K.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    o === 0 && !n(y.name.value).removed && p.add(y.name.value);
  }), p.forEach(function(y) {
    f(n(y)).fragmentSpreads.forEach(function(_) {
      p.add(_);
    });
  });
  var m = function(y) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(y) || n(y).removed);
  }, g = {
    enter: function(y) {
      if (m(y.name.value))
        return null;
    }
  };
  return Qu(Te(d, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: g,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: g,
    OperationDefinition: {
      leave: function(y) {
        if (y.variableDefinitions) {
          var _ = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(y.name && y.name.value)
          ).transitiveVars;
          if (_.size < y.variableDefinitions.length)
            return v(v({}, y), { variableDefinitions: y.variableDefinitions.filter(function(w) {
              return _.has(w.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var Rn = Object.assign(function(e) {
  return Te(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === K.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var o = i.some(function(s) {
              return qe(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = n;
              if (!(qe(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return v(v({}, t), { selections: se(se([], i, !0), [di], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === di;
  }
});
function Bu(e) {
  var t = Dt(e), r = t.operation;
  if (r === "query")
    return e;
  var n = Te(e, {
    OperationDefinition: {
      enter: function(i) {
        return v(v({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function Ho(e) {
  Ot(e);
  var t = Ko([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function Wu(e) {
  return Ot(e), Te(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return v(v({}, t), { directives: se(se([], t.directives || [], !0), [
          {
            kind: K.DIRECTIVE,
            name: { kind: K.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var Ju = Object.prototype.hasOwnProperty;
function vi() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Dr(e);
}
function Dr(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new Qe(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var Gu = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, Qe = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = Gu), this.reconciler = t, this.isObject = W, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], o = 2; o < arguments.length; o++)
        i[o - 2] = arguments[o];
      return W(r) && W(t) ? (Object.keys(r).forEach(function(a) {
        if (Ju.call(t, a)) {
          var s = t[a];
          if (r[a] !== s) {
            var u = n.reconciler.apply(n, se([
              t,
              r,
              a
            ], i, !1));
            u !== s && (t = n.shallowCopyForMerge(t), t[a] = u);
          }
        } else
          t = n.shallowCopyForMerge(t), t[a] = r[a];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return W(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = v({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function Ku(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Hu(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hu(e, t) {
  if (e) {
    if (typeof e == "string") return mi(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mi(e, t);
  }
}
function mi(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function yi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Pn(e, t, r) {
  return t && yi(e.prototype, t), r && yi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Fn = function() {
  return typeof Symbol == "function";
}, Cn = function(e) {
  return Fn() && !!Symbol[e];
}, Nn = function(e) {
  return Cn(e) ? Symbol[e] : "@@" + e;
};
Fn() && !Cn("observable") && (Symbol.observable = Symbol("observable"));
var Yu = Nn("iterator"), nn = Nn("observable"), Yo = Nn("species");
function hr(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function Pt(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[Yo], t === null && (t = void 0)), t !== void 0 ? t : Q;
}
function Xu(e) {
  return e instanceof Q;
}
function wt(e) {
  wt.log ? wt.log(e) : setTimeout(function() {
    throw e;
  });
}
function or(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      wt(t);
    }
  });
}
function Xo(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = hr(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      wt(n);
    }
}
function on(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function ec(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (ea(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function ea(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = hr(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (on(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        on(e), i && i.call(n);
        break;
    }
  } catch (o) {
    wt(o);
  }
  e._state === "closed" ? Xo(e) : e._state === "running" && (e._state = "ready");
}
function Ar(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], or(function() {
        return ec(e);
      });
      return;
    }
    ea(e, t, r);
  }
}
var tc = /* @__PURE__ */ (function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new rc(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (on(this), Xo(this));
  }, Pn(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), rc = /* @__PURE__ */ (function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(n) {
    Ar(this._subscription, "next", n);
  }, t.error = function(n) {
    Ar(this._subscription, "error", n);
  }, t.complete = function() {
    Ar(this._subscription, "complete");
  }, Pn(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), Q = /* @__PURE__ */ (function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new tc(n, this._subscriber);
  }, t.forEach = function(n) {
    var i = this;
    return new Promise(function(o, a) {
      if (typeof n != "function") {
        a(new TypeError(n + " is not a function"));
        return;
      }
      function s() {
        u.unsubscribe(), o();
      }
      var u = i.subscribe({
        next: function(c) {
          try {
            n(c, s);
          } catch (l) {
            a(l), u.unsubscribe();
          }
        },
        error: a,
        complete: o
      });
    });
  }, t.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Pt(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            s = n(s);
          } catch (u) {
            return a.error(u);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Pt(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            if (!n(s)) return;
          } catch (u) {
            return a.error(u);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Pt(this), a = arguments.length > 1, s = !1, u = arguments[1], c = u;
    return new o(function(l) {
      return i.subscribe({
        next: function(h) {
          var d = !s;
          if (s = !0, !d || a)
            try {
              c = n(c, h);
            } catch (f) {
              return l.error(f);
            }
          else
            c = h;
        },
        error: function(h) {
          l.error(h);
        },
        complete: function() {
          if (!s && !a) return l.error(new TypeError("Cannot reduce an empty sequence"));
          l.next(c), l.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    var s = Pt(this);
    return new s(function(u) {
      var c, l = 0;
      function h(d) {
        c = d.subscribe({
          next: function(f) {
            u.next(f);
          },
          error: function(f) {
            u.error(f);
          },
          complete: function() {
            l === o.length ? (c = void 0, u.complete()) : h(s.from(o[l++]));
          }
        });
      }
      return h(n), function() {
        c && (c.unsubscribe(), c = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Pt(this);
    return new o(function(a) {
      var s = [], u = i.subscribe({
        next: function(l) {
          if (n)
            try {
              l = n(l);
            } catch (d) {
              return a.error(d);
            }
          var h = o.from(l).subscribe({
            next: function(d) {
              a.next(d);
            },
            error: function(d) {
              a.error(d);
            },
            complete: function() {
              var d = s.indexOf(h);
              d >= 0 && s.splice(d, 1), c();
            }
          });
          s.push(h);
        },
        error: function(l) {
          a.error(l);
        },
        complete: function() {
          c();
        }
      });
      function c() {
        u.closed && s.length === 0 && a.complete();
      }
      return function() {
        s.forEach(function(l) {
          return l.unsubscribe();
        }), u.unsubscribe();
      };
    });
  }, t[nn] = function() {
    return this;
  }, e.from = function(n) {
    var i = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var o = hr(n, nn);
    if (o) {
      var a = o.call(n);
      if (Object(a) !== a) throw new TypeError(a + " is not an object");
      return Xu(a) && a.constructor === i ? a : new i(function(s) {
        return a.subscribe(s);
      });
    }
    if (Cn("iterator") && (o = hr(n, Yu), o))
      return new i(function(s) {
        or(function() {
          if (!s.closed) {
            for (var u = Ku(o.call(n)), c; !(c = u()).done; ) {
              var l = c.value;
              if (s.next(l), s.closed) return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(s) {
        or(function() {
          if (!s.closed) {
            for (var u = 0; u < n.length; ++u)
              if (s.next(n[u]), s.closed) return;
            s.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    var a = typeof this == "function" ? this : e;
    return new a(function(s) {
      or(function() {
        if (!s.closed) {
          for (var u = 0; u < i.length; ++u)
            if (s.next(i[u]), s.closed) return;
          s.complete();
        }
      });
    });
  }, Pn(e, null, [{
    key: Yo,
    get: function() {
      return this;
    }
  }]), e;
})();
Fn() && Object.defineProperty(Q, Symbol("extensions"), {
  value: {
    symbol: nn,
    hostReportError: wt
  },
  configurable: !0
});
function nc(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var st;
typeof self < "u" ? st = self : typeof window < "u" ? st = window : typeof global < "u" ? st = global : typeof module < "u" ? st = module : st = Function("return this")();
nc(st);
var gi = Q.prototype, bi = "@@observable";
gi[bi] || (gi[bi] = function() {
  return this;
});
function ic(e) {
  return e.catch(function() {
  }), e;
}
var oc = Object.prototype.toString;
function ta(e) {
  return an(e);
}
function an(e, t) {
  switch (oc.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, o) {
        r[o] = an(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = an(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function ac(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    W(r) && sc(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      W(r[n]) && t.add(r[n]);
    });
  }), e;
}
function sc(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function dr(e) {
  return globalThis.__DEV__ !== !1 && ac(e), e;
}
function $t(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function xr(e, t, r) {
  return new Q(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(u) {
        return new Promise(function(c) {
          return c(u());
        });
      }
    };
    function o(u, c) {
      return function(l) {
        if (u) {
          var h = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : u(l);
          };
          i = i.then(h, h).then(function(d) {
            return n.next(d);
          }, function(d) {
            return n.error(d);
          });
        } else
          n[c](l);
      };
    }
    var a = {
      next: o(t, "next"),
      error: o(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(a);
    return function() {
      return s.unsubscribe();
    };
  });
}
function ra(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Q });
  }
  return Do && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function _i(e) {
  return e && typeof e.then == "function";
}
var ut = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, o) {
        n.resolve = i, n.reject = o;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), $t(n.observers, "next", i));
        },
        error: function(i) {
          var o = n.sub;
          o !== null && (o && setTimeout(function() {
            return o.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), $t(n.observers, "error", i));
        },
        complete: function() {
          var i = n, o = i.sub, a = i.sources, s = a === void 0 ? [] : a;
          if (o !== null) {
            var u = s.shift();
            u ? _i(u) ? u.then(function(c) {
              return n.sub = c.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = u.subscribe(n.handlers) : (o && setTimeout(function() {
              return o.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), $t(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new Q(r)]), _i(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
        return o(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, o) {
        n || (n = !0, r(i, o));
      });
    }, t;
  })(Q)
);
ra(ut);
function vt(e) {
  return "incremental" in e;
}
function uc(e) {
  return "hasNext" in e && "data" in e;
}
function cc(e) {
  return vt(e) || uc(e);
}
function lc(e) {
  return W(e) && "payload" in e;
}
function na(e, t) {
  var r = e, n = new Qe();
  return vt(t) && Ie(t.incremental) && t.incremental.forEach(function(i) {
    for (var o = i.data, a = i.path, s = a.length - 1; s >= 0; --s) {
      var u = a[s], c = !isNaN(+u), l = c ? [] : {};
      l[u] = o, o = l;
    }
    r = n.merge(r, o);
  }), r;
}
function ar(e) {
  var t = sn(e);
  return Ie(t);
}
function sn(e) {
  var t = Ie(e.errors) ? e.errors.slice(0) : [];
  return vt(e) && Ie(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function Et() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var o = n[i];
      o !== void 0 && (r[i] = o);
    });
  }), r;
}
function Mr(e, t) {
  return Et(e, t, t.variables && {
    variables: Et(v(v({}, e && e.variables), t.variables))
  });
}
var jr, fc = Symbol.for("apollo.deprecations"), wi = Symbol.for("apollo.deprecations.slot"), un = lr, cn = (jr = un[wi]) !== null && jr !== void 0 ? jr : un[wi] = new It();
function hc(e) {
  return un[fc] || (cn.getValue() || []).includes(e);
}
function fe(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return cn.withValue.apply(cn, se([Array.isArray(e) ? e : [e]], t, !1));
}
function re(e, t, r, n) {
  n === void 0 && (n = "Please remove this option."), Xe(t, function() {
    t in e && globalThis.__DEV__ !== !1 && D.warn(103, r, t, n);
  });
}
function Xe(e, t) {
  hc(e) || t();
}
function $r(e) {
  return new Q(function(t) {
    t.error(e);
  });
}
var ia = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function dc(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw ve(58, i);
  }
  return e;
}
function pc(e, t) {
  var r = v({}, e), n = function(o) {
    typeof o == "function" ? r = v(v({}, r), o(r)) : r = v(v({}, r), o);
  }, i = function() {
    return v({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function vc(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? At(t.query) || void 0 : ""), t;
}
function mc(e, t) {
  var r = v({}, e), n = new Set(Object.keys(e));
  return Te(t, {
    Variable: function(i, o, a) {
      a && a.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
function Ei(e, t) {
  return t ? t(e) : Q.of();
}
function Ft(e) {
  return typeof e == "function" ? new Be(e) : e;
}
function Xt(e) {
  return e.request.length <= 1;
}
var Be = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Q.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(Ft).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = Ft(r), o = Ft(n || new e(Ei)), a;
      return Xt(i) && Xt(o) ? a = new e(function(s) {
        return t(s) ? i.request(s) || Q.of() : o.request(s) || Q.of();
      }) : a = new e(function(s, u) {
        return t(s) ? i.request(s, u) || Q.of() : o.request(s, u) || Q.of();
      }), Object.assign(a, { left: i, right: o });
    }, e.execute = function(t, r) {
      return t.request(pc(r.context, vc(dc(r)))) || Q.of();
    }, e.concat = function(t, r) {
      var n = Ft(t);
      if (Xt(n))
        return globalThis.__DEV__ !== !1 && D.warn(47, n), n;
      var i = Ft(r), o;
      return Xt(i) ? o = new e(function(a) {
        return n.request(a, function(s) {
          return i.request(s) || Q.of();
        }) || Q.of();
      }) : o = new e(function(a, s) {
        return n.request(a, function(u) {
          return i.request(u, s) || Q.of();
        }) || Q.of();
      }), Object.assign(o, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(Ei)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw ve(48);
    }, e.prototype.onError = function(t, r) {
      if (globalThis.__DEV__ !== !1 && Xe("onError", function() {
        globalThis.__DEV__ !== !1 && D.warn(49);
      }), r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && D.warn(50), this.onError = t, this;
    }, e;
  })()
), yc = Be.from, gc = Be.split, ln = Be.execute;
function bc(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function _c(e) {
  var t = null, r = null, n = !1, i = [], o = [];
  function a(h) {
    if (!r) {
      if (o.length) {
        var d = o.shift();
        if (Array.isArray(d) && d[0])
          return d[0]({ value: h, done: !1 });
      }
      i.push(h);
    }
  }
  function s(h) {
    r = h;
    var d = o.slice();
    d.forEach(function(f) {
      f[1](h);
    }), !t || t();
  }
  function u() {
    n = !0;
    var h = o.slice();
    h.forEach(function(d) {
      d[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", a), e.removeListener("error", s), e.removeListener("end", u), e.removeListener("finish", u), e.removeListener("close", u);
  }, e.on("data", a), e.on("error", s), e.on("end", u), e.on("finish", u), e.on("close", u);
  function c() {
    return new Promise(function(h, d) {
      if (r)
        return d(r);
      if (i.length)
        return h({ value: i.shift(), done: !1 });
      if (n)
        return h({ value: void 0, done: !0 });
      o.push([h, d]);
    });
  }
  var l = {
    next: function() {
      return c();
    }
  };
  return Er && (l[Symbol.asyncIterator] = function() {
    return this;
  }), l;
}
function wc(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(o) {
          n({ value: o, done: !1 });
        }).catch(i);
      }));
    }
  };
  return Er && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function ki(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return Er && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function Ec(e) {
  return !!e.body;
}
function kc(e) {
  return !!e.getReader;
}
function Sc(e) {
  return !!(Er && e[Symbol.asyncIterator]);
}
function Oc(e) {
  return !!e.stream;
}
function Tc(e) {
  return !!e.arrayBuffer;
}
function Dc(e) {
  return !!e.pipe;
}
function Ic(e) {
  var t = e;
  if (Ec(e) && (t = e.body), Sc(t))
    return bc(t);
  if (kc(t))
    return ki(t.getReader());
  if (Oc(t))
    return ki(t.stream().getReader());
  if (Tc(t))
    return wc(t.arrayBuffer());
  if (Dc(t))
    return _c(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var An = Symbol();
function zc(e) {
  return e.extensions ? Array.isArray(e.extensions[An]) : !1;
}
function oa(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var Rc = function(e) {
  var t = se(se(se([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return W(r) && r.message || "Error message not found.";
  }).join(`
`);
}, $e = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, o = r.clientErrors, a = r.networkError, s = r.errorMessage, u = r.extraInfo, c = e.call(this, s) || this;
      return c.name = "ApolloError", c.graphQLErrors = n || [], c.protocolErrors = i || [], c.clientErrors = o || [], c.networkError = a || null, c.message = s || Rc(c), c.extraInfo = u, c.cause = se(se(se([
        a
      ], n || [], !0), i || [], !0), o || [], !0).find(function(l) {
        return !!l;
      }) || null, c.__proto__ = t.prototype, c;
    }
    return t;
  })(Error)
), Si = Object.prototype.hasOwnProperty;
function Pc(e, t) {
  return xe(this, void 0, void 0, function() {
    var r, n, i, o, a, s, u, c, l, h, d, f, p, m, g, y, _, w, S, O, T, F, R, x;
    return Me(this, function(L) {
      switch (L.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (x = e.headers) === null || x === void 0 ? void 0 : x.get("content-type"), i = "boundary=", o = n != null && n.includes(i) ? n == null ? void 0 : n.substring((n == null ? void 0 : n.indexOf(i)) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", a = `\r
--`.concat(o), s = "", u = Ic(e), c = !0, L.label = 1;
        case 1:
          return c ? [4, u.next()] : [3, 3];
        case 2:
          for (l = L.sent(), h = l.value, d = l.done, f = typeof h == "string" ? h : r.decode(h), p = s.length - a.length + 1, c = !d, s += f, m = s.indexOf(a, p); m > -1; ) {
            if (g = void 0, F = [
              s.slice(0, m),
              s.slice(m + a.length)
            ], g = F[0], s = F[1], y = g.indexOf(`\r
\r
`), _ = Fc(g.slice(0, y)), w = _["content-type"], w && w.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (S = g.slice(y), S) {
              if (O = aa(e, S), Object.keys(O).length > 1 || "data" in O || "incremental" in O || "errors" in O || "payload" in O)
                if (lc(O)) {
                  if (T = {}, "payload" in O) {
                    if (Object.keys(O).length === 1 && O.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    T = v({}, O.payload);
                  }
                  "errors" in O && (T = v(v({}, T), { extensions: v(v({}, "extensions" in T ? T.extensions : null), (R = {}, R[An] = O.errors, R)) })), t(T);
                } else
                  t(O);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(O).length === 1 && "hasNext" in O && !O.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            m = s.indexOf(a);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Fc(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), o = r.slice(n + 1).trim();
      t[i] = o;
    }
  }), t;
}
function aa(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    ia(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function Cc(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function Nc(e) {
  return function(t) {
    return t.text().then(function(r) {
      return aa(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !Si.call(r, "data") && !Si.call(r, "errors") && ia(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var fn = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = ve(54, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, Ac = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, xc = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, Mc = {
  method: "POST"
}, jc = {
  http: Ac,
  headers: xc,
  options: Mc
}, $c = function(e, t) {
  return t(e);
};
function Lc(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, o = {};
  r.forEach(function(h) {
    i = v(v(v({}, i), h.options), { headers: v(v({}, i.headers), h.headers) }), h.credentials && (i.credentials = h.credentials), o = v(v({}, o), h.http);
  }), i.headers && (i.headers = Vc(i.headers, o.preserveHeaderCase));
  var a = e.operationName, s = e.extensions, u = e.variables, c = e.query, l = { operationName: a, variables: u };
  return o.includeExtensions && (l.extensions = s), o.includeQuery && (l.query = t(c, Le)), {
    options: i,
    body: l
  };
}
function Vc(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(o) {
      r[o.toLowerCase()] = e[o];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(o) {
    n[o.toLowerCase()] = {
      originalName: o,
      value: e[o]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(o) {
    i[n[o].originalName] = n[o].value;
  }), i;
}
var qc = function(e) {
  if (!e && typeof fetch > "u")
    throw ve(51);
}, Zc = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function Qc(e, t) {
  var r = [], n = function(h, d) {
    r.push("".concat(h, "=").concat(encodeURIComponent(d)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = fn(t.variables, "Variables map");
    } catch (h) {
      return { parseError: h };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var o = void 0;
    try {
      o = fn(t.extensions, "Extensions map");
    } catch (h) {
      return { parseError: h };
    }
    n("extensions", o);
  }
  var a = "", s = e, u = e.indexOf("#");
  u !== -1 && (a = e.substr(u), s = e.substr(0, u));
  var c = s.indexOf("?") === -1 ? "?" : "&", l = s + c + r.join("&") + a;
  return { newURI: l };
}
var Oi = Oe(function() {
  return fetch;
}), Uc = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, o = i === void 0 ? $c : i, a = e.includeExtensions, s = e.preserveHeaderCase, u = e.useGETForQueries, c = e.includeUnusedVariables, l = c === void 0 ? !1 : c, h = Pe(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && qc(n || Oi);
  var d = {
    http: { includeExtensions: a, preserveHeaderCase: s },
    options: h.fetchOptions,
    credentials: h.credentials,
    headers: h.headers
  };
  return new Be(function(f) {
    var p = Zc(f, r), m = f.getContext(), g = {};
    if (m.clientAwareness) {
      var y = m.clientAwareness, _ = y.name, w = y.version;
      _ && (g["apollographql-client-name"] = _), w && (g["apollographql-client-version"] = w);
    }
    var S = v(v({}, g), m.headers), O = {
      http: m.http,
      options: m.fetchOptions,
      credentials: m.credentials,
      headers: S
    };
    if (qt(["client"], f.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && D.warn(52);
      var T = Ho(f.query);
      if (!T)
        return $r(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = T;
    }
    var F = Lc(f, o, jc, d, O), R = F.options, x = F.body;
    x.variables && !l && (x.variables = mc(x.variables, f.query));
    var L;
    !R.signal && typeof AbortController < "u" && (L = new AbortController(), R.signal = L.signal);
    var Ee = function(A) {
      return A.kind === "OperationDefinition" && A.operation === "mutation";
    }, ye = function(A) {
      return A.kind === "OperationDefinition" && A.operation === "subscription";
    }, Y = ye(Dt(f.query)), he = qt(["defer"], f.query);
    if (u && !f.query.definitions.some(Ee) && (R.method = "GET"), he || Y) {
      R.headers = R.headers || {};
      var N = "multipart/mixed;";
      Y && he && globalThis.__DEV__ !== !1 && D.warn(53), Y ? N += "boundary=graphql;subscriptionSpec=1.0,application/json" : he && (N += "deferSpec=20220824,application/json"), R.headers.accept = N;
    }
    if (R.method === "GET") {
      var U = Qc(p, x), C = U.newURI, M = U.parseError;
      if (M)
        return $r(M);
      p = C;
    } else
      try {
        R.body = fn(x, "Payload");
      } catch (A) {
        return $r(A);
      }
    return new Q(function(A) {
      var ce = n || Oe(function() {
        return fetch;
      }) || Oi, $ = A.next.bind(A);
      return ce(p, R).then(function(de) {
        var Re;
        f.setContext({ response: de });
        var Ge = (Re = de.headers) === null || Re === void 0 ? void 0 : Re.get("content-type");
        return Ge !== null && /^multipart\/mixed/i.test(Ge) ? Pc(de, $) : Nc(f)(de).then($);
      }).then(function() {
        L = void 0, A.complete();
      }).catch(function(de) {
        L = void 0, Cc(de, A);
      }), function() {
        L && L.abort();
      };
    });
  });
}, sa = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, Uc(r).request) || this;
      return n.options = r, n;
    }
    return t;
  })(Be)
);
const { toString: Ti, hasOwnProperty: Bc } = Object.prototype, Di = Function.prototype.toString, hn = /* @__PURE__ */ new Map();
function B(e, t) {
  try {
    return dn(e, t);
  } finally {
    hn.clear();
  }
}
function dn(e, t) {
  if (e === t)
    return !0;
  const r = Ti.call(e), n = Ti.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (zi(e, t))
        return !0;
      const i = Ii(e), o = Ii(t), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!Bc.call(t, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const u = i[s];
        if (!dn(e[u], t[u]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (zi(e, t))
        return !0;
      const i = e.entries(), o = r === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, u] = a.value;
        if (!t.has(s) || o && !dn(u, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = Di.call(e);
      return i !== Di.call(t) ? !1 : !Gc(i, Jc);
    }
  }
  return !1;
}
function Ii(e) {
  return Object.keys(e).filter(Wc, e);
}
function Wc(e) {
  return this[e] !== void 0;
}
const Jc = "{ [native code] }";
function Gc(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function zi(e, t) {
  let r = hn.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    hn.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function ua(e, t, r, n) {
  var i = t.data, o = Pe(t, ["data"]), a = r.data, s = Pe(r, ["data"]);
  return B(o, s) && sr(Dt(e).selectionSet, i, a, {
    fragmentMap: St(Tt(e)),
    variables: n
  });
}
function sr(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(o) {
    if (i.has(o) || (i.add(o), !Gt(o, n.variables)) || Ri(o))
      return !0;
    if (qe(o)) {
      var a = Ce(o), s = t && t[a], u = r && r[a], c = o.selectionSet;
      if (!c)
        return B(s, u);
      var l = Array.isArray(s), h = Array.isArray(u);
      if (l !== h)
        return !1;
      if (l && h) {
        var d = s.length;
        if (u.length !== d)
          return !1;
        for (var f = 0; f < d; ++f)
          if (!sr(c, s[f], u[f], n))
            return !1;
        return !0;
      }
      return sr(c, s, u, n);
    } else {
      var p = kr(o, n.fragmentMap);
      if (p)
        return Ri(p) ? !0 : sr(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function Ri(e) {
  return !!e.directives && e.directives.some(Kc);
}
function Kc(e) {
  return e.name.value === "nonreactive";
}
var ca = nt ? WeakMap : Map, la = On ? WeakSet : Set, xn = new It(), Pi = !1;
function fa() {
  Pi || (Pi = !0, globalThis.__DEV__ !== !1 && D.warn(64));
}
function ha(e, t, r) {
  return xn.withValue(!0, function() {
    var n = xt(e, t, r, !1);
    return Object.isFrozen(e) && dr(n), n;
  });
}
function Hc(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function xt(e, t, r, n, i) {
  var o, a = r.knownChanged, s = Hc(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var u = 0, c = Array.from(e.entries()); u < c.length; u++) {
      var l = c[u], h = l[0], d = l[1];
      if (d === null) {
        s[h] = null;
        continue;
      }
      var f = xt(d, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(h, "]") : void 0);
      a.has(f) && a.add(s), s[h] = f;
    }
    return a.has(s) ? s : e;
  }
  for (var p = 0, m = t.selections; p < m.length; p++) {
    var g = m[p], y = void 0;
    if (n && a.add(s), g.kind === K.FIELD) {
      var _ = Ce(g), w = g.selectionSet;
      if (y = s[_] || e[_], y === void 0)
        continue;
      if (w && y !== null) {
        var f = xt(e[_], w, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(_) : void 0);
        a.has(f) && (y = f);
      }
      globalThis.__DEV__ === !1 && (s[_] = y), globalThis.__DEV__ !== !1 && (n && _ !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((o = Object.getOwnPropertyDescriptor(s, _)) === null || o === void 0) && o.value) ? Object.defineProperty(s, _, Yc(_, y, i || "", r.operationName, r.operationType)) : (delete s[_], s[_] = y));
    }
    if (g.kind === K.INLINE_FRAGMENT && (!g.typeCondition || r.cache.fragmentMatches(g, e.__typename)) && (y = xt(e, g.selectionSet, r, n, i)), g.kind === K.FRAGMENT_SPREAD) {
      var S = g.name.value, O = r.fragmentMap[S] || (r.fragmentMap[S] = r.cache.lookupFragment(S));
      D(O, 59, S);
      var T = Js(g);
      T !== "mask" && (y = xt(e, O.selectionSet, r, T === "migrate", i));
    }
    a.has(y) && a.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && a.add(s), a.has(s) ? s : e;
}
function Yc(e, t, r, n, i) {
  var o = function() {
    return xn.getValue() || (globalThis.__DEV__ !== !1 && D.warn(60, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), o = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return o();
    },
    set: function(a) {
      o = function() {
        return a;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function da(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && fa(), e;
  var i = t.definitions.filter(function(a) {
    return a.kind === K.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (D(i.length === 1, 61, i.length), n = i[0].name.value);
  var o = i.find(function(a) {
    return a.name.value === n;
  });
  return D(!!o, 62, n), e == null || B(e, {}) ? e : ha(e, o.selectionSet, {
    operationType: "fragment",
    operationName: o.name.value,
    fragmentMap: St(Tt(t)),
    cache: r,
    mutableTargets: new ca(),
    knownChanged: new la()
  });
}
function Xc(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && fa(), e;
  var i = et(t);
  return D(i, 63), e == null ? e : ha(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: St(Tt(t)),
    cache: r,
    mutableTargets: new ca(),
    knownChanged: new la()
  });
}
var pa = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Qt(eu, {
        max: Fe["cache.fragmentQueryDocuments"] || 1e3,
        cache: fr
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var r = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(r);
      }, n), i;
    }, e.prototype.recordOptimisticTransaction = function(t, r) {
      this.performTransaction(t, r);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && re(t, "canonizeResults", "cache.readQuery"), fe("canonizeResults", function() {
        return n.read(v(v({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
      });
    }, e.prototype.watchFragment = function(t) {
      var r = this, n = t.fragment, i = t.fragmentName, o = t.from, a = t.optimistic, s = a === void 0 ? !0 : a, u = Pe(t, ["fragment", "fragmentName", "from", "optimistic"]), c = this.getFragmentDoc(n, i), l = typeof o > "u" || typeof o == "string" ? o : this.identify(o), h = !!t[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var d = i || xo(n).name.value;
        l || globalThis.__DEV__ !== !1 && D.warn(1, d);
      }
      var f = v(v({}, u), { returnPartialData: !0, id: l, query: c, optimistic: s }), p;
      return new Q(function(m) {
        return r.watch(v(v({}, f), { immediate: !0, callback: function(g) {
          var y = h ? da(g.result, n, r, i) : g.result;
          if (
            // Always ensure we deliver the first result
            !(p && ua(
              c,
              { data: p.result },
              { data: y },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var _ = {
              data: y,
              complete: !!g.complete
            };
            g.missing && (_.missing = Dr(g.missing.map(function(w) {
              return w.missing;
            }))), p = v(v({}, g), { result: y }), m.next(_);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && re(t, "canonizeResults", "cache.readFragment"), fe("canonizeResults", function() {
        return n.read(v(v({}, t), { query: n.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
      });
    }, e.prototype.writeQuery = function(t) {
      var r = t.id, n = t.data, i = Pe(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: r || "ROOT_QUERY",
        result: n
      }));
    }, e.prototype.writeFragment = function(t) {
      var r = t.id, n = t.data, i = t.fragment, o = t.fragmentName, a = Pe(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(a, {
        query: this.getFragmentDoc(i, o),
        dataId: r,
        result: n
      }));
    }, e.prototype.updateQuery = function(t, r) {
      return globalThis.__DEV__ !== !1 && re(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(n) {
          var i = fe("canonizeResults", function() {
            return n.readQuery(t);
          }), o = r(i);
          return o == null ? i : (n.writeQuery(v(v({}, t), { data: o })), o);
        }
      });
    }, e.prototype.updateFragment = function(t, r) {
      return globalThis.__DEV__ !== !1 && re(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(n) {
          var i = fe("canonizeResults", function() {
            return n.readFragment(t);
          }), o = r(i);
          return o == null ? i : (n.writeFragment(v(v({}, t), { data: o })), o);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (pa.prototype.getMemoryInternals = hu);
var va = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r, n, i, o) {
      var a, s = e.call(this, r) || this;
      if (s.message = r, s.path = n, s.query = i, s.variables = o, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var u = s.path.length - 1; u >= 0; --u)
          s.missing = (a = {}, a[s.path[u]] = s.missing, a);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), ie = Object.prototype.hasOwnProperty;
function Ct(e) {
  return e == null;
}
function ma(e, t) {
  var r = e.__typename, n = e.id, i = e._id;
  if (typeof r == "string" && (t && (t.keyObject = Ct(n) ? Ct(i) ? void 0 : { _id: i } : { id: n }), Ct(n) && !Ct(i) && (n = i), !Ct(n)))
    return "".concat(r, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var ya = {
  dataIdFromObject: ma,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function el(e) {
  return Et(ya, e);
}
function ga(e) {
  var t = e.canonizeResults;
  return t === void 0 ? ya.canonizeResults : t;
}
function tl(e, t) {
  return q(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var ba = /^[_a-z][_0-9a-z]*/i;
function Ue(e) {
  var t = e.match(ba);
  return t ? t[0] : e;
}
function pn(e, t, r) {
  return W(t) ? X(t) ? t.every(function(n) {
    return pn(e, n, r);
  }) : e.selections.every(function(n) {
    if (qe(n) && Gt(n, r)) {
      var i = Ce(n);
      return ie.call(t, i) && (!n.selectionSet || pn(n.selectionSet, t[i], r));
    }
    return !0;
  }) : !1;
}
function lt(e) {
  return W(e) && !q(e) && !X(e);
}
function rl() {
  return new Qe();
}
function _a(e, t) {
  var r = St(Tt(e));
  return {
    fragmentMap: r,
    lookupFragment: function(n) {
      var i = r[n];
      return !i && t && (i = t.lookup(n)), i || null;
    }
  };
}
var ur = /* @__PURE__ */ Object.create(null), Lr = function() {
  return ur;
}, Fi = /* @__PURE__ */ Object.create(null), Ut = (
  /** @class */
  (function() {
    function e(t, r) {
      var n = this;
      this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
        return dr(q(i) ? n.get(i.__ref, o) : i && i[o]);
      }, this.canRead = function(i) {
        return q(i) ? n.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, o) {
        if (typeof i == "string")
          return pt(i);
        if (q(i))
          return i;
        var a = n.policies.identify(i)[0];
        if (a) {
          var s = pt(a);
          return o && n.merge(a, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return v({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, r) {
      if (this.group.depend(t, r), ie.call(this.data, t)) {
        var n = this.data[t];
        if (n && ie.call(n, r))
          return n[r];
      }
      if (r === "__typename" && ie.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof Ae)
        return this.parent.get(t, r);
    }, e.prototype.lookup = function(t, r) {
      if (r && this.group.depend(t, "__exists"), ie.call(this.data, t))
        return this.data[t];
      if (this instanceof Ae)
        return this.parent.lookup(t, r);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, r) {
      var n = this, i;
      q(t) && (t = t.__ref), q(r) && (r = r.__ref);
      var o = typeof t == "string" ? this.lookup(i = t) : t, a = typeof r == "string" ? this.lookup(i = r) : r;
      if (a) {
        D(typeof i == "string", 2);
        var s = new Qe(il).merge(o, a);
        if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
          var u = /* @__PURE__ */ Object.create(null);
          o || (u.__exists = 1), Object.keys(a).forEach(function(c) {
            if (!o || o[c] !== s[c]) {
              u[c] = 1;
              var l = Ue(c);
              l !== c && !n.policies.hasKeyArgs(s.__typename, l) && (u[l] = 1), s[c] === void 0 && !(n instanceof Ae) && delete s[c];
            }
          }), u.__typename && !(o && o.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete u.__typename, Object.keys(u).forEach(function(c) {
            return n.group.dirty(i, c);
          });
        }
      }
    }, e.prototype.modify = function(t, r) {
      var n = this, i = this.lookup(t);
      if (i) {
        var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, u = {
          DELETE: ur,
          INVALIDATE: Fi,
          isReference: q,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(c, l) {
            return n.policies.readField(typeof c == "string" ? {
              fieldName: c,
              from: l || pt(t)
            } : c, { store: n });
          }
        };
        if (Object.keys(i).forEach(function(c) {
          var l = Ue(c), h = i[c];
          if (h !== void 0) {
            var d = typeof r == "function" ? r : r[c] || r[l];
            if (d) {
              var f = d === Lr ? ur : d(dr(h), v(v({}, u), { fieldName: l, storeFieldName: c, storage: n.getStorage(t, c) }));
              if (f === Fi)
                n.group.dirty(t, c);
              else if (f === ur && (f = void 0), f !== h && (o[c] = f, a = !0, h = f, globalThis.__DEV__ !== !1)) {
                var p = function(O) {
                  if (n.lookup(O.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && D.warn(3, O), !0;
                };
                if (q(f))
                  p(f);
                else if (Array.isArray(f))
                  for (var m = !1, g = void 0, y = 0, _ = f; y < _.length; y++) {
                    var w = _[y];
                    if (q(w)) {
                      if (m = !0, p(w))
                        break;
                    } else if (typeof w == "object" && w) {
                      var S = n.policies.identify(w)[0];
                      S && (g = w);
                    }
                    if (m && g !== void 0) {
                      globalThis.__DEV__ !== !1 && D.warn(4, g);
                      break;
                    }
                  }
              }
            }
            h !== void 0 && (s = !1);
          }
        }), a)
          return this.merge(t, o), s && (this instanceof Ae ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, r, n) {
      var i, o = this.lookup(t);
      if (o) {
        var a = this.getFieldValue(o, "__typename"), s = r && n ? this.policies.getStoreFieldName({ typename: a, fieldName: r, args: n }) : r;
        return this.modify(t, s ? (i = {}, i[s] = Lr, i) : Lr);
      }
      return !1;
    }, e.prototype.evict = function(t, r) {
      var n = !1;
      return t.id && (ie.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof Ae && this !== r && (n = this.parent.evict(t, r) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, r = this.toObject(), n = [];
      return this.getRootIdSet().forEach(function(i) {
        ie.call(t.policies.rootTypenamesById, i) || n.push(i);
      }), n.length && (r.__META = { extraRootIds: n.sort() }), r;
    }, e.prototype.replace = function(t) {
      var r = this;
      if (Object.keys(this.data).forEach(function(o) {
        t && ie.call(t, o) || r.delete(o);
      }), t) {
        var n = t.__META, i = Pe(t, ["__META"]);
        Object.keys(i).forEach(function(o) {
          r.merge(o, i[o]);
        }), n && n.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var r = --this.rootIds[t];
        return r || delete this.rootIds[t], r;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof Ae ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, r = this.getRootIdSet(), n = this.toObject();
      r.forEach(function(a) {
        ie.call(n, a) && (Object.keys(t.findChildRefIds(a)).forEach(r.add, r), delete n[a]);
      });
      var i = Object.keys(n);
      if (i.length) {
        for (var o = this; o instanceof Ae; )
          o = o.parent;
        i.forEach(function(a) {
          return o.delete(a);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!ie.call(this.refs, t)) {
        var r = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
        if (!n)
          return r;
        var i = /* @__PURE__ */ new Set([n]);
        i.forEach(function(o) {
          q(o) && (r[o.__ref] = !0), W(o) && Object.keys(o).forEach(function(a) {
            var s = o[a];
            W(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), wa = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? Wo() : null, this.keyMaker = new Ne(nt);
    }, e.prototype.depend = function(t, r) {
      if (this.d) {
        this.d(Vr(t, r));
        var n = Ue(r);
        n !== r && this.d(Vr(t, n)), this.parent && this.parent.depend(t, r);
      }
    }, e.prototype.dirty = function(t, r) {
      this.d && this.d.dirty(
        Vr(t, r),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        r === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function Vr(e, t) {
  return t + "#" + e;
}
function Ci(e, t) {
  Lt(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(r) {
      De(n, r);
      function n(i) {
        var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, u = i.seed, c = r.call(this, o, new wa(s)) || this;
        return c.stump = new nl(c), c.storageTrie = new Ne(nt), u && c.replace(u), c;
      }
      return n.prototype.addLayer = function(i, o) {
        return this.stump.addLayer(i, o);
      }, n.prototype.removeLayer = function() {
        return this;
      }, n.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, n;
    })(e)
  );
  e.Root = t;
})(Ut || (Ut = {}));
var Ae = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, n.policies, o) || this;
      return a.id = r, a.parent = n, a.replay = i, a.group = o, i(a), a;
    }
    return t.prototype.addLayer = function(r, n) {
      return new t(r, this, n, this.group);
    }, t.prototype.removeLayer = function(r) {
      var n = this, i = this.parent.removeLayer(r);
      return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
        var a = n.data[o], s = i.lookup(o);
        s ? a ? a !== s && Object.keys(a).forEach(function(u) {
          B(a[u], s[u]) || n.group.dirty(o, u);
        }) : (n.group.dirty(o, "__exists"), Object.keys(s).forEach(function(u) {
          n.group.dirty(o, u);
        })) : n.delete(o);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return v(v({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(r) {
      var n = this.parent.findChildRefIds(r);
      return ie.call(this.data, r) ? v(v({}, n), e.prototype.findChildRefIds.call(this, r)) : n;
    }, t.prototype.getStorage = function() {
      for (var r = this.parent; r.parent; )
        r = r.parent;
      return r.getStorage.apply(
        r,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(Ut)
), nl = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      return e.call(this, "EntityStore.Stump", r, function() {
      }, new wa(r.group.caching, r.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(r, n) {
      return this.parent.merge(r, n);
    }, t;
  })(Ae)
);
function il(e, t, r) {
  var n = e[r], i = t[r];
  return B(n, i) ? n : i;
}
function Lt(e) {
  return !!(e instanceof Ut && e.group.caching);
}
function ol(e) {
  return W(e) ? X(e) ? e.slice(0) : v({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var Ni = (
  /** @class */
  (function() {
    function e() {
      this.known = new (On ? WeakSet : Set)(), this.pool = new Ne(nt), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return W(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (W(t)) {
        var r = ol(t);
        return this.passes.set(r, t), r;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var r = this;
      if (W(t)) {
        var n = this.passes.get(t);
        if (n)
          return n;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var o = t.map(this.admit, this), a = this.pool.lookupArray(o);
            return a.array || (this.known.add(a.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), a.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), u = [s], c = this.sortedKeys(t);
            u.push(c.json);
            var l = u.length;
            c.sorted.forEach(function(f) {
              u.push(r.admit(t[f]));
            });
            var a = this.pool.lookupArray(u);
            if (!a.object) {
              var h = a.object = Object.create(s);
              this.known.add(h), c.sorted.forEach(function(f, p) {
                h[f] = u[l + p];
              }), globalThis.__DEV__ !== !1 && Object.freeze(h);
            }
            return a.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var r = Object.keys(t), n = this.pool.lookupArray(r);
      if (!n.keys) {
        r.sort();
        var i = JSON.stringify(r);
        (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: r, json: i });
      }
      return n.keys;
    }, e;
  })()
);
function Ai(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var al = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.knownResults = new (nt ? WeakMap : Map)(), this.config = Et(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: ga(t)
      }), this.canon = t.canon || new Ni(), this.executeSelectionSet = Qt(function(n) {
        var i, o = n.context.canonizeResults, a = Ai(n);
        a[3] = !o;
        var s = (i = r.executeSelectionSet).peek.apply(i, a);
        return s ? o ? v(v({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: r.canon.admit(s.result)
        }) : s : (Ci(n.context.store, n.enclosingRef.__ref), r.execSelectionSetImpl(n));
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: Ai,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(n, i, o, a) {
          if (Lt(o.store))
            return o.store.makeCacheKey(n, q(i) ? i.__ref : i, o.varString, a);
        }
      }), this.executeSubSelectedArray = Qt(function(n) {
        return Ci(n.context.store, n.enclosingRef.__ref), r.execSubSelectedArrayImpl(n);
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(n) {
          var i = n.field, o = n.array, a = n.context;
          if (Lt(a.store))
            return a.store.makeCacheKey(i, o, a.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new Ni();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var r = t.store, n = t.query, i = t.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = t.variables, s = t.returnPartialData, u = s === void 0 ? !0 : s, c = t.canonizeResults, l = c === void 0 ? this.config.canonizeResults : c, h = this.config.cache.policies;
      a = v(v({}, Tn(Ao(n))), a);
      var d = pt(o), f = this.executeSelectionSet({
        selectionSet: Dt(n).selectionSet,
        objectOrReference: d,
        enclosingRef: d,
        context: v({ store: r, query: n, policies: h, variables: a, varString: Ve(a), canonizeResults: l }, _a(n, this.config.fragments))
      }), p;
      if (f.missing && (p = [
        new va(sl(f.missing), f.missing, n, a)
      ], !u))
        throw p[0];
      return {
        result: f.result,
        complete: !p,
        missing: p
      };
    }, e.prototype.isFresh = function(t, r, n, i) {
      if (Lt(i.store) && this.knownResults.get(t) === n) {
        var o = this.executeSelectionSet.peek(
          n,
          r,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (o && t === o.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var r = this, n = t.selectionSet, i = t.objectOrReference, o = t.enclosingRef, a = t.context;
      if (q(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = a.variables, u = a.policies, c = a.store, l = c.getFieldValue(i, "__typename"), h = [], d, f = new Qe();
      this.config.addTypename && typeof l == "string" && !u.rootIdsByTypename[l] && h.push({ __typename: l });
      function p(w, S) {
        var O;
        return w.missing && (d = f.merge(d, (O = {}, O[S] = w.missing, O))), w.result;
      }
      var m = new Set(n.selections);
      m.forEach(function(w) {
        var S, O;
        if (Gt(w, s))
          if (qe(w)) {
            var T = u.readField({
              fieldName: w.name.value,
              field: w,
              variables: a.variables,
              from: i
            }, a), F = Ce(w);
            T === void 0 ? Rn.added(w) || (d = f.merge(d, (S = {}, S[F] = "Can't find field '".concat(w.name.value, "' on ").concat(q(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), S))) : X(T) ? T.length > 0 && (T = p(r.executeSubSelectedArray({
              field: w,
              array: T,
              enclosingRef: o,
              context: a
            }), F)) : w.selectionSet ? T != null && (T = p(r.executeSelectionSet({
              selectionSet: w.selectionSet,
              objectOrReference: T,
              enclosingRef: q(T) ? T : o,
              context: a
            }), F)) : a.canonizeResults && (T = r.canon.pass(T)), T !== void 0 && h.push((O = {}, O[F] = T, O));
          } else {
            var R = kr(w, a.lookupFragment);
            if (!R && w.kind === K.FRAGMENT_SPREAD)
              throw ve(10, w.name.value);
            R && u.fragmentMatches(R, l) && R.selectionSet.selections.forEach(m.add, m);
          }
      });
      var g = Dr(h), y = { result: g, missing: d }, _ = a.canonizeResults ? this.canon.admit(y) : dr(y);
      return _.result && this.knownResults.set(_.result, n), _;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var r = this, n = t.field, i = t.array, o = t.enclosingRef, a = t.context, s, u = new Qe();
      function c(l, h) {
        var d;
        return l.missing && (s = u.merge(s, (d = {}, d[h] = l.missing, d))), l.result;
      }
      return n.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(l, h) {
        return l === null ? null : X(l) ? c(r.executeSubSelectedArray({
          field: n,
          array: l,
          enclosingRef: o,
          context: a
        }), h) : n.selectionSet ? c(r.executeSelectionSet({
          selectionSet: n.selectionSet,
          objectOrReference: l,
          enclosingRef: q(l) ? l : o,
          context: a
        }), h) : (globalThis.__DEV__ !== !1 && ul(a.store, n, l), l);
      }), {
        result: a.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function sl(e) {
  try {
    JSON.stringify(e, function(t, r) {
      if (typeof r == "string")
        throw r;
      return r;
    });
  } catch (t) {
    return t;
  }
}
function ul(e, t, r) {
  if (!t.selectionSet) {
    var n = /* @__PURE__ */ new Set([r]);
    n.forEach(function(i) {
      W(i) && (D(
        !q(i),
        11,
        tl(e, i),
        t.name.value
      ), Object.values(i).forEach(n.add, n));
    });
  }
}
var Mn = new It(), xi = /* @__PURE__ */ new WeakMap();
function Vt(e) {
  var t = xi.get(e);
  return t || xi.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: Wo()
  }), t;
}
function Mi(e) {
  Vt(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function cl(e) {
  Vt(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function ll(e) {
  var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = function(o) {
    if (arguments.length > 0) {
      if (e !== o) {
        e = o, t.forEach(function(u) {
          Vt(u).dep.dirty(n), fl(u);
        });
        var a = Array.from(r);
        r.clear(), a.forEach(function(u) {
          return u(e);
        });
      }
    } else {
      var s = Mn.getValue();
      s && (i(s), Vt(s).dep(n));
    }
    return e;
  };
  n.onNextChange = function(o) {
    return r.add(o), function() {
      r.delete(o);
    };
  };
  var i = n.attachCache = function(o) {
    return t.add(o), Vt(o).vars.add(n), n;
  };
  return n.forgetCache = function(o) {
    return t.delete(o);
  }, n;
}
function fl(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var ji = /* @__PURE__ */ Object.create(null);
function jn(e) {
  var t = JSON.stringify(e);
  return ji[t] || (ji[t] = /* @__PURE__ */ Object.create(null));
}
function $i(e) {
  var t = jn(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(r, n) {
    var i = function(a, s) {
      return n.readField(s, a);
    }, o = n.keyObject = $n(e, function(a) {
      var s = mt(
        n.storeObject,
        a,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && r !== n.storeObject && ie.call(r, a[0]) && (s = mt(r, a, ka)), D(s !== void 0, 5, a.join("."), r), s;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(o));
  });
}
function Li(e) {
  var t = jn(e);
  return t.keyArgsFn || (t.keyArgsFn = function(r, n) {
    var i = n.field, o = n.variables, a = n.fieldName, s = $n(e, function(c) {
      var l = c[0], h = l.charAt(0);
      if (h === "@") {
        if (i && Ie(i.directives)) {
          var d = l.slice(1), f = i.directives.find(function(y) {
            return y.name.value === d;
          }), p = f && Sr(f, o);
          return p && mt(
            p,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            c.slice(1)
          );
        }
        return;
      }
      if (h === "$") {
        var m = l.slice(1);
        if (o && ie.call(o, m)) {
          var g = c.slice(0);
          return g[0] = m, mt(o, g);
        }
        return;
      }
      if (r)
        return mt(r, c);
    }), u = JSON.stringify(s);
    return (r || u !== "{}") && (a += ":" + u), a;
  });
}
function $n(e, t) {
  var r = new Qe();
  return Ea(e).reduce(function(n, i) {
    var o, a = t(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      n = r.merge(n, a);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function Ea(e) {
  var t = jn(e);
  if (!t.paths) {
    var r = t.paths = [], n = [];
    e.forEach(function(i, o) {
      X(i) ? (Ea(i).forEach(function(a) {
        return r.push(n.concat(a));
      }), n.length = 0) : (n.push(i), X(e[o + 1]) || (r.push(n.slice(0)), n.length = 0));
    });
  }
  return t.paths;
}
function ka(e, t) {
  return e[t];
}
function mt(e, t, r) {
  return r = r || ka, Sa(t.reduce(function n(i, o) {
    return X(i) ? i.map(function(a) {
      return n(a, o);
    }) : i && r(i, o);
  }, e));
}
function Sa(e) {
  return W(e) ? X(e) ? e.map(Sa) : $n(Object.keys(e).sort(), function(t) {
    return mt(e, t);
  }) : e;
}
function vn(e) {
  return e.args !== void 0 ? e.args : e.field ? Sr(e.field, e.variables) : null;
}
var hl = function() {
}, Vi = function(e, t) {
  return t.fieldName;
}, qi = function(e, t, r) {
  var n = r.mergeObjects;
  return n(e, t);
}, Zi = function(e, t) {
  return t;
}, dl = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = v({ dataIdFromObject: ma }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, r) {
      var n, i = this, o = r && (r.typename || ((n = r.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
      if (o === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var a = r && r.storeObject || t, s = v(v({}, r), { typename: o, storeObject: a, readField: r && r.readField || function() {
        var h = Ln(arguments, a);
        return i.readField(h, {
          store: i.cache.data,
          variables: h.variables
        });
      } }), u, c = o && this.getTypePolicy(o), l = c && c.keyFn || this.config.dataIdFromObject;
      return xn.withValue(!0, function() {
        for (; l; ) {
          var h = l(v(v({}, t), a), s);
          if (X(h))
            l = $i(h);
          else {
            u = h;
            break;
          }
        }
      }), u = u ? String(u) : void 0, s.keyObject ? [u, s.keyObject] : [u];
    }, e.prototype.addTypePolicies = function(t) {
      var r = this;
      Object.keys(t).forEach(function(n) {
        var i = t[n], o = i.queryType, a = i.mutationType, s = i.subscriptionType, u = Pe(i, ["queryType", "mutationType", "subscriptionType"]);
        o && r.setRootTypename("Query", n), a && r.setRootTypename("Mutation", n), s && r.setRootTypename("Subscription", n), ie.call(r.toBeAdded, n) ? r.toBeAdded[n].push(u) : r.toBeAdded[n] = [u];
      });
    }, e.prototype.updateTypePolicy = function(t, r, n) {
      var i = this.getTypePolicy(t), o = r.keyFields, a = r.fields;
      function s(u, c) {
        u.merge = typeof c == "function" ? c : c === !0 ? qi : c === !1 ? Zi : u.merge;
      }
      s(i, r.merge), i.keyFn = // Pass false to disable normalization for this typename.
      o === !1 ? hl : X(o) ? $i(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(u) {
        var c = n[u];
        (!c || (c == null ? void 0 : c.typename) !== t) && (c = n[u] = { typename: t });
        var l = a[u];
        if (typeof l == "function")
          c.read = l;
        else {
          var h = l.keyArgs, d = l.read, f = l.merge;
          c.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          h === !1 ? Vi : X(h) ? Li(h) : typeof h == "function" ? h : c.keyFn, typeof d == "function" && (c.read = d), s(c, f);
        }
        c.read && c.merge && (c.keyFn = c.keyFn || Vi);
      });
    }, e.prototype.setRootTypename = function(t, r) {
      r === void 0 && (r = t);
      var n = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[n];
      r !== i && (D(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[r] = n, this.rootTypenamesById[n] = r);
    }, e.prototype.addPossibleTypes = function(t) {
      var r = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
        r.getSupertypeSet(n, !0), t[n].forEach(function(i) {
          r.getSupertypeSet(i, !0).add(n);
          var o = i.match(ba);
          (!o || o[0] !== i) && r.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var r = this;
      if (!ie.call(this.typePolicies, t)) {
        var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        n.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(a, s) {
          if (a.test(t)) {
            var u = r.supertypeMap.get(s);
            u && u.forEach(function(c) {
              return i.add(c);
            });
          }
        })), i && i.size && i.forEach(function(a) {
          var s = r.getTypePolicy(a), u = s.fields, c = Pe(s, ["fields"]);
          Object.assign(n, c), Object.assign(n.fields, u);
        });
      }
      var o = this.toBeAdded[t];
      return o && o.length && o.splice(0).forEach(function(a) {
        r.updateTypePolicy(t, a, r.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, r) {
      if (t)
        return this.getTypePolicy(t).fields[r];
    }, e.prototype.getSupertypeSet = function(t, r) {
      var n = this.supertypeMap.get(t);
      return !n && r && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
    }, e.prototype.fragmentMatches = function(t, r, n, i) {
      var o = this;
      if (!t.typeCondition)
        return !0;
      if (!r)
        return !1;
      var a = t.typeCondition.name.value;
      if (r === a)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(a))
        for (var s = this.getSupertypeSet(r, !0), u = [s], c = function(p) {
          var m = o.getSupertypeSet(p, !1);
          m && m.size && u.indexOf(m) < 0 && u.push(m);
        }, l = !!(n && this.fuzzySubtypes.size), h = !1, d = 0; d < u.length; ++d) {
          var f = u[d];
          if (f.has(a))
            return s.has(a) || (h && globalThis.__DEV__ !== !1 && D.warn(7, r, a), s.add(a)), !0;
          f.forEach(c), l && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          d === u.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          pn(t.selectionSet, n, i) && (l = !1, h = !0, this.fuzzySubtypes.forEach(function(p, m) {
            var g = r.match(p);
            g && g[0] === r && c(m);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return !!(n && n.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var r = t.typename, n = t.fieldName, i = this.getFieldPolicy(r, n), o, a = i && i.keyFn;
      if (a && r)
        for (var s = {
          typename: r,
          fieldName: n,
          field: t.field || null,
          variables: t.variables
        }, u = vn(t); a; ) {
          var c = a(u, s);
          if (X(c))
            a = Li(c);
          else {
            o = c || n;
            break;
          }
        }
      return o === void 0 && (o = t.field ? zu(t.field, t.variables) : No(n, vn(t))), o === !1 ? n : n === Ue(o) ? o : n + ":" + o;
    }, e.prototype.readField = function(t, r) {
      var n = t.from;
      if (n) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var o = r.store.getFieldValue(n, "__typename");
            o && (t.typename = o);
          }
          var a = this.getStoreFieldName(t), s = Ue(a), u = r.store.getFieldValue(n, a), c = this.getFieldPolicy(t.typename, s), l = c && c.read;
          if (l) {
            var h = Qi(this, n, t, r, r.store.getStorage(q(n) ? n.__ref : n, a));
            return Mn.withValue(this.cache, l, [
              u,
              h
            ]);
          }
          return u;
        }
      }
    }, e.prototype.getReadFunction = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return n && n.read;
    }, e.prototype.getMergeFunction = function(t, r, n) {
      var i = this.getFieldPolicy(t, r), o = i && i.merge;
      return !o && n && (i = this.getTypePolicy(n), o = i && i.merge), o;
    }, e.prototype.runMergeFunction = function(t, r, n, i, o) {
      var a = n.field, s = n.typename, u = n.merge;
      return u === qi ? Oa(i.store)(t, r) : u === Zi ? r : (i.overwrite && (t = void 0), u(t, r, Qi(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: a.name.value,
          field: a,
          variables: i.variables
        },
        i,
        o || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function Qi(e, t, r, n, i) {
  var o = e.getStoreFieldName(r), a = Ue(o), s = r.variables || n.variables, u = n.store, c = u.toReference, l = u.canRead;
  return {
    args: vn(r),
    field: r.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: q,
    toReference: c,
    storage: i,
    cache: e.cache,
    canRead: l,
    readField: function() {
      return e.readField(Ln(arguments, t, s), n);
    },
    mergeObjects: Oa(n.store)
  };
}
function Ln(e, t, r) {
  var n = e[0], i = e[1], o = e.length, a;
  return typeof n == "string" ? a = {
    fieldName: n,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: o > 1 ? i : t
  } : (a = v({}, n), ie.call(a, "from") || (a.from = t)), globalThis.__DEV__ !== !1 && a.from === void 0 && globalThis.__DEV__ !== !1 && D.warn(8, ko(Array.from(e))), a.variables === void 0 && (a.variables = r), a;
}
function Oa(e) {
  return function(r, n) {
    if (X(r) || X(n))
      throw ve(9);
    if (W(r) && W(n)) {
      var i = e.getFieldValue(r, "__typename"), o = e.getFieldValue(n, "__typename"), a = i && o && i !== o;
      if (a)
        return n;
      if (q(r) && lt(n))
        return e.merge(r.__ref, n), r;
      if (lt(r) && q(n))
        return e.merge(r, n.__ref), n;
      if (lt(r) && lt(n))
        return v(v({}, r), n);
    }
    return n;
  };
}
function qr(e, t, r) {
  var n = "".concat(t).concat(r), i = e.flavors.get(n);
  return i || e.flavors.set(n, i = e.clientOnly === t && e.deferred === r ? e : v(v({}, e), { clientOnly: t, deferred: r })), i;
}
var pl = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.cache = t, this.reader = r, this.fragments = n;
    }
    return e.prototype.writeToStore = function(t, r) {
      var n = this, i = r.query, o = r.result, a = r.dataId, s = r.variables, u = r.overwrite, c = et(i), l = rl();
      s = v(v({}, Tn(c)), s);
      var h = v(v({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(f, p) {
        return l.merge(f, p);
      }, variables: s, varString: Ve(s) }, _a(i, this.fragments)), { overwrite: !!u, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), d = this.processSelectionSet({
        result: o || /* @__PURE__ */ Object.create(null),
        dataId: a,
        selectionSet: c.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: h
      });
      if (!q(d))
        throw ve(12, o);
      return h.incomingById.forEach(function(f, p) {
        var m = f.storeObject, g = f.mergeTree, y = f.fieldNodeSet, _ = pt(p);
        if (g && g.map.size) {
          var w = n.applyMerges(g, _, m, h);
          if (q(w))
            return;
          m = w;
        }
        if (globalThis.__DEV__ !== !1 && !h.overwrite) {
          var S = /* @__PURE__ */ Object.create(null);
          y.forEach(function(F) {
            F.selectionSet && (S[F.name.value] = !0);
          });
          var O = function(F) {
            return S[Ue(F)] === !0;
          }, T = function(F) {
            var R = g && g.map.get(F);
            return !!(R && R.info && R.info.merge);
          };
          Object.keys(m).forEach(function(F) {
            O(F) && !T(F) && vl(_, m, F, h.store);
          });
        }
        t.merge(p, m);
      }), t.retain(d.__ref), d;
    }, e.prototype.processSelectionSet = function(t) {
      var r = this, n = t.dataId, i = t.result, o = t.selectionSet, a = t.context, s = t.mergeTree, u = this.cache.policies, c = /* @__PURE__ */ Object.create(null), l = n && u.rootTypenamesById[n] || rn(i, o, a.fragmentMap) || n && a.store.get(n, "__typename");
      typeof l == "string" && (c.__typename = l);
      var h = function() {
        var w = Ln(arguments, c, a.variables);
        if (q(w.from)) {
          var S = a.incomingById.get(w.from.__ref);
          if (S) {
            var O = u.readField(v(v({}, w), { from: S.storeObject }), a);
            if (O !== void 0)
              return O;
          }
        }
        return u.readField(w, a);
      }, d = /* @__PURE__ */ new Set();
      this.flattenFields(
        o,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        a,
        l
      ).forEach(function(w, S) {
        var O, T = Ce(S), F = i[T];
        if (d.add(S), F !== void 0) {
          var R = u.getStoreFieldName({
            typename: l,
            fieldName: S.name.value,
            field: S,
            variables: w.variables
          }), x = Ui(s, R), L = r.processFieldValue(
            F,
            S,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            S.selectionSet ? qr(w, !1, !1) : w,
            x
          ), Ee = void 0;
          S.selectionSet && (q(L) || lt(L)) && (Ee = h("__typename", L));
          var ye = u.getMergeFunction(l, S.name.value, Ee);
          ye ? x.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: S,
            typename: l,
            merge: ye
          } : Bi(s, R), c = w.merge(c, (O = {}, O[R] = L, O));
        } else globalThis.__DEV__ !== !1 && !w.clientOnly && !w.deferred && !Rn.added(S) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !u.getReadFunction(l, S.name.value) && globalThis.__DEV__ !== !1 && D.error(13, Ce(S), i);
      });
      try {
        var f = u.identify(i, {
          typename: l,
          selectionSet: o,
          fragmentMap: a.fragmentMap,
          storeObject: c,
          readField: h
        }), p = f[0], m = f[1];
        n = n || p, m && (c = a.merge(c, m));
      } catch (w) {
        if (!n)
          throw w;
      }
      if (typeof n == "string") {
        var g = pt(n), y = a.written[n] || (a.written[n] = []);
        if (y.indexOf(o) >= 0 || (y.push(o), this.reader && this.reader.isFresh(i, g, o, a)))
          return g;
        var _ = a.incomingById.get(n);
        return _ ? (_.storeObject = a.merge(_.storeObject, c), _.mergeTree = mn(_.mergeTree, s), d.forEach(function(w) {
          return _.fieldNodeSet.add(w);
        })) : a.incomingById.set(n, {
          storeObject: c,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: pr(s) ? void 0 : s,
          fieldNodeSet: d
        }), g;
      }
      return c;
    }, e.prototype.processFieldValue = function(t, r, n, i) {
      var o = this;
      return !r.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? ta(t) : t : X(t) ? t.map(function(a, s) {
        var u = o.processFieldValue(a, r, n, Ui(i, s));
        return Bi(i, s), u;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: r.selectionSet,
        context: n,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, r, n, i) {
      i === void 0 && (i = rn(r, t, n.fragmentMap));
      var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new Ne(!1);
      return (function u(c, l) {
        var h = s.lookup(
          c,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          l.clientOnly,
          l.deferred
        );
        h.visited || (h.visited = !0, c.selections.forEach(function(d) {
          if (Gt(d, n.variables)) {
            var f = l.clientOnly, p = l.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(f && p) && Ie(d.directives) && d.directives.forEach(function(y) {
                var _ = y.name.value;
                if (_ === "client" && (f = !0), _ === "defer") {
                  var w = Sr(y, n.variables);
                  (!w || w.if !== !1) && (p = !0);
                }
              }), qe(d)
            ) {
              var m = o.get(d);
              m && (f = f && m.clientOnly, p = p && m.deferred), o.set(d, qr(n, f, p));
            } else {
              var g = kr(d, n.lookupFragment);
              if (!g && d.kind === K.FRAGMENT_SPREAD)
                throw ve(14, d.name.value);
              g && a.fragmentMatches(g, i, r, n.variables) && u(g.selectionSet, qr(n, f, p));
            }
          }
        }));
      })(t, n), o;
    }, e.prototype.applyMerges = function(t, r, n, i, o) {
      var a, s = this;
      if (t.map.size && !q(n)) {
        var u = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !X(n) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (q(r) || lt(r)) ? r : void 0
        ), c = n;
        u && !o && (o = [q(u) ? u.__ref : u]);
        var l, h = function(d, f) {
          return X(d) ? typeof f == "number" ? d[f] : void 0 : i.store.getFieldValue(d, String(f));
        };
        t.map.forEach(function(d, f) {
          var p = h(u, f), m = h(c, f);
          if (m !== void 0) {
            o && o.push(f);
            var g = s.applyMerges(d, p, m, i, o);
            g !== m && (l = l || /* @__PURE__ */ new Map(), l.set(f, g)), o && D(o.pop() === f);
          }
        }), l && (n = X(c) ? c.slice(0) : v({}, c), l.forEach(function(d, f) {
          n[f] = d;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(r, n, t.info, i, o && (a = i.store).getStorage.apply(a, o)) : n;
    }, e;
  })()
), Ta = [];
function Ui(e, t) {
  var r = e.map;
  return r.has(t) || r.set(t, Ta.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
}
function mn(e, t) {
  if (e === t || !t || pr(t))
    return e;
  if (!e || pr(e))
    return t;
  var r = e.info && t.info ? v(v({}, e.info), t.info) : e.info || t.info, n = e.map.size && t.map.size, i = n ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, o = { info: r, map: i };
  if (n) {
    var a = new Set(t.map.keys());
    e.map.forEach(function(s, u) {
      o.map.set(u, mn(s, t.map.get(u))), a.delete(u);
    }), a.forEach(function(s) {
      o.map.set(s, mn(t.map.get(s), e.map.get(s)));
    });
  }
  return o;
}
function pr(e) {
  return !e || !(e.info || e.map.size);
}
function Bi(e, t) {
  var r = e.map, n = r.get(t);
  n && pr(n) && (Ta.push(n), r.delete(t));
}
var Wi = /* @__PURE__ */ new Set();
function vl(e, t, r, n) {
  var i = function(h) {
    var d = n.getFieldValue(h, r);
    return typeof d == "object" && d;
  }, o = i(e);
  if (o) {
    var a = i(t);
    if (a && !q(o) && !B(o, a) && !Object.keys(o).every(function(h) {
      return n.getFieldValue(a, h) !== void 0;
    })) {
      var s = n.getFieldValue(e, "__typename") || n.getFieldValue(t, "__typename"), u = Ue(r), c = "".concat(s, ".").concat(u);
      if (!Wi.has(c)) {
        Wi.add(c);
        var l = [];
        !X(o) && !X(a) && [o, a].forEach(function(h) {
          var d = n.getFieldValue(h, "__typename");
          typeof d == "string" && !l.includes(d) && l.push(d);
        }), globalThis.__DEV__ !== !1 && D.warn(15, u, s, l.length ? "either ensure all objects of type " + l.join(" and ") + " have an ID or a custom merge function, or " : "", c, v({}, o), v({}, a));
      }
    }
  }
}
var Da = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this) || this;
      return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new Jo(Rn), n.assumeImmutableResults = !0, n.makeVar = ll, n.txCount = 0, globalThis.__DEV__ !== !1 && (re(r, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), re(r, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), n.config = el(r), n.addTypename = !!n.config.addTypename, n.policies = new dl({
        cache: n,
        dataIdFromObject: n.config.dataIdFromObject,
        possibleTypes: n.config.possibleTypes,
        typePolicies: n.config.typePolicies
      }), n.init(), n;
    }
    return t.prototype.init = function() {
      var r = this.data = new Ut.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = r.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(r) {
      var n = this, i = this.storeReader, o = this.config.fragments;
      this.addTypenameTransform.resetCache(), o == null || o.resetCaches(), this.storeWriter = new pl(this, this.storeReader = new al({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: ga(this.config),
        canon: r ? void 0 : i && i.canon,
        fragments: o
      }), o), this.maybeBroadcastWatch = Qt(function(a, s) {
        return n.broadcastWatch(a, s);
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(a) {
          var s = a.optimistic ? n.optimisticData : n.data;
          if (Lt(s)) {
            var u = a.optimistic, c = a.id, l = a.variables;
            return s.makeCacheKey(
              a.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              a.callback,
              Ve({ optimistic: u, id: c, variables: l })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(a) {
        return a.resetCaching();
      });
    }, t.prototype.restore = function(r) {
      return this.init(), r && this.data.replace(r), this;
    }, t.prototype.extract = function(r) {
      return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(r) {
      globalThis.__DEV__ !== !1 && re(r, "canonizeResults", "cache.read");
      var n = r.returnPartialData, i = n === void 0 ? !1 : n;
      try {
        return this.storeReader.diffQueryAgainstStore(v(v({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (o) {
        if (o instanceof va)
          return null;
        throw o;
      }
    }, t.prototype.write = function(r) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(r) {
      if (ie.call(r, "id") && !r.id)
        return !1;
      var n = r.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, n.modify(r.id || "ROOT_QUERY", r.fields);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(r) {
      return globalThis.__DEV__ !== !1 && re(r, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(v(v({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(r) {
      var n = this;
      return this.watches.size || cl(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
        n.watches.delete(r) && !n.watches.size && Mi(n), n.maybeBroadcastWatch.forget(r);
      };
    }, t.prototype.gc = function(r) {
      globalThis.__DEV__ !== !1 && re(r || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), Ve.reset(), Le.reset();
      var n = this.optimisticData.gc();
      return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), n;
    }, t.prototype.retain = function(r, n) {
      return (n ? this.optimisticData : this.data).retain(r);
    }, t.prototype.release = function(r, n) {
      return (n ? this.optimisticData : this.data).release(r);
    }, t.prototype.identify = function(r) {
      if (q(r))
        return r.__ref;
      try {
        return this.policies.identify(r)[0];
      } catch (n) {
        globalThis.__DEV__ !== !1 && D.warn(n);
      }
    }, t.prototype.evict = function(r) {
      if (!r.id) {
        if (ie.call(r, "id"))
          return !1;
        r = v(v({}, r), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(r, this.data);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(r) {
      var n = this;
      return this.init(), Ve.reset(), r && r.discardWatches ? (this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), Mi(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(r) {
      var n = this.optimisticData.removeLayer(r);
      n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
    }, t.prototype.batch = function(r) {
      var n = this, i = r.update, o = r.optimistic, a = o === void 0 ? !0 : o, s = r.removeOptimistic, u = r.onWatchUpdated, c, l = function(d) {
        var f = n, p = f.data, m = f.optimisticData;
        ++n.txCount, d && (n.data = n.optimisticData = d);
        try {
          return c = i(n);
        } finally {
          --n.txCount, n.data = p, n.optimisticData = m;
        }
      }, h = /* @__PURE__ */ new Set();
      return u && !this.txCount && this.broadcastWatches(v(v({}, r), { onWatchUpdated: function(d) {
        return h.add(d), !1;
      } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, l) : a === !1 ? l(this.data) : l(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), u && h.size ? (this.broadcastWatches(v(v({}, r), { onWatchUpdated: function(d, f) {
        var p = u.call(this, d, f);
        return p !== !1 && h.delete(d), p;
      } })), h.size && h.forEach(function(d) {
        return n.maybeBroadcastWatch.dirty(d);
      })) : this.broadcastWatches(r), c;
    }, t.prototype.performTransaction = function(r, n) {
      return this.batch({
        update: r,
        optimistic: n || n !== null
      });
    }, t.prototype.transformDocument = function(r) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(r));
    }, t.prototype.fragmentMatches = function(r, n) {
      return this.policies.fragmentMatches(r, n);
    }, t.prototype.lookupFragment = function(r) {
      var n;
      return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(r)) || null;
    }, t.prototype.broadcastWatches = function(r) {
      var n = this;
      this.txCount || this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch(i, r);
      });
    }, t.prototype.addFragmentsToDocument = function(r) {
      var n = this.config.fragments;
      return n ? n.transform(r) : r;
    }, t.prototype.addTypenameToDocument = function(r) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
    }, t.prototype.broadcastWatch = function(r, n) {
      var i = this, o = r.lastDiff, a = fe("canonizeResults", function() {
        return i.diff(r);
      });
      n && (r.optimistic && typeof n.optimistic == "string" && (a.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, r, a, o) === !1) || (!o || !B(o.result, a.result)) && r.callback(r.lastDiff = a, o);
    }, t;
  })(pa)
);
globalThis.__DEV__ !== !1 && (Da.prototype.getMemoryInternals = fu);
var V;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(V || (V = {}));
function ft(e) {
  return e ? e < 7 : !1;
}
var Ji = Object.assign, ml = Object.hasOwnProperty, cr = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, o = r.options, a = this, s = t.inactiveOnCreation.getValue();
      a = e.call(this, function(y) {
        a._getOrCreateQuery();
        try {
          var _ = y._subscription._observer;
          _ && !_.error && (_.error = yl);
        } catch {
        }
        var w = !a.observers.size;
        a.observers.add(y);
        var S = a.last;
        return S && S.error ? y.error && y.error(S.error) : S && S.result && y.next && y.next(a.maskResult(S.result)), w && a.reobserve().catch(function() {
        }), function() {
          a.observers.delete(y) && !a.observers.size && a.tearDownQuery();
        };
      }) || this, a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.dirty = !1, a._getOrCreateQuery = function() {
        return s && (n.queries.set(a.queryId, i), s = !1), a.queryManager.getOrCreateQuery(a.queryId);
      }, a.queryInfo = i, a.queryManager = n, a.waitForOwnResult = Zr(o.fetchPolicy), a.isTornDown = !1, a.subscribeToMore = a.subscribeToMore.bind(a), a.maskResult = a.maskResult.bind(a);
      var u = n.defaultOptions.watchQuery, c = u === void 0 ? {} : u, l = c.fetchPolicy, h = l === void 0 ? "cache-first" : l, d = o.fetchPolicy, f = d === void 0 ? h : d, p = o.initialFetchPolicy, m = p === void 0 ? f === "standby" ? h : f : p;
      a.options = v(v({}, o), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: m,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: f
      }), a.queryId = i.queryId || n.generateQueryId();
      var g = et(a.query);
      return a.queryName = g && g.name && g.name.value, a;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return globalThis.__DEV__ !== !1 && Xe("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && D.warn(23);
      }), new Promise(function(n, i) {
        var o = {
          next: function(s) {
            n(s), r.observers.delete(o), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              a.unsubscribe();
            }, 0);
          },
          error: i
        }, a = r.subscribe(o);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      var n = this;
      r === void 0 && (r = !0);
      var i = fe("getLastResult", function() {
        return n.getLastResult(!0);
      }), o = this.queryInfo.networkStatus || i && i.networkStatus || V.ready, a = v(v({}, i), { loading: ft(o), networkStatus: o }), s = this.options.fetchPolicy, u = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Zr(u) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var c = this.queryInfo.getDiff();
        (c.complete || this.options.returnPartialData) && (a.data = c.result), B(a.data, {}) && (a.data = void 0), c.complete ? (delete a.partial, c.complete && a.networkStatus === V.loading && (u === "cache-first" || u === "cache-only") && (a.networkStatus = V.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === V.ready && (a.error || a.errors) && (a.networkStatus = V.error), globalThis.__DEV__ !== !1 && !c.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && Ia(c.missing);
      }
      return r && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), o = this.queryManager.dataMasking, a = o ? i.nonReactiveQuery : this.query, s = o || i.hasNonreactiveDirective ? !ua(a, this.last.result, r, this.variables) : !B(this.last.result, r);
      return s || n && !B(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || B(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return globalThis.__DEV__ !== !1 && Xe("getLastResult", function() {
        globalThis.__DEV__ !== !1 && D.warn(24);
      }), this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return globalThis.__DEV__ !== !1 && Xe("getLastError", function() {
        globalThis.__DEV__ !== !1 && D.warn(25);
      }), this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && Xe("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && D.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && D.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, o = this.options.fetchPolicy;
      if (o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && ml.call(r, "variables")) {
        var a = Ao(this.query), s = a.variableDefinitions;
        (!s || !s.some(function(u) {
          return u.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && D.warn(
          28,
          r,
          ((n = a.name) === null || n === void 0 ? void 0 : n.value) || a
        );
      }
      return r && !B(this.options.variables, r) && (i.variables = this.options.variables = v(v({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, V.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = v(v({}, r.query ? r : v(v(v(v({}, this.options), { query: this.options.query }), r), { variables: v(v({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var o = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var a = this.queryInfo, s = a.networkStatus;
      a.networkStatus = V.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var u = /* @__PURE__ */ new Set(), c = r == null ? void 0 : r.updateQuery, l = this.options.fetchPolicy !== "no-cache";
      return l || D(c, 29), this.queryManager.fetchQuery(o, i, V.fetchMore).then(function(h) {
        if (n.queryManager.removeQuery(o), a.networkStatus === V.fetchMore && (a.networkStatus = s), l)
          n.queryManager.cache.batch({
            update: function(p) {
              var m = r.updateQuery;
              m ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(g) {
                return m(g, {
                  fetchMoreResult: h.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: h.data
              });
            },
            onWatchUpdated: function(p) {
              u.add(p.query);
            }
          });
        else {
          var d = n.getLast("result"), f = c(d.data, {
            fetchMoreResult: h.data,
            variables: i.variables
          });
          n.reportResult(v(v({}, d), { networkStatus: s, loading: ft(s), data: f }), n.variables);
        }
        return n.maskResult(h);
      }).finally(function() {
        l && !u.has(n.query) && n.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(o) {
          var a = r.updateQuery;
          a && n.updateQuery(function(s, u) {
            return a(s, v({ subscriptionData: o }, u));
          });
        },
        error: function(o) {
          if (r.onError) {
            r.onError(o);
            return;
          }
          globalThis.__DEV__ !== !1 && D.error(30, o);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return globalThis.__DEV__ !== !1 && (re(r, "canonizeResults", "setOptions"), Xe("setOptions", function() {
        globalThis.__DEV__ !== !1 && D.warn(31);
      })), this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = Et(this.options, r || {});
      Ji(this.options, n);
    }, t.prototype.setVariables = function(r) {
      var n = this;
      return B(this.variables, r) ? this.observers.size ? fe("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, V.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), o = i.result, a = i.complete, s = r(o, {
        variables: this.variables,
        complete: !!a,
        previousData: o
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, o = i === void 0 ? "cache-first" : i, a = n.initialFetchPolicy, s = a === void 0 ? o : a;
        o === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(o, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      var o = this._getOrCreateQuery();
      return o.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(o, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, o = n.options.pollInterval;
        if (!o || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === o)) {
          D(o, 32);
          var a = i || (this.pollingInfo = {});
          a.interval = o;
          var s = function() {
            var c, l;
            r.pollingInfo && (!ft(r.queryInfo.networkStatus) && !(!((l = (c = r.options).skipPollAttempt) === null || l === void 0) && l.call(c)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, V.poll).then(u, u) : u());
          }, u = function() {
            var c = r.pollingInfo;
            c && (clearTimeout(c.timeout), c.timeout = setTimeout(s, c.interval));
          };
          u();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var o = fe("getLastError", function() {
        return i.getLastError();
      });
      return o && this.last && !B(n, this.last.variables) && (o = void 0), this.last = v({ result: this.queryManager.assumeImmutableResults ? r : ta(r), variables: n }, o ? { error: o } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var o = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === V.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === V.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === V.poll
      ), a = this.options.variables, s = this.options.fetchPolicy, u = Et(this.options, r || {}), c = o ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        u
      ) : Ji(this.options, u), l = this.transformDocument(c.query);
      this.lastQuery = l, o || (this.updatePolling(), r && r.variables && !B(r.variables, a) && // Don't mess with the fetchPolicy if it's currently "standby".
      c.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (c.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof c.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", c), n === void 0 && (n = V.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Zr(c.fetchPolicy));
      var h = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, d = c.variables && v({}, c.variables), f = this.fetch(c, n, l), p = f.concast, m = f.fromLink, g = {
        next: function(y) {
          B(i.variables, d) && (h(), i.reportResult(y, d));
        },
        error: function(y) {
          B(i.variables, d) && (oa(y) || (y = new $e({ networkError: y })), h(), i.reportError(y, d));
        }
      };
      return !o && (m || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = g), p.addObserver(g), p;
    }, t.prototype.reobserve = function(r, n) {
      return ic(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = this.last;
      fe("resetLastResults", function() {
        return r.resetLastResults();
      });
      var a = this.subscribe.apply(this, n);
      return this.last = o, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this, o = fe("getLastError", function() {
        return i.getLastError();
      }), a = this.isDifferentFromLastResult(r, n);
      (o || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (o || a) && $t(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = this, o = v(v({}, fe("getLastResult", function() {
        return i.getLastResult();
      })), { error: r, errors: r.graphQLErrors, networkStatus: V.error, loading: !1 });
      this.updateLastResult(o, n), $t(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? v(v({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var r = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !ft(this.queryInfo.networkStatus))) {
        var r = this.queryInfo.getDiff();
        r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(o, a) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(o, a) : n;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new It(), t;
  })(Q)
);
ra(cr);
function yl(e) {
  globalThis.__DEV__ !== !1 && D.error(33, e.message, e.stack);
}
function Ia(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && D.debug(34, e);
}
function Zr(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var ht = new (nt ? WeakMap : Map)();
function Qr(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return ht.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (ht.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
var Ur = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      ht.has(n) || (ht.set(n, 0), Qr(n, "evict"), Qr(n, "modify"), Qr(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || V.loading;
      return this.variables && this.networkStatus !== V.loading && !B(this.variables, t.variables) && (r = V.setVariables), B(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, r = this.getDiffOptions();
      if (this.lastDiff && B(r, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = fe("canonizeResults", function() {
        return t.cache.diff(r);
      });
      return this.updateLastDiff(i, r), i;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && fe("getLastError", function() {
        var o;
        return (o = r.observableQuery) === null || o === void 0 ? void 0 : o.getLastError();
      }) || (this.updateLastDiff(t), B(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var r = this.observableQuery;
        r && r.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = v(v({}, this.getDiffOptions(t)), { watcher: this, callback: function(o) {
          return r.setDiff(o);
        } });
        (!this.lastWatch || !B(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === ht.get(this.cache) && B(r, n.variables) && B(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var o = this, a, s = new Qe(), u = Ie(t.errors) ? t.errors.slice(0) : [];
      if ((a = this.observableQuery) === null || a === void 0 || a.resetNotifications(), "incremental" in t && Ie(t.incremental)) {
        var c = na(this.getDiff().result, t);
        t.data = c;
      } else if ("hasNext" in t && t.hasNext) {
        var l = this.getDiff();
        t.data = s.merge(l.result, t.data);
      }
      this.graphQLErrors = u, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (yn(t, n.errorPolicy) ? this.cache.performTransaction(function(h) {
        if (o.shouldWrite(t, n.variables))
          h.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), o.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: ht.get(o.cache)
          };
        else if (o.lastDiff && o.lastDiff.diff.complete) {
          t.data = o.lastDiff.diff.result;
          return;
        }
        var d = o.getDiffOptions(n.variables), f = fe("canonizeResults", function() {
          return h.diff(d);
        });
        !o.stopped && B(o.variables, n.variables) && o.updateWatch(n.variables), o.updateLastDiff(f, d), f.complete && (t.data = f.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = V.ready;
    }, e.prototype.markError = function(t) {
      var r;
      return this.networkStatus = V.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function yn(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !ar(e);
  return !n && r && e.data && (n = !0), n;
}
var gl = Object.prototype.hasOwnProperty, Gi = /* @__PURE__ */ Object.create(null), bl = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new zo(
        Fe["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Ne(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new Jo(
        function(o) {
          return r.cache.transformDocument(o);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(ve(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return xe(this, arguments, void 0, function(r) {
        var n, i, o, a, s, u, c, l = r.mutation, h = r.variables, d = r.optimisticResponse, f = r.updateQueries, p = r.refetchQueries, m = p === void 0 ? [] : p, g = r.awaitRefetchQueries, y = g === void 0 ? !1 : g, _ = r.update, w = r.onQueryUpdated, S = r.fetchPolicy, O = S === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.fetchPolicy) || "network-only" : S, T = r.errorPolicy, F = T === void 0 ? ((c = this.defaultOptions.mutate) === null || c === void 0 ? void 0 : c.errorPolicy) || "none" : T, R = r.keepRootFields, x = r.context;
        return Me(this, function(L) {
          switch (L.label) {
            case 0:
              return D(l, 36), D(O === "network-only" || O === "no-cache", 37), n = this.generateMutationId(), l = this.cache.transformForLink(this.transform(l)), i = this.getDocumentInfo(l).hasClientExports, h = this.getVariables(l, h), i ? [4, this.localState.addExportedVariables(l, h, x)] : [3, 2];
            case 1:
              h = L.sent(), L.label = 2;
            case 2:
              return o = this.mutationStore && (this.mutationStore[n] = {
                mutation: l,
                variables: h,
                loading: !0,
                error: null
              }), a = d && this.markMutationOptimistic(d, {
                mutationId: n,
                document: l,
                variables: h,
                fetchPolicy: O,
                errorPolicy: F,
                context: x,
                updateQueries: f,
                update: _,
                keepRootFields: R
              }), this.broadcastQueries(), s = this, [2, new Promise(function(Ee, ye) {
                return xr(s.getObservableFromLink(l, v(v({}, x), { optimisticResponse: a ? d : void 0 }), h, {}, !1), function(Y) {
                  if (ar(Y) && F === "none")
                    throw new $e({
                      graphQLErrors: sn(Y)
                    });
                  o && (o.loading = !1, o.error = null);
                  var he = v({}, Y);
                  return typeof m == "function" && (m = m(he)), F === "ignore" && ar(he) && delete he.errors, s.markMutationResult({
                    mutationId: n,
                    result: he,
                    document: l,
                    variables: h,
                    fetchPolicy: O,
                    errorPolicy: F,
                    context: x,
                    update: _,
                    updateQueries: f,
                    awaitRefetchQueries: y,
                    refetchQueries: m,
                    removeOptimistic: a ? n : void 0,
                    onQueryUpdated: w,
                    keepRootFields: R
                  });
                }).subscribe({
                  next: function(Y) {
                    s.broadcastQueries(), (!("hasNext" in Y) || Y.hasNext === !1) && Ee(v(v({}, Y), { data: s.maskOperation({
                      document: l,
                      data: Y.data,
                      fetchPolicy: O,
                      id: n
                    }) }));
                  },
                  error: function(Y) {
                    o && (o.loading = !1, o.error = Y), a && s.cache.removeOptimistic(n), s.broadcastQueries(), ye(Y instanceof $e ? Y : new $e({
                      networkError: Y
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, o = [], a = t.fetchPolicy === "no-cache";
      if (!a && yn(i, t.errorPolicy)) {
        if (vt(i) || o.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), vt(i) && Ie(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), u = void 0;
          s.result && (u = na(s.result, i)), typeof u < "u" && (i.data = u, o.push({
            result: u,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var c = t.updateQueries;
        c && this.queries.forEach(function(h, d) {
          var f = h.observableQuery, p = f && f.queryName;
          if (!(!p || !gl.call(c, p))) {
            var m = c[p], g = n.queries.get(d), y = g.document, _ = g.variables, w = r.diff({
              query: y,
              variables: _,
              returnPartialData: !0,
              optimistic: !1
            }), S = w.result, O = w.complete;
            if (O && S) {
              var T = m(S, {
                mutationResult: i,
                queryName: y && At(y) || void 0,
                queryVariables: _
              });
              T && o.push({
                result: T,
                dataId: "ROOT_QUERY",
                query: y,
                variables: _
              });
            }
          }
        });
      }
      if (o.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var l = [];
        if (this.refetchQueries({
          updateCache: function(h) {
            a || o.forEach(function(m) {
              return h.write(m);
            });
            var d = t.update, f = !cc(i) || vt(i) && !i.hasNext;
            if (d) {
              if (!a) {
                var p = h.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = v(v({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              f && d(h, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !a && !t.keepRootFields && f && h.modify({
              id: "ROOT_MUTATION",
              fields: function(m, g) {
                var y = g.fieldName, _ = g.DELETE;
                return y === "__typename" ? m : _;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(h) {
          return l.push(h);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(l).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: Gi }) : t;
      return i === Gi ? !1 : (this.cache.recordOptimisticTransaction(function(o) {
        try {
          n.markMutationResult(v(v({}, r), { result: { data: i } }), o);
        } catch (a) {
          globalThis.__DEV__ !== !1 && D.error(a);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: Us(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: qt(["nonreactive"], t),
          nonReactiveQuery: Wu(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: Ko([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: Tn(et(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: v(v({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? v(v({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return v(v({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = v(v({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new Ur(this), i = new cr({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, cr.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), D(t.query, 38), D(t.query.kind === "Document", 39), D(!t.returnPartialData, 40), D(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(r, v(v({}, t), { query: i })).then(function(o) {
        return o && v(v({}, o), { data: n.maskOperation({
          document: i,
          data: o.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(ve(42)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = V.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), o.set(s, !1);
        else if (bu(s)) {
          var u = Le(r.transform(s));
          i.set(u, At(s)), o.set(u, !1);
        } else W(s) && s.query && a.add(s);
      }), this.queries.forEach(function(s, u) {
        var c = s.observableQuery, l = s.document;
        if (c) {
          if (t === "all") {
            n.set(u, c);
            return;
          }
          var h = c.queryName, d = c.options.fetchPolicy;
          if (d === "standby" || t === "active" && !c.hasObservers())
            return;
          (t === "active" || h && o.has(h) || l && o.has(Le(l))) && (n.set(u, c), h && o.set(h, !0), l && o.set(Le(l), !0));
        }
      }), a.size && a.forEach(function(s) {
        var u = Kr("legacyOneTimeQuery"), c = r.getOrCreateQuery(u).init({
          document: s.query,
          variables: s.variables
        }), l = new cr({
          queryManager: r,
          queryInfo: c,
          options: v(v({}, s), { fetchPolicy: "network-only" })
        });
        D(l.queryId === u), c.setObservableQuery(l), n.set(u, l);
      }), globalThis.__DEV__ !== !1 && o.size && o.forEach(function(s, u) {
        if (!s) {
          var c = i.get(u);
          c ? globalThis.__DEV__ !== !1 && D.warn(43, c) : globalThis.__DEV__ !== !1 && D.warn(44);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, o) {
        var a = i.options.fetchPolicy;
        fe("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || a !== "standby" && a !== "cache-only") && n.push(i.refetch()), (r.queries.get(o) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, o = t.fetchPolicy, a = t.errorPolicy, s = a === void 0 ? "none" : a, u = t.context, c = u === void 0 ? {} : u, l = t.extensions, h = l === void 0 ? {} : l;
      n = this.transform(n), i = this.getVariables(n, i);
      var d = function(p) {
        return r.getObservableFromLink(n, c, p, h).map(function(m) {
          o !== "no-cache" && (yn(m, s) && r.cache.write({
            query: n,
            result: m.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var g = ar(m), y = zc(m);
          if (g || y) {
            var _ = {};
            if (g && (_.graphQLErrors = m.errors), y && (_.protocolErrors = m.extensions[An]), s === "none" || y)
              throw new $e(_);
          }
          return s === "ignore" && delete m.errors, m;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var f = this.localState.addExportedVariables(n, i, c).then(d);
        return new Q(function(p) {
          var m = null;
          return f.then(function(g) {
            return m = g.subscribe(p);
          }, p.error), function() {
            return m && m.unsubscribe();
          };
        });
      }
      return d(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var r;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var r;
        return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, o) {
      var a = this, s;
      o === void 0 && (o = (s = r == null ? void 0 : r.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var u, c = this.getDocumentInfo(t), l = c.serverQuery, h = c.clientQuery;
      if (l) {
        var d = this, f = d.inFlightLinkObservables, p = d.link, m = {
          query: l,
          variables: n,
          operationName: At(l) || void 0,
          context: this.prepareContext(v(v({}, r), { forceFetch: !o })),
          extensions: i
        };
        if (r = m.context, o) {
          var g = Le(l), y = Ve(n), _ = f.lookup(g, y);
          if (u = _.observable, !u) {
            var w = new ut([
              ln(p, m)
            ]);
            u = _.observable = w, w.beforeNext(function S(O, T) {
              O === "next" && "hasNext" in T && T.hasNext ? w.beforeNext(S) : f.remove(g, y);
            });
          }
        } else
          u = new ut([
            ln(p, m)
          ]);
      } else
        u = new ut([Q.of({ data: {} })]), r = this.prepareContext(r);
      return h && (u = xr(u, function(S) {
        return a.localState.runResolvers({
          document: h,
          remoteResult: S,
          context: r,
          variables: n
        });
      })), u;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(n.query);
      return xr(this.getObservableFromLink(o, n.context, n.variables), function(a) {
        var s = sn(a), u = s.length > 0, c = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (u && c === "none")
            throw t.markError(new $e({
              graphQLErrors: s
            }));
          t.markResult(a, o, n, r), t.markReady();
        }
        var l = {
          data: a.data,
          loading: !1,
          networkStatus: V.ready
        };
        return u && c === "none" && (l.data = void 0), u && c !== "ignore" && (l.errors = s, l.networkStatus = V.error), l;
      }, function(a) {
        var s = oa(a) ? a : new $e({ networkError: a });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var o = this;
      n === void 0 && (n = V.loading), i === void 0 && (i = r.query);
      var a = this.getVariables(i, r.variables), s = this.defaultOptions.watchQuery, u = r.fetchPolicy, c = u === void 0 ? s && s.fetchPolicy || "cache-first" : u, l = r.errorPolicy, h = l === void 0 ? s && s.errorPolicy || "none" : l, d = r.returnPartialData, f = d === void 0 ? !1 : d, p = r.notifyOnNetworkStatusChange, m = p === void 0 ? !1 : p, g = r.context, y = g === void 0 ? {} : g, _ = Object.assign({}, r, {
        query: i,
        variables: a,
        fetchPolicy: c,
        errorPolicy: h,
        returnPartialData: f,
        notifyOnNetworkStatusChange: m,
        context: y
      }), w = function(R) {
        _.variables = R;
        var x = o.fetchQueryByPolicy(t, _, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          _.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          x.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), x
        );
      }, S = function() {
        return o.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(R) {
        S(), setTimeout(function() {
          return O.cancel(R);
        });
      });
      var O, T;
      if (this.getDocumentInfo(_.query).hasClientExports)
        O = new ut(this.localState.addExportedVariables(_.query, _.variables, _.context).then(w).then(function(R) {
          return R.sources;
        })), T = !0;
      else {
        var F = w(_.variables);
        T = F.fromLink, O = new ut(F.sources);
      }
      return O.promise.then(S, S), {
        concast: O,
        fromLink: T
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, o = t.optimistic, a = o === void 0 ? !1 : o, s = t.removeOptimistic, u = s === void 0 ? a ? Kr("refetchQueries") : void 0 : s, c = t.onQueryUpdated, l = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(d, f) {
        l.set(f, {
          oq: d,
          lastDiff: (r.queries.get(f) || d.queryInfo).getDiff()
        });
      });
      var h = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: a && u || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: u,
        onWatchUpdated: function(d, f, p) {
          var m = d.watcher instanceof Ur && d.watcher.observableQuery;
          if (m) {
            if (c) {
              l.delete(m.queryId);
              var g = c(m, f, p);
              return g === !0 && (g = m.refetch()), g !== !1 && h.set(m, g), g;
            }
            c !== null && l.set(m.queryId, { oq: m, lastDiff: p, diff: f });
          }
        }
      }), l.size && l.forEach(function(d, f) {
        var p = d.oq, m = d.lastDiff, g = d.diff, y;
        c && (g || (g = fe("canonizeResults", function() {
          return r.cache.diff(p.queryInfo.getDiffOptions());
        })), y = c(p, g, m)), (!c || y === !0) && (y = p.refetch()), y !== !1 && h.set(p, y), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), u && this.cache.removeOptimistic(u), h;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, o = t.document, a = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, u = t.id, c = (r = et(o)) === null || r === void 0 ? void 0 : r.operation, l = ((n = c == null ? void 0 : c[0]) !== null && n !== void 0 ? n : "o") + u;
        this.dataMasking && s === "no-cache" && !tu(o) && !this.noCacheWarningsByQueryId.has(l) && (this.noCacheWarningsByQueryId.add(l), globalThis.__DEV__ !== !1 && D.warn(
          45,
          (i = At(o)) !== null && i !== void 0 ? i : "Unnamed ".concat(c ?? "operation")
        ));
      }
      return this.dataMasking ? Xc(a, o, this.cache) : a;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? da(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, o = r.query, a = r.variables, s = r.fetchPolicy, u = r.refetchWritePolicy, c = r.errorPolicy, l = r.returnPartialData, h = r.context, d = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: o,
        variables: a,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, m = function(S, O) {
        O === void 0 && (O = t.networkStatus || V.loading);
        var T = S.result;
        globalThis.__DEV__ !== !1 && !l && !B(T, {}) && Ia(S.missing);
        var F = function(R) {
          return Q.of(v({ data: R, loading: ft(O), networkStatus: O }, S.complete ? null : { partial: !0 }));
        };
        return T && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
          document: o,
          remoteResult: { data: T },
          context: h,
          variables: a,
          onlyRunForcedResolvers: !0
        }).then(function(R) {
          return F(R.data || void 0);
        }) : c === "none" && O === V.refetch && Array.isArray(S.missing) ? F(void 0) : F(T);
      }, g = s === "no-cache" ? 0 : n === V.refetch && u !== "merge" ? 1 : 2, y = function() {
        return i.getResultsFromLink(t, g, {
          query: o,
          variables: a,
          context: h,
          fetchPolicy: s,
          errorPolicy: c
        });
      }, _ = d && typeof f == "number" && f !== n && ft(n);
      switch (s) {
        default:
        case "cache-first": {
          var w = p();
          return w.complete ? {
            fromLink: !1,
            sources: [m(w, t.markReady())]
          } : l || _ ? {
            fromLink: !0,
            sources: [m(w), y()]
          } : { fromLink: !0, sources: [y()] };
        }
        case "cache-and-network": {
          var w = p();
          return w.complete || l || _ ? {
            fromLink: !0,
            sources: [m(w), y()]
          } : { fromLink: !0, sources: [y()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [m(p(), t.markReady())]
          };
        case "network-only":
          return _ ? {
            fromLink: !0,
            sources: [m(p()), y()]
          } : { fromLink: !0, sources: [y()] };
        case "no-cache":
          return _ ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [m(t.getDiff()), y()]
          } : { fromLink: !0, sources: [y()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Ur(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return v(v(v({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), _l = (
  /** @class */
  (function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, o = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = vi(r.resolvers, n);
      }) : this.resolvers = vi(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return xe(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, o = r.context, a = r.variables, s = r.onlyRunForcedResolvers, u = s === void 0 ? !1 : s;
        return Me(this, function(c) {
          return n ? [2, this.resolveDocument(n, i.data, o, a, this.fragmentMatcher, u).then(function(l) {
            return v(v({}, i), { data: l.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return qt(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return Ho(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return v(v({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return xe(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Me(this, function(o) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(a) {
            return v(v({}, n), a.exportedVariables);
          })] : [2, v({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return Te(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return wr;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: Bu(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return xe(this, arguments, void 0, function(n, i, o, a, s, u) {
        var c, l, h, d, f, p, m, g, y, _, w;
        return o === void 0 && (o = {}), a === void 0 && (a = {}), s === void 0 && (s = function() {
          return !0;
        }), u === void 0 && (u = !1), Me(this, function(S) {
          return c = Dt(n), l = Tt(n), h = St(l), d = this.collectSelectionsToResolve(c, h), f = c.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", m = this, g = m.cache, y = m.client, _ = {
            fragmentMap: h,
            context: v(v({}, o), { cache: g, client: y }),
            variables: a,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: d,
            onlyRunForcedResolvers: u
          }, w = !1, [2, this.resolveSelectionSet(c.selectionSet, w, i, _).then(function(O) {
            return {
              result: O,
              exportedVariables: _.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return xe(this, void 0, void 0, function() {
        var o, a, s, u, c, l = this;
        return Me(this, function(h) {
          return o = i.fragmentMap, a = i.context, s = i.variables, u = [n], c = function(d) {
            return xe(l, void 0, void 0, function() {
              var f, p;
              return Me(this, function(m) {
                return !r && !i.selectionsToResolve.has(d) ? [
                  2
                  /*return*/
                ] : Gt(d, s) ? qe(d) ? [2, this.resolveField(d, r, n, i).then(function(g) {
                  var y;
                  typeof g < "u" && u.push((y = {}, y[Ce(d)] = g, y));
                })] : (Pu(d) ? f = d : (f = o[d.name.value], D(f, 21, d.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, i.fragmentMatcher(n, p, a)) ? [2, this.resolveSelectionSet(f.selectionSet, r, n, i).then(function(g) {
                  u.push(g);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(c)).then(function() {
            return Dr(u);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return xe(this, void 0, void 0, function() {
        var o, a, s, u, c, l, h, d, f, p = this;
        return Me(this, function(m) {
          return n ? (o = i.variables, a = t.name.value, s = Ce(t), u = a !== s, c = n[s] || n[a], l = Promise.resolve(c), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (h = n.__typename || i.defaultOperationType, d = this.resolvers && this.resolvers[h], d && (f = d[u ? a : s], f && (l = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            Mn.withValue(this.cache, f, [
              n,
              Sr(t, o),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, l.then(function(g) {
            var y, _;
            if (g === void 0 && (g = c), t.directives && t.directives.forEach(function(S) {
              S.name.value === "export" && S.arguments && S.arguments.forEach(function(O) {
                O.name.value === "as" && O.value.kind === "StringValue" && (i.exportedVariables[O.value.value] = g);
              });
            }), !t.selectionSet || g == null)
              return g;
            var w = (_ = (y = t.directives) === null || y === void 0 ? void 0 : y.some(function(S) {
              return S.name.value === "client";
            })) !== null && _ !== void 0 ? _ : !1;
            if (Array.isArray(g))
              return p.resolveSubSelectedArray(t, r || w, g, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || w, g, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var o = this;
      return Promise.all(n.map(function(a) {
        if (a === null)
          return null;
        if (Array.isArray(a))
          return o.resolveSubSelectedArray(t, r, a, i);
        if (t.selectionSet)
          return o.resolveSelectionSet(t.selectionSet, r, a, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(a) {
        return !Array.isArray(a);
      }, i = this.selectionsToResolveCache;
      function o(a) {
        if (!i.has(a)) {
          var s = /* @__PURE__ */ new Set();
          i.set(a, s), Te(a, {
            Directive: function(u, c, l, h, d) {
              u.name.value === "client" && d.forEach(function(f) {
                n(f) && ai(f) && s.add(f);
              });
            },
            FragmentSpread: function(u, c, l, h, d) {
              var f = r[u.name.value];
              D(f, 22, u.name.value);
              var p = o(f);
              p.size > 0 && (d.forEach(function(m) {
                n(m) && ai(m) && s.add(m);
              }), s.add(u), p.forEach(function(m) {
                s.add(m);
              }));
            }
          });
        }
        return i.get(a);
      }
      return o(t);
    }, e;
  })()
), Ki = !1, za = (
  /** @class */
  (function() {
    function e(t) {
      var r = this, n, i, o;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw ve(16);
      var a = t.uri, s = t.credentials, u = t.headers, c = t.cache, l = t.documentTransform, h = t.ssrMode, d = h === void 0 ? !1 : h, f = t.ssrForceFetchDelay, p = f === void 0 ? 0 : f, m = t.connectToDevTools, g = t.queryDeduplication, y = g === void 0 ? !0 : g, _ = t.defaultOptions, w = t.defaultContext, S = t.assumeImmutableResults, O = S === void 0 ? c.assumeImmutableResults : S, T = t.resolvers, F = t.typeDefs, R = t.fragmentMatcher, x = t.clientAwareness, L = t.name, Ee = t.version, ye = t.devtools, Y = t.dataMasking;
      globalThis.__DEV__ !== !1 && (re(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), re(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), re(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), re(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), re(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), re(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), re(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && D.warn(17));
      var he = t.link;
      he || (he = a ? new sa({ uri: a, credentials: s, headers: u }) : Be.empty()), this.link = he, this.cache = c, this.disableNetworkFetches = d || p > 0, this.queryDeduplication = y, this.defaultOptions = _ || /* @__PURE__ */ Object.create(null), this.typeDefs = F, this.devtoolsConfig = v(v({}, ye), { enabled: (n = ye == null ? void 0 : ye.enabled) !== null && n !== void 0 ? n : m }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), p && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, p), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = En, this.localState = new _l({
        cache: c,
        client: this,
        resolvers: T,
        fragmentMatcher: R
      }), this.queryManager = new bl({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: w,
        documentTransform: l,
        queryDeduplication: y,
        ssrMode: d,
        dataMasking: !!Y,
        clientAwareness: {
          name: (i = x == null ? void 0 : x.name) !== null && i !== void 0 ? i : L,
          version: (o = x == null ? void 0 : x.version) !== null && o !== void 0 ? o : Ee
        },
        localState: this.localState,
        assumeImmutableResults: O,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !Ki && globalThis.__DEV__ !== !1 && (Ki = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, o = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? o = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (o = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), o && globalThis.__DEV__ !== !1 && D.log("Download the Apollo DevTools for a better development experience: %s", o);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = Mr(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = v(v({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (re(t, "canonizeResults", "client.watchQuery"), re(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = Mr(this.defaultOptions.query, t)), D(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = v(v({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (re(t, "canonizeResults", "client.query"), re(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && D.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = Mr(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return v(v({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(v(v({}, t), (r = {}, r[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return ln(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(a, s) {
        n.push(s), i.push(a);
      });
      var o = Promise.all(i);
      return o.queries = n, o.results = i, o.catch(function(a) {
        globalThis.__DEV__ !== !1 && D.debug(20, a);
      }), o;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (za.prototype.getMemoryInternals = lu);
function wl(e) {
  return W(e) && "code" in e && "reason" in e;
}
function El(e) {
  var t;
  return W(e) && ((t = e.target) === null || t === void 0 ? void 0 : t.readyState) === WebSocket.CLOSED;
}
var kl = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.client = r, n;
    }
    return t.prototype.request = function(r) {
      var n = this;
      return new Q(function(i) {
        return n.client.subscribe(v(v({}, r), { query: Le(r.query) }), {
          next: i.next.bind(i),
          complete: i.complete.bind(i),
          error: function(o) {
            if (o instanceof Error)
              return i.error(o);
            var a = wl(o);
            return a || El(o) ? i.error(
              // reason will be available on clean closes
              new Error("Socket closed".concat(a ? " with event ".concat(o.code) : "").concat(a ? " ".concat(o.reason) : ""))
            ) : i.error(new $e({
              graphQLErrors: Array.isArray(o) ? o : [o]
            }));
          }
          // casting around a wrong type in graphql-ws, which incorrectly expects `Sink<ExecutionResult>`
        });
      });
    }, t;
  })(Be)
);
function ge(e) {
  return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
function He(e) {
  return ge(e) === "object";
}
function Sl(e) {
  return Array.isArray(e) && // must be at least one error
  e.length > 0 && // error has at least a message
  e.every((t) => "message" in t);
}
function Hi(e, t) {
  return e.length < 124 ? e : t;
}
const Ol = "graphql-transport-ws";
var _e;
(function(e) {
  e[e.InternalServerError = 4500] = "InternalServerError", e[e.InternalClientError = 4005] = "InternalClientError", e[e.BadRequest = 4400] = "BadRequest", e[e.BadResponse = 4004] = "BadResponse", e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e[e.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", e[e.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", e[e.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", e[e.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", e[e.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(_e || (_e = {}));
var ne;
(function(e) {
  e.ConnectionInit = "connection_init", e.ConnectionAck = "connection_ack", e.Ping = "ping", e.Pong = "pong", e.Subscribe = "subscribe", e.Next = "next", e.Error = "error", e.Complete = "complete";
})(ne || (ne = {}));
function Ra(e) {
  if (!He(e))
    throw new Error(`Message is expected to be an object, but got ${ge(e)}`);
  if (!e.type)
    throw new Error("Message is missing the 'type' property");
  if (typeof e.type != "string")
    throw new Error(`Message is expects the 'type' property to be a string, but got ${ge(e.type)}`);
  switch (e.type) {
    case ne.ConnectionInit:
    case ne.ConnectionAck:
    case ne.Ping:
    case ne.Pong: {
      if (e.payload != null && !He(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${e.payload}"`);
      break;
    }
    case ne.Subscribe: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ge(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!He(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object, but got ${ge(e.payload)}`);
      if (typeof e.payload.query != "string")
        throw new Error(`"${e.type}" message payload expects the 'query' property to be a string, but got ${ge(e.payload.query)}`);
      if (e.payload.variables != null && !He(e.payload.variables))
        throw new Error(`"${e.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${ge(e.payload.variables)}`);
      if (e.payload.operationName != null && ge(e.payload.operationName) !== "string")
        throw new Error(`"${e.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${ge(e.payload.operationName)}`);
      if (e.payload.extensions != null && !He(e.payload.extensions))
        throw new Error(`"${e.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${ge(e.payload.extensions)}`);
      break;
    }
    case ne.Next: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ge(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!He(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object, but got ${ge(e.payload)}`);
      break;
    }
    case ne.Error: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ge(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!Sl(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(e.payload)}`);
      break;
    }
    case ne.Complete: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ge(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      break;
    }
    default:
      throw new Error(`Invalid message 'type' property "${e.type}"`);
  }
  return e;
}
function Tl(e, t) {
  return Ra(typeof e == "string" ? JSON.parse(e, t) : e);
}
function Nt(e, t) {
  return Ra(e), JSON.stringify(e, t);
}
var yt = function(e) {
  return this instanceof yt ? (this.v = e, this) : new yt(e);
}, Dl = function(e, t, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(e, t || []), i, o = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), s("next"), s("throw"), s("return", a), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function a(f) {
    return function(p) {
      return Promise.resolve(p).then(f, h);
    };
  }
  function s(f, p) {
    n[f] && (i[f] = function(m) {
      return new Promise(function(g, y) {
        o.push([f, m, g, y]) > 1 || u(f, m);
      });
    }, p && (i[f] = p(i[f])));
  }
  function u(f, p) {
    try {
      c(n[f](p));
    } catch (m) {
      d(o[0][3], m);
    }
  }
  function c(f) {
    f.value instanceof yt ? Promise.resolve(f.value.v).then(l, h) : d(o[0][2], f);
  }
  function l(f) {
    u("next", f);
  }
  function h(f) {
    u("throw", f);
  }
  function d(f, p) {
    f(p), o.shift(), o.length && u(o[0][0], o[0][1]);
  }
};
function Il(e) {
  const {
    url: t,
    connectionParams: r,
    lazy: n = !0,
    onNonLazyError: i = console.error,
    lazyCloseTimeout: o = 0,
    keepAlive: a = 0,
    disablePong: s,
    connectionAckWaitTimeout: u = 0,
    retryAttempts: c = 5,
    retryWait: l = async function(U) {
      let C = 1e3;
      for (let M = 0; M < U; M++)
        C *= 2;
      await new Promise((M) => setTimeout(M, C + // add random timeout from 300ms to 3s
      Math.floor(Math.random() * 2700 + 300)));
    },
    shouldRetry: h = Br,
    isFatalConnectionProblem: d,
    on: f,
    webSocketImpl: p,
    /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */
    generateID: m = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (U) => {
        const C = Math.random() * 16 | 0;
        return (U == "x" ? C : C & 3 | 8).toString(16);
      });
    },
    jsonMessageReplacer: g,
    jsonMessageReviver: y
  } = e;
  let _;
  if (p) {
    if (!Rl(p))
      throw new Error("Invalid WebSocket implementation provided");
    _ = p;
  } else typeof WebSocket < "u" ? _ = WebSocket : typeof global < "u" ? _ = global.WebSocket || // @ts-expect-error: Support more browsers
  global.MozWebSocket : typeof window < "u" && (_ = window.WebSocket || // @ts-expect-error: Support more browsers
  window.MozWebSocket);
  if (!_)
    throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  const w = _, S = (() => {
    const N = /* @__PURE__ */ (() => {
      const C = {};
      return {
        on(M, A) {
          return C[M] = A, () => {
            delete C[M];
          };
        },
        emit(M) {
          var A;
          "id" in M && ((A = C[M.id]) === null || A === void 0 || A.call(C, M));
        }
      };
    })(), U = {
      connecting: f != null && f.connecting ? [f.connecting] : [],
      opened: f != null && f.opened ? [f.opened] : [],
      connected: f != null && f.connected ? [f.connected] : [],
      ping: f != null && f.ping ? [f.ping] : [],
      pong: f != null && f.pong ? [f.pong] : [],
      message: f != null && f.message ? [N.emit, f.message] : [N.emit],
      closed: f != null && f.closed ? [f.closed] : [],
      error: f != null && f.error ? [f.error] : []
    };
    return {
      onMessage: N.on,
      on(C, M) {
        const A = U[C];
        return A.push(M), () => {
          A.splice(A.indexOf(M), 1);
        };
      },
      emit(C, ...M) {
        for (const A of [...U[C]])
          A(...M);
      }
    };
  })();
  function O(N) {
    const U = [
      // errors are fatal and more critical than close events, throw them first
      S.on("error", (C) => {
        U.forEach((M) => M()), N(C);
      }),
      // closes can be graceful and not fatal, throw them second (if error didnt throw)
      S.on("closed", (C) => {
        U.forEach((M) => M()), N(C);
      })
    ];
  }
  let T, F = 0, R, x = !1, L = 0, Ee = !1;
  async function ye() {
    clearTimeout(R);
    const [N, U] = await (T ?? (T = new Promise((A, ce) => (async () => {
      if (x) {
        if (await l(L), !F)
          return T = void 0, ce({ code: 1e3, reason: "All Subscriptions Gone" });
        L++;
      }
      S.emit("connecting", x);
      const $ = new w(typeof t == "function" ? await t() : t, Ol);
      let de, Re;
      function Ge() {
        isFinite(a) && a > 0 && (clearTimeout(Re), Re = setTimeout(() => {
          $.readyState === w.OPEN && ($.send(Nt({ type: ne.Ping })), S.emit("ping", !1, void 0));
        }, a));
      }
      O((le) => {
        T = void 0, clearTimeout(de), clearTimeout(Re), ce(le), le instanceof Yi && ($.close(4499, "Terminated"), $.onerror = null, $.onclose = null);
      }), $.onerror = (le) => S.emit("error", le), $.onclose = (le) => S.emit("closed", le), $.onopen = async () => {
        try {
          S.emit("opened", $);
          const le = typeof r == "function" ? await r() : r;
          if ($.readyState !== w.OPEN)
            return;
          $.send(Nt(le ? {
            type: ne.ConnectionInit,
            payload: le
          } : {
            type: ne.ConnectionInit
            // payload is completely absent if not provided
          }, g)), isFinite(u) && u > 0 && (de = setTimeout(() => {
            $.close(_e.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
          }, u)), Ge();
        } catch (le) {
          S.emit("error", le), $.close(_e.InternalClientError, Hi(le instanceof Error ? le.message : new Error(le).message, "Internal client error"));
        }
      };
      let ot = !1;
      $.onmessage = ({ data: le }) => {
        try {
          const oe = Tl(le, y);
          if (S.emit("message", oe), oe.type === "ping" || oe.type === "pong") {
            S.emit(oe.type, !0, oe.payload), oe.type === "pong" ? Ge() : s || ($.send(Nt(oe.payload ? {
              type: ne.Pong,
              payload: oe.payload
            } : {
              type: ne.Pong
              // payload is completely absent if not provided
            })), S.emit("pong", !1, oe.payload));
            return;
          }
          if (ot)
            return;
          if (oe.type !== ne.ConnectionAck)
            throw new Error(`First message cannot be of type ${oe.type}`);
          clearTimeout(de), ot = !0, S.emit("connected", $, oe.payload, x), x = !1, L = 0, A([
            $,
            new Promise((Nm, ks) => O(ks))
          ]);
        } catch (oe) {
          $.onmessage = null, S.emit("error", oe), $.close(_e.BadResponse, Hi(oe instanceof Error ? oe.message : new Error(oe).message, "Bad response"));
        }
      };
    })())));
    N.readyState === w.CLOSING && await U;
    let C = () => {
    };
    const M = new Promise((A) => C = A);
    return [
      N,
      C,
      Promise.race([
        // wait for
        M.then(() => {
          if (!F) {
            const A = () => N.close(1e3, "Normal Closure");
            isFinite(o) && o > 0 ? R = setTimeout(() => {
              N.readyState === w.OPEN && A();
            }, o) : A();
          }
        }),
        // or
        U
      ])
    ];
  }
  function Y(N) {
    if (Br(N) && (zl(N.code) || [
      _e.InternalServerError,
      _e.InternalClientError,
      _e.BadRequest,
      _e.BadResponse,
      _e.Unauthorized,
      // CloseCode.Forbidden, might grant access out after retry
      _e.SubprotocolNotAcceptable,
      // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
      // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
      _e.SubscriberAlreadyExists,
      _e.TooManyInitialisationRequests
      // 4499, // Terminated, probably because the socket froze, we want to retry
    ].includes(N.code)))
      throw N;
    if (Ee)
      return !1;
    if (Br(N) && N.code === 1e3)
      return F > 0;
    if (!c || L >= c || !h(N) || d != null && d(N))
      throw N;
    return x = !0;
  }
  n || (async () => {
    for (F++; ; )
      try {
        const [, , N] = await ye();
        await N;
      } catch (N) {
        try {
          if (!Y(N))
            return;
        } catch (U) {
          return i == null ? void 0 : i(U);
        }
      }
  })();
  function he(N, U) {
    const C = m(N);
    let M = !1, A = !1, ce = () => {
      F--, M = !0;
    };
    return (async () => {
      for (F++; ; )
        try {
          const [$, de, Re] = await ye();
          if (M)
            return de();
          const Ge = S.onMessage(C, (ot) => {
            switch (ot.type) {
              case ne.Next: {
                U.next(ot.payload);
                return;
              }
              case ne.Error: {
                A = !0, M = !0, U.error(ot.payload), ce();
                return;
              }
              case ne.Complete: {
                M = !0, ce();
                return;
              }
            }
          });
          $.send(Nt({
            id: C,
            type: ne.Subscribe,
            payload: N
          }, g)), ce = () => {
            !M && $.readyState === w.OPEN && $.send(Nt({
              id: C,
              type: ne.Complete
            }, g)), F--, M = !0, de();
          }, await Re.finally(Ge);
          return;
        } catch ($) {
          if (!Y($))
            return;
        }
    })().then(() => {
      A || U.complete();
    }).catch(($) => {
      U.error($);
    }), () => {
      M || ce();
    };
  }
  return {
    on: S.on,
    subscribe: he,
    iterate(N) {
      const U = [], C = {
        done: !1,
        error: null,
        resolve: () => {
        }
      }, M = he(N, {
        next(ce) {
          U.push(ce), C.resolve();
        },
        error(ce) {
          C.done = !0, C.error = ce, C.resolve();
        },
        complete() {
          C.done = !0, C.resolve();
        }
      }), A = (function() {
        return Dl(this, arguments, function* () {
          for (; ; ) {
            for (U.length || (yield yt(new Promise((de) => C.resolve = de))); U.length; )
              yield yield yt(U.shift());
            if (C.error)
              throw C.error;
            if (C.done)
              return yield yt(void 0);
          }
        });
      })();
      return A.throw = async (ce) => (C.done || (C.done = !0, C.error = ce, C.resolve()), { done: !0, value: void 0 }), A.return = async () => (M(), { done: !0, value: void 0 }), A;
    },
    async dispose() {
      if (Ee = !0, T) {
        const [N] = await T;
        N.close(1e3, "Normal Closure");
      }
    },
    terminate() {
      T && S.emit("closed", new Yi());
    }
  };
}
class Yi extends Error {
  constructor() {
    super(...arguments), this.name = "TerminatedCloseEvent", this.message = "4499: Terminated", this.code = 4499, this.reason = "Terminated", this.wasClean = !1;
  }
}
function Br(e) {
  return He(e) && "code" in e && "reason" in e;
}
function zl(e) {
  return [
    1e3,
    // Normal Closure is not an erroneous close code
    1001,
    // Going Away
    1006,
    // Abnormal Closure
    1005,
    // No Status Received
    1012,
    // Service Restart
    1013,
    // Try Again Later
    1014
    // Bad Gateway
  ].includes(e) ? !1 : e >= 1e3 && e <= 1999;
}
function Rl(e) {
  return typeof e == "function" && "constructor" in e && "CLOSED" in e && "CLOSING" in e && "CONNECTING" in e && "OPEN" in e;
}
const Pl = (e, t) => {
  const r = new sa({
    credentials: "include",
    uri: e
  }), n = new kl(
    Il({
      url: t,
      lazy: !0
    })
  ), i = gc(
    ({ query: a }) => {
      const s = Dt(a);
      return s.kind === "OperationDefinition" && s.operation === "subscription";
    },
    n,
    r
  );
  return new za({
    cache: new Da(),
    link: yc([i]),
    credentials: "include"
  });
};
class $m {
  constructor(t, r) {
    at(this, "endpoint");
    at(this, "apolloClient");
    at(this, "uploadToS3", async (t, r, n) => {
      const i = {};
      return new Q((o) => {
        const a = new FormData(), { url: s } = i.data.presignedFormData, u = JSON.parse(
          i.data.presignedFormData.fields
        );
        Object.keys(u).forEach((l) => {
          a.append(l, u[l]);
        }), a.append("file", t);
        const c = new XMLHttpRequest();
        c.open("POST", s), c.upload.addEventListener("progress", (l) => {
          const h = l.loaded / l.total;
          o.next({ progress: h });
        }), c.upload.addEventListener("load", () => {
          c.upload.removeEventListener("progress", () => null), o.complete();
        }), c.send(a);
      });
    });
    this.endpoint = t;
    try {
      this.apolloClient = Pl(
        `${t}/graphql`,
        `${r}`
      );
    } catch (n) {
      throw console.error(n), new Error("Failed to create apollo client");
    }
  }
  downloadS3File(t, r = null) {
    return new Promise((n) => {
      const i = `${this.endpoint}/download?bucket=${t.bucket}&key=${t.key}&isFolder=${t.isFolder ? 1 : 0}${r ? `&limit=${r}` : ""}`, o = new XMLHttpRequest();
      o.withCredentials = !0, o.open("GET", i, !0), o.setRequestHeader("Content-Type", "application/json"), o.responseType = "blob", o.addEventListener("load", function() {
        return n(this.response);
      }), o.send(JSON.stringify({ ...t, limit: r }));
    });
  }
  async refreshToken() {
    fetch(`${this.endpoint}/refreshToken`, {
      method: "POST",
      credentials: "include"
    });
  }
}
function E(e, t, r) {
  function n(s, u) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: u,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, u);
    const c = a.prototype, l = Object.keys(c);
    for (let h = 0; h < l.length; h++) {
      const d = l[h];
      d in s || (s[d] = c[d].bind(s));
    }
  }
  const i = (r == null ? void 0 : r.Parent) ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var u;
    const c = r != null && r.Parent ? new o() : this;
    n(c, s), (u = c._zod).deferred ?? (u.deferred = []);
    for (const l of c._zod.deferred)
      l();
    return c;
  }
  return Object.defineProperty(a, "init", { value: n }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var u, c;
      return r != null && r.Parent && s instanceof r.Parent ? !0 : (c = (u = s == null ? void 0 : s._zod) == null ? void 0 : u.traits) == null ? void 0 : c.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class gt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Pa extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Fa = {};
function tt(e) {
  return Fa;
}
function Ca(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, i]) => t.indexOf(+n) === -1).map(([n, i]) => i);
}
function gn(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Vn(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function qn(e) {
  return e == null;
}
function Zn(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function Fl(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = t.toString();
  let i = (n.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(n)) {
    const u = n.match(/\d?e-(\d?)/);
    u != null && u[1] && (i = Number.parseInt(u[1]));
  }
  const o = r > i ? r : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const Xi = Symbol("evaluating");
function Z(e, t, r) {
  let n;
  Object.defineProperty(e, t, {
    get() {
      if (n !== Xi)
        return n === void 0 && (n = Xi, n = r()), n;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function it(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function We(...e) {
  const t = {};
  for (const r of e) {
    const n = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, n);
  }
  return Object.defineProperties({}, t);
}
function eo(e) {
  return JSON.stringify(e);
}
function Cl(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Na = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function vr(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Nl = Vn(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Bt(e) {
  if (vr(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const r = t.prototype;
  return !(vr(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function Aa(e) {
  return Bt(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Al = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function kt(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Je(e, t, r) {
  const n = new e._zod.constr(t ?? e._zod.def);
  return (!t || r != null && r.parent) && (n._zod.parent = e), n;
}
function P(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function xl(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const Ml = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function jl(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const o = We(e._zod.def, {
    get shape() {
      const a = {};
      for (const s in t) {
        if (!(s in r.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && (a[s] = r.shape[s]);
      }
      return it(this, "shape", a), a;
    },
    checks: []
  });
  return Je(e, o);
}
function $l(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const o = We(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape };
      for (const s in t) {
        if (!(s in r.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && delete a[s];
      }
      return it(this, "shape", a), a;
    },
    checks: []
  });
  return Je(e, o);
}
function Ll(e, t) {
  if (!Bt(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0) {
    const o = e._zod.def.shape;
    for (const a in t)
      if (Object.getOwnPropertyDescriptor(o, a) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const i = We(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return it(this, "shape", o), o;
    }
  });
  return Je(e, i);
}
function Vl(e, t) {
  if (!Bt(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const r = We(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t };
      return it(this, "shape", n), n;
    }
  });
  return Je(e, r);
}
function ql(e, t) {
  const r = We(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t._zod.def.shape };
      return it(this, "shape", n), n;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Je(e, r);
}
function Zl(e, t, r) {
  const i = t._zod.def.checks;
  if (i && i.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const a = We(t._zod.def, {
    get shape() {
      const s = t._zod.def.shape, u = { ...s };
      if (r)
        for (const c in r) {
          if (!(c in s))
            throw new Error(`Unrecognized key: "${c}"`);
          r[c] && (u[c] = e ? new e({
            type: "optional",
            innerType: s[c]
          }) : s[c]);
        }
      else
        for (const c in s)
          u[c] = e ? new e({
            type: "optional",
            innerType: s[c]
          }) : s[c];
      return it(this, "shape", u), u;
    },
    checks: []
  });
  return Je(t, a);
}
function Ql(e, t, r) {
  const n = We(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (r)
        for (const a in r) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          r[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return it(this, "shape", o), o;
    }
  });
  return Je(t, n);
}
function dt(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (((r = e.issues[n]) == null ? void 0 : r.continue) !== !0)
      return !0;
  return !1;
}
function xa(e, t) {
  return t.map((r) => {
    var n;
    return (n = r).path ?? (n.path = []), r.path.unshift(e), r;
  });
}
function er(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function rt(e, t, r) {
  var i, o, a, s, u, c;
  const n = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const l = er((a = (o = (i = e.inst) == null ? void 0 : i._zod.def) == null ? void 0 : o.error) == null ? void 0 : a.call(o, e)) ?? er((s = t == null ? void 0 : t.error) == null ? void 0 : s.call(t, e)) ?? er((u = r.customError) == null ? void 0 : u.call(r, e)) ?? er((c = r.localeError) == null ? void 0 : c.call(r, e)) ?? "Invalid input";
    n.message = l;
  }
  return delete n.inst, delete n.continue, t != null && t.reportInput || delete n.input, n;
}
function Qn(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Wt(...e) {
  const [t, r, n] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: n
  } : { ...t };
}
const Ma = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, gn, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, ja = E("$ZodError", Ma), $a = E("$ZodError", Ma, { Parent: Error });
function Ul(e, t = (r) => r.message) {
  const r = {}, n = [];
  for (const i of e.issues)
    i.path.length > 0 ? (r[i.path[0]] = r[i.path[0]] || [], r[i.path[0]].push(t(i))) : n.push(t(i));
  return { formErrors: n, fieldErrors: r };
}
function Bl(e, t = (r) => r.message) {
  const r = { _errors: [] }, n = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => n({ issues: a }));
      else if (o.code === "invalid_key")
        n({ issues: o.issues });
      else if (o.code === "invalid_element")
        n({ issues: o.issues });
      else if (o.path.length === 0)
        r._errors.push(t(o));
      else {
        let a = r, s = 0;
        for (; s < o.path.length; ) {
          const u = o.path[s];
          s === o.path.length - 1 ? (a[u] = a[u] || { _errors: [] }, a[u]._errors.push(t(o))) : a[u] = a[u] || { _errors: [] }, a = a[u], s++;
        }
      }
  };
  return n(e), r;
}
const Un = (e) => (t, r, n, i) => {
  const o = n ? Object.assign(n, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: r, issues: [] }, o);
  if (a instanceof Promise)
    throw new gt();
  if (a.issues.length) {
    const s = new ((i == null ? void 0 : i.Err) ?? e)(a.issues.map((u) => rt(u, o, tt())));
    throw Na(s, i == null ? void 0 : i.callee), s;
  }
  return a.value;
}, Bn = (e) => async (t, r, n, i) => {
  const o = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: r, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new ((i == null ? void 0 : i.Err) ?? e)(a.issues.map((u) => rt(u, o, tt())));
    throw Na(s, i == null ? void 0 : i.callee), s;
  }
  return a.value;
}, Ir = (e) => (t, r, n) => {
  const i = n ? { ...n, async: !1 } : { async: !1 }, o = t._zod.run({ value: r, issues: [] }, i);
  if (o instanceof Promise)
    throw new gt();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? ja)(o.issues.map((a) => rt(a, i, tt())))
  } : { success: !0, data: o.value };
}, Wl = /* @__PURE__ */ Ir($a), zr = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: r, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => rt(a, i, tt())))
  } : { success: !0, data: o.value };
}, Jl = /* @__PURE__ */ zr($a), Gl = (e) => (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Un(e)(t, r, i);
}, Kl = (e) => (t, r, n) => Un(e)(t, r, n), Hl = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Bn(e)(t, r, i);
}, Yl = (e) => async (t, r, n) => Bn(e)(t, r, n), Xl = (e) => (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Ir(e)(t, r, i);
}, ef = (e) => (t, r, n) => Ir(e)(t, r, n), tf = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return zr(e)(t, r, i);
}, rf = (e) => async (t, r, n) => zr(e)(t, r, n), nf = /^[cC][^\s-]{8,}$/, of = /^[0-9a-z]+$/, af = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, sf = /^[0-9a-vA-V]{20}$/, uf = /^[A-Za-z0-9]{27}$/, cf = /^[a-zA-Z0-9_-]{21}$/, lf = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, ff = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, to = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, hf = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, df = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function pf() {
  return new RegExp(df, "u");
}
const vf = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, mf = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, yf = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, gf = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, bf = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, La = /^[A-Za-z0-9_-]*$/, _f = /^\+[1-9]\d{6,14}$/, Va = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", wf = /* @__PURE__ */ new RegExp(`^${Va}$`);
function qa(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Ef(e) {
  return new RegExp(`^${qa(e)}$`);
}
function kf(e) {
  const t = qa({ precision: e.precision }), r = ["Z"];
  e.local && r.push(""), e.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const n = `${t}(?:${r.join("|")})`;
  return new RegExp(`^${Va}T(?:${n})$`);
}
const Sf = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Of = /^-?\d+$/, Tf = /^-?\d+(?:\.\d+)?$/, Df = /^(?:true|false)$/i, If = /^[^A-Z]*$/, zf = /^[^a-z]*$/, be = /* @__PURE__ */ E("$ZodCheck", (e, t) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = t, (r = e._zod).onattach ?? (r.onattach = []);
}), Za = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Qa = /* @__PURE__ */ E("$ZodCheckLessThan", (e, t) => {
  be.init(e, t);
  const r = Za[typeof t.value];
  e._zod.onattach.push((n) => {
    const i = n._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (n) => {
    (t.inclusive ? n.value <= t.value : n.value < t.value) || n.issues.push({
      origin: r,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Ua = /* @__PURE__ */ E("$ZodCheckGreaterThan", (e, t) => {
  be.init(e, t);
  const r = Za[typeof t.value];
  e._zod.onattach.push((n) => {
    const i = n._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (n) => {
    (t.inclusive ? n.value >= t.value : n.value > t.value) || n.issues.push({
      origin: r,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Rf = /* @__PURE__ */ E("$ZodCheckMultipleOf", (e, t) => {
  be.init(e, t), e._zod.onattach.push((r) => {
    var n;
    (n = r._zod.bag).multipleOf ?? (n.multipleOf = t.value);
  }), e._zod.check = (r) => {
    if (typeof r.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % t.value === BigInt(0) : Fl(r.value, t.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Pf = /* @__PURE__ */ E("$ZodCheckNumberFormat", (e, t) => {
  var a;
  be.init(e, t), t.format = t.format || "float64";
  const r = (a = t.format) == null ? void 0 : a.includes("int"), n = r ? "int" : "number", [i, o] = Ml[t.format];
  e._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.format = t.format, u.minimum = i, u.maximum = o, r && (u.pattern = Of);
  }), e._zod.check = (s) => {
    const u = s.value;
    if (r) {
      if (!Number.isInteger(u)) {
        s.issues.push({
          expected: n,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: u,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(u)) {
        u > 0 ? s.issues.push({
          input: u,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: u,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    u < i && s.issues.push({
      origin: "number",
      input: u,
      code: "too_small",
      minimum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), u > o && s.issues.push({
      origin: "number",
      input: u,
      code: "too_big",
      maximum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), Ff = /* @__PURE__ */ E("$ZodCheckMaxLength", (e, t) => {
  var r;
  be.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !qn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (n._zod.bag.maximum = t.maximum);
  }), e._zod.check = (n) => {
    const i = n.value;
    if (i.length <= t.maximum)
      return;
    const a = Qn(i);
    n.issues.push({
      origin: a,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Cf = /* @__PURE__ */ E("$ZodCheckMinLength", (e, t) => {
  var r;
  be.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !qn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (n._zod.bag.minimum = t.minimum);
  }), e._zod.check = (n) => {
    const i = n.value;
    if (i.length >= t.minimum)
      return;
    const a = Qn(i);
    n.issues.push({
      origin: a,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Nf = /* @__PURE__ */ E("$ZodCheckLengthEquals", (e, t) => {
  var r;
  be.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !qn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (n) => {
    const i = n.value, o = i.length;
    if (o === t.length)
      return;
    const a = Qn(i), s = o > t.length;
    n.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Rr = /* @__PURE__ */ E("$ZodCheckStringFormat", (e, t) => {
  var r, n;
  be.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (r = e._zod).check ?? (r.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (n = e._zod).check ?? (n.check = () => {
  });
}), Af = /* @__PURE__ */ E("$ZodCheckRegex", (e, t) => {
  Rr.init(e, t), e._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), xf = /* @__PURE__ */ E("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = If), Rr.init(e, t);
}), Mf = /* @__PURE__ */ E("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = zf), Rr.init(e, t);
}), jf = /* @__PURE__ */ E("$ZodCheckIncludes", (e, t) => {
  be.init(e, t);
  const r = kt(t.includes), n = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${r}` : r);
  t.pattern = n, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), $f = /* @__PURE__ */ E("$ZodCheckStartsWith", (e, t) => {
  be.init(e, t);
  const r = new RegExp(`^${kt(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.startsWith(t.prefix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Lf = /* @__PURE__ */ E("$ZodCheckEndsWith", (e, t) => {
  be.init(e, t);
  const r = new RegExp(`.*${kt(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.endsWith(t.suffix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Vf = /* @__PURE__ */ E("$ZodCheckOverwrite", (e, t) => {
  be.init(e, t), e._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
});
class qf {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((a) => a), i = Math.min(...n.map((a) => a.length - a.trimStart().length)), o = n.map((a) => a.slice(i)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of o)
      this.content.push(a);
  }
  compile() {
    const t = Function, r = this == null ? void 0 : this.args, i = [...((this == null ? void 0 : this.content) ?? [""]).map((o) => `  ${o}`)];
    return new t(...r, i.join(`
`));
  }
}
const Zf = {
  major: 4,
  minor: 3,
  patch: 6
}, ee = /* @__PURE__ */ E("$ZodType", (e, t) => {
  var i;
  var r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Zf;
  const n = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && n.unshift(e);
  for (const o of n)
    for (const a of o._zod.onattach)
      a(e);
  if (n.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (i = e._zod.deferred) == null || i.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, u, c) => {
      let l = dt(s), h;
      for (const d of u) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (l)
          continue;
        const f = s.issues.length, p = d._zod.check(s);
        if (p instanceof Promise && (c == null ? void 0 : c.async) === !1)
          throw new gt();
        if (h || p instanceof Promise)
          h = (h ?? Promise.resolve()).then(async () => {
            await p, s.issues.length !== f && (l || (l = dt(s, f)));
          });
        else {
          if (s.issues.length === f)
            continue;
          l || (l = dt(s, f));
        }
      }
      return h ? h.then(() => s) : s;
    }, a = (s, u, c) => {
      if (dt(s))
        return s.aborted = !0, s;
      const l = o(u, n, c);
      if (l instanceof Promise) {
        if (c.async === !1)
          throw new gt();
        return l.then((h) => e._zod.parse(h, c));
      }
      return e._zod.parse(l, c);
    };
    e._zod.run = (s, u) => {
      if (u.skipChecks)
        return e._zod.parse(s, u);
      if (u.direction === "backward") {
        const l = e._zod.parse({ value: s.value, issues: [] }, { ...u, skipChecks: !0 });
        return l instanceof Promise ? l.then((h) => a(h, s, u)) : a(l, s, u);
      }
      const c = e._zod.parse(s, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new gt();
        return c.then((l) => o(l, n, u));
      }
      return o(c, n, u);
    };
  }
  Z(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = Wl(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return Jl(e, o).then((u) => {
          var c;
          return u.success ? { value: u.data } : { issues: (c = u.error) == null ? void 0 : c.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Wn = /* @__PURE__ */ E("$ZodString", (e, t) => {
  var r;
  ee.init(e, t), e._zod.pattern = [...((r = e == null ? void 0 : e._zod.bag) == null ? void 0 : r.patterns) ?? []].pop() ?? Sf(e._zod.bag), e._zod.parse = (n, i) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), J = /* @__PURE__ */ E("$ZodStringFormat", (e, t) => {
  Rr.init(e, t), Wn.init(e, t);
}), Qf = /* @__PURE__ */ E("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = ff), J.init(e, t);
}), Uf = /* @__PURE__ */ E("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = to(n));
  } else
    t.pattern ?? (t.pattern = to());
  J.init(e, t);
}), Bf = /* @__PURE__ */ E("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = hf), J.init(e, t);
}), Wf = /* @__PURE__ */ E("$ZodURL", (e, t) => {
  J.init(e, t), e._zod.check = (r) => {
    try {
      const n = r.value.trim(), i = new URL(n);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? r.value = i.href : r.value = n;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Jf = /* @__PURE__ */ E("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = pf()), J.init(e, t);
}), Gf = /* @__PURE__ */ E("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = cf), J.init(e, t);
}), Kf = /* @__PURE__ */ E("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = nf), J.init(e, t);
}), Hf = /* @__PURE__ */ E("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = of), J.init(e, t);
}), Yf = /* @__PURE__ */ E("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = af), J.init(e, t);
}), Xf = /* @__PURE__ */ E("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = sf), J.init(e, t);
}), eh = /* @__PURE__ */ E("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = uf), J.init(e, t);
}), th = /* @__PURE__ */ E("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = kf(t)), J.init(e, t);
}), rh = /* @__PURE__ */ E("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = wf), J.init(e, t);
}), nh = /* @__PURE__ */ E("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Ef(t)), J.init(e, t);
}), ih = /* @__PURE__ */ E("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = lf), J.init(e, t);
}), oh = /* @__PURE__ */ E("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = vf), J.init(e, t), e._zod.bag.format = "ipv4";
}), ah = /* @__PURE__ */ E("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = mf), J.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), sh = /* @__PURE__ */ E("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = yf), J.init(e, t);
}), uh = /* @__PURE__ */ E("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = gf), J.init(e, t), e._zod.check = (r) => {
    const n = r.value.split("/");
    try {
      if (n.length !== 2)
        throw new Error();
      const [i, o] = n;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Ba(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const ch = /* @__PURE__ */ E("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = bf), J.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (r) => {
    Ba(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function lh(e) {
  if (!La.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (n) => n === "-" ? "+" : "/"), r = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Ba(r);
}
const fh = /* @__PURE__ */ E("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = La), J.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (r) => {
    lh(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), hh = /* @__PURE__ */ E("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = _f), J.init(e, t);
});
function dh(e, t = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [n] = r;
    if (!n)
      return !1;
    const i = JSON.parse(atob(n));
    return !("typ" in i && (i == null ? void 0 : i.typ) !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const ph = /* @__PURE__ */ E("$ZodJWT", (e, t) => {
  J.init(e, t), e._zod.check = (r) => {
    dh(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Wa = /* @__PURE__ */ E("$ZodNumber", (e, t) => {
  ee.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Tf, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const i = r.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return r;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), r;
  };
}), vh = /* @__PURE__ */ E("$ZodNumberFormat", (e, t) => {
  Pf.init(e, t), Wa.init(e, t);
}), mh = /* @__PURE__ */ E("$ZodBoolean", (e, t) => {
  ee.init(e, t), e._zod.pattern = Df, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = !!r.value;
      } catch {
      }
    const i = r.value;
    return typeof i == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), r;
  };
}), yh = /* @__PURE__ */ E("$ZodUnknown", (e, t) => {
  ee.init(e, t), e._zod.parse = (r) => r;
}), gh = /* @__PURE__ */ E("$ZodNever", (e, t) => {
  ee.init(e, t), e._zod.parse = (r, n) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
});
function ro(e, t, r) {
  e.issues.length && t.issues.push(...xa(r, e.issues)), t.value[r] = e.value;
}
const bh = /* @__PURE__ */ E("$ZodArray", (e, t) => {
  ee.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value;
    if (!Array.isArray(i))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), r;
    r.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], u = t.element._zod.run({
        value: s,
        issues: []
      }, n);
      u instanceof Promise ? o.push(u.then((c) => ro(c, r, a))) : ro(u, r, a);
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
});
function mr(e, t, r, n, i) {
  if (e.issues.length) {
    if (i && !(r in n))
      return;
    t.issues.push(...xa(r, e.issues));
  }
  e.value === void 0 ? r in n && (t.value[r] = void 0) : t.value[r] = e.value;
}
function Ja(e) {
  var n, i, o, a;
  const t = Object.keys(e.shape);
  for (const s of t)
    if (!((a = (o = (i = (n = e.shape) == null ? void 0 : n[s]) == null ? void 0 : i._zod) == null ? void 0 : o.traits) != null && a.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const r = xl(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(r)
  };
}
function Ga(e, t, r, n, i, o) {
  const a = [], s = i.keySet, u = i.catchall._zod, c = u.def.type, l = u.optout === "optional";
  for (const h in t) {
    if (s.has(h))
      continue;
    if (c === "never") {
      a.push(h);
      continue;
    }
    const d = u.run({ value: t[h], issues: [] }, n);
    d instanceof Promise ? e.push(d.then((f) => mr(f, r, h, t, l))) : mr(d, r, h, t, l);
  }
  return a.length && r.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => r) : r;
}
const _h = /* @__PURE__ */ E("$ZodObject", (e, t) => {
  ee.init(e, t);
  const r = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(r != null && r.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const u = { ...s };
        return Object.defineProperty(t, "shape", {
          value: u
        }), u;
      }
    });
  }
  const n = Vn(() => Ja(t));
  Z(e._zod, "propValues", () => {
    const s = t.shape, u = {};
    for (const c in s) {
      const l = s[c]._zod;
      if (l.values) {
        u[c] ?? (u[c] = /* @__PURE__ */ new Set());
        for (const h of l.values)
          u[c].add(h);
      }
    }
    return u;
  });
  const i = vr, o = t.catchall;
  let a;
  e._zod.parse = (s, u) => {
    a ?? (a = n.value);
    const c = s.value;
    if (!i(c))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: c,
        inst: e
      }), s;
    s.value = {};
    const l = [], h = a.shape;
    for (const d of a.keys) {
      const f = h[d], p = f._zod.optout === "optional", m = f._zod.run({ value: c[d], issues: [] }, u);
      m instanceof Promise ? l.push(m.then((g) => mr(g, s, d, c, p))) : mr(m, s, d, c, p);
    }
    return o ? Ga(l, c, s, u, n.value, e) : l.length ? Promise.all(l).then(() => s) : s;
  };
}), wh = /* @__PURE__ */ E("$ZodObjectJIT", (e, t) => {
  _h.init(e, t);
  const r = e._zod.parse, n = Vn(() => Ja(t)), i = (d) => {
    var w;
    const f = new qf(["shape", "payload", "ctx"]), p = n.value, m = (S) => {
      const O = eo(S);
      return `shape[${O}]._zod.run({ value: input[${O}], issues: [] }, ctx)`;
    };
    f.write("const input = payload.value;");
    const g = /* @__PURE__ */ Object.create(null);
    let y = 0;
    for (const S of p.keys)
      g[S] = `key_${y++}`;
    f.write("const newResult = {};");
    for (const S of p.keys) {
      const O = g[S], T = eo(S), F = d[S], R = ((w = F == null ? void 0 : F._zod) == null ? void 0 : w.optout) === "optional";
      f.write(`const ${O} = ${m(S)};`), R ? f.write(`
        if (${O}.issues.length) {
          if (${T} in input) {
            payload.issues = payload.issues.concat(${O}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${T}, ...iss.path] : [${T}]
            })));
          }
        }
        
        if (${O}.value === undefined) {
          if (${T} in input) {
            newResult[${T}] = undefined;
          }
        } else {
          newResult[${T}] = ${O}.value;
        }
        
      `) : f.write(`
        if (${O}.issues.length) {
          payload.issues = payload.issues.concat(${O}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${T}, ...iss.path] : [${T}]
          })));
        }
        
        if (${O}.value === undefined) {
          if (${T} in input) {
            newResult[${T}] = undefined;
          }
        } else {
          newResult[${T}] = ${O}.value;
        }
        
      `);
    }
    f.write("payload.value = newResult;"), f.write("return payload;");
    const _ = f.compile();
    return (S, O) => _(d, S, O);
  };
  let o;
  const a = vr, s = !Fa.jitless, c = s && Nl.value, l = t.catchall;
  let h;
  e._zod.parse = (d, f) => {
    h ?? (h = n.value);
    const p = d.value;
    return a(p) ? s && c && (f == null ? void 0 : f.async) === !1 && f.jitless !== !0 ? (o || (o = i(t.shape)), d = o(d, f), l ? Ga([], p, d, f, h, e) : d) : r(d, f) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), d);
  };
});
function no(e, t, r, n) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !dt(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: e.map((o) => o.issues.map((a) => rt(a, n, tt())))
  }), t);
}
const Eh = /* @__PURE__ */ E("$ZodUnion", (e, t) => {
  ee.init(e, t), Z(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), Z(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), Z(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), Z(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => Zn(o.source)).join("|")})$`);
    }
  });
  const r = t.options.length === 1, n = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (r)
      return n(i, o);
    let a = !1;
    const s = [];
    for (const u of t.options) {
      const c = u._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (c instanceof Promise)
        s.push(c), a = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return a ? Promise.all(s).then((u) => no(u, i, e, o)) : no(s, i, e, o);
  };
}), kh = /* @__PURE__ */ E("$ZodIntersection", (e, t) => {
  ee.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value, o = t.left._zod.run({ value: i, issues: [] }, n), a = t.right._zod.run({ value: i, issues: [] }, n);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([u, c]) => io(r, u, c)) : io(r, o, a);
  };
});
function bn(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Bt(e) && Bt(t)) {
    const r = Object.keys(t), n = Object.keys(e).filter((o) => r.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of n) {
      const a = bn(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n], o = t[n], a = bn(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [n, ...a.mergeErrorPath]
        };
      r.push(a.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function io(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const u of s.keys)
        n.has(u) || n.set(u, {}), n.get(u).l = !0;
    } else
      e.issues.push(s);
  for (const s of r.issues)
    if (s.code === "unrecognized_keys")
      for (const u of s.keys)
        n.has(u) || n.set(u, {}), n.get(u).r = !0;
    else
      e.issues.push(s);
  const o = [...n].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), dt(e))
    return e;
  const a = bn(t.value, r.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const Sh = /* @__PURE__ */ E("$ZodEnum", (e, t) => {
  ee.init(e, t);
  const r = Ca(t.entries), n = new Set(r);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${r.filter((i) => Al.has(typeof i)).map((i) => typeof i == "string" ? kt(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return n.has(a) || i.issues.push({
      code: "invalid_value",
      values: r,
      input: a,
      inst: e
    }), i;
  };
}), Oh = /* @__PURE__ */ E("$ZodLiteral", (e, t) => {
  if (ee.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const r = new Set(t.values);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${t.values.map((n) => typeof n == "string" ? kt(n) : n ? kt(n.toString()) : String(n)).join("|")})$`), e._zod.parse = (n, i) => {
    const o = n.value;
    return r.has(o) || n.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), n;
  };
}), Th = /* @__PURE__ */ E("$ZodTransform", (e, t) => {
  ee.init(e, t), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      throw new Pa(e.constructor.name);
    const i = t.transform(r.value, r);
    if (n.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((a) => (r.value = a, r));
    if (i instanceof Promise)
      throw new gt();
    return r.value = i, r;
  };
});
function oo(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Ka = /* @__PURE__ */ E("$ZodOptional", (e, t) => {
  ee.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Z(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Z(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Zn(r.source)})?$`) : void 0;
  }), e._zod.parse = (r, n) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(r, n);
      return i instanceof Promise ? i.then((o) => oo(o, r.value)) : oo(i, r.value);
    }
    return r.value === void 0 ? r : t.innerType._zod.run(r, n);
  };
}), Dh = /* @__PURE__ */ E("$ZodExactOptional", (e, t) => {
  Ka.init(e, t), Z(e._zod, "values", () => t.innerType._zod.values), Z(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (r, n) => t.innerType._zod.run(r, n);
}), Ih = /* @__PURE__ */ E("$ZodNullable", (e, t) => {
  ee.init(e, t), Z(e._zod, "optin", () => t.innerType._zod.optin), Z(e._zod, "optout", () => t.innerType._zod.optout), Z(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Zn(r.source)}|null)$`) : void 0;
  }), Z(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (r, n) => r.value === null ? r : t.innerType._zod.run(r, n);
}), zh = /* @__PURE__ */ E("$ZodDefault", (e, t) => {
  ee.init(e, t), e._zod.optin = "optional", Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => ao(o, t)) : ao(i, t);
  };
});
function ao(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Rh = /* @__PURE__ */ E("$ZodPrefault", (e, t) => {
  ee.init(e, t), e._zod.optin = "optional", Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => (n.direction === "backward" || r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, n));
}), Ph = /* @__PURE__ */ E("$ZodNonOptional", (e, t) => {
  ee.init(e, t), Z(e._zod, "values", () => {
    const r = t.innerType._zod.values;
    return r ? new Set([...r].filter((n) => n !== void 0)) : void 0;
  }), e._zod.parse = (r, n) => {
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => so(o, e)) : so(i, e);
  };
});
function so(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Fh = /* @__PURE__ */ E("$ZodCatch", (e, t) => {
  ee.init(e, t), Z(e._zod, "optin", () => t.innerType._zod.optin), Z(e._zod, "optout", () => t.innerType._zod.optout), Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => (r.value = o.value, o.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: o.issues.map((a) => rt(a, n, tt()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = i.value, i.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: i.issues.map((o) => rt(o, n, tt()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), Ch = /* @__PURE__ */ E("$ZodPipe", (e, t) => {
  ee.init(e, t), Z(e._zod, "values", () => t.in._zod.values), Z(e._zod, "optin", () => t.in._zod.optin), Z(e._zod, "optout", () => t.out._zod.optout), Z(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (r, n) => {
    if (n.direction === "backward") {
      const o = t.out._zod.run(r, n);
      return o instanceof Promise ? o.then((a) => tr(a, t.in, n)) : tr(o, t.in, n);
    }
    const i = t.in._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => tr(o, t.out, n)) : tr(i, t.out, n);
  };
});
function tr(e, t, r) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, r);
}
const Nh = /* @__PURE__ */ E("$ZodReadonly", (e, t) => {
  ee.init(e, t), Z(e._zod, "propValues", () => t.innerType._zod.propValues), Z(e._zod, "values", () => t.innerType._zod.values), Z(e._zod, "optin", () => {
    var r, n;
    return (n = (r = t.innerType) == null ? void 0 : r._zod) == null ? void 0 : n.optin;
  }), Z(e._zod, "optout", () => {
    var r, n;
    return (n = (r = t.innerType) == null ? void 0 : r._zod) == null ? void 0 : n.optout;
  }), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then(uo) : uo(i);
  };
});
function uo(e) {
  return e.value = Object.freeze(e.value), e;
}
const Ah = /* @__PURE__ */ E("$ZodCustom", (e, t) => {
  be.init(e, t), ee.init(e, t), e._zod.parse = (r, n) => r, e._zod.check = (r) => {
    const n = r.value, i = t.fn(n);
    if (i instanceof Promise)
      return i.then((o) => co(o, r, n, e));
    co(i, r, n, e);
  };
});
function co(e, t, r, n) {
  if (!e) {
    const i = {
      code: "custom",
      input: r,
      inst: n,
      // incorporates params.error into issue reporting
      path: [...n._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !n._zod.def.abort
      // params: inst._zod.def.params,
    };
    n._zod.def.params && (i.params = n._zod.def.params), t.issues.push(Wt(i));
  }
}
var lo;
class xh {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...r) {
    const n = r[0];
    return this._map.set(t, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const r = this._map.get(t);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(t), this;
  }
  get(t) {
    const r = t._zod.parent;
    if (r) {
      const n = { ...this.get(r) ?? {} };
      delete n.id;
      const i = { ...n, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Mh() {
  return new xh();
}
(lo = globalThis).__zod_globalRegistry ?? (lo.__zod_globalRegistry = Mh());
const Mt = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function jh(e, t) {
  return new e({
    type: "string",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $h(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fo(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Lh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Vh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Zh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Qh(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Uh(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bh(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wh(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Jh(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Gh(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Kh(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Hh(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Yh(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Xh(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ed(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function td(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rd(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nd(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function id(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function od(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ad(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sd(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ud(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cd(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ld(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fd(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hd(e, t) {
  return new e({
    type: "boolean",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dd(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function pd(e, t) {
  return new e({
    type: "never",
    ...P(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ho(e, t) {
  return new Qa({
    check: "less_than",
    ...P(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Wr(e, t) {
  return new Qa({
    check: "less_than",
    ...P(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function po(e, t) {
  return new Ua({
    check: "greater_than",
    ...P(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Jr(e, t) {
  return new Ua({
    check: "greater_than",
    ...P(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function vo(e, t) {
  return new Rf({
    check: "multiple_of",
    ...P(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ha(e, t) {
  return new Ff({
    check: "max_length",
    ...P(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function yr(e, t) {
  return new Cf({
    check: "min_length",
    ...P(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ya(e, t) {
  return new Nf({
    check: "length_equals",
    ...P(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function vd(e, t) {
  return new Af({
    check: "string_format",
    format: "regex",
    ...P(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function md(e) {
  return new xf({
    check: "string_format",
    format: "lowercase",
    ...P(e)
  });
}
// @__NO_SIDE_EFFECTS__
function yd(e) {
  return new Mf({
    check: "string_format",
    format: "uppercase",
    ...P(e)
  });
}
// @__NO_SIDE_EFFECTS__
function gd(e, t) {
  return new jf({
    check: "string_format",
    format: "includes",
    ...P(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function bd(e, t) {
  return new $f({
    check: "string_format",
    format: "starts_with",
    ...P(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function _d(e, t) {
  return new Lf({
    check: "string_format",
    format: "ends_with",
    ...P(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function zt(e) {
  return new Vf({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function wd(e) {
  return /* @__PURE__ */ zt((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function Ed() {
  return /* @__PURE__ */ zt((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function kd() {
  return /* @__PURE__ */ zt((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Sd() {
  return /* @__PURE__ */ zt((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Od() {
  return /* @__PURE__ */ zt((e) => Cl(e));
}
// @__NO_SIDE_EFFECTS__
function Td(e, t, r) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...P(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Dd(e, t, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...P(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Id(e) {
  const t = /* @__PURE__ */ zd((r) => (r.addIssue = (n) => {
    if (typeof n == "string")
      r.issues.push(Wt(n, r.value, t._zod.def));
    else {
      const i = n;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = r.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), r.issues.push(Wt(i));
    }
  }, e(r.value, r)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function zd(e, t) {
  const r = new be({
    check: "custom",
    ...P(t)
  });
  return r._zod.check = e, r;
}
function Xa(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? Mt,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function ue(e, t, r = { path: [], schemaPath: [] }) {
  var l, h;
  var n;
  const i = e._zod.def, o = t.seen.get(e);
  if (o)
    return o.count++, r.schemaPath.includes(e) && (o.cycle = r.path), o.schema;
  const a = { schema: {}, count: 1, cycle: void 0, path: r.path };
  t.seen.set(e, a);
  const s = (h = (l = e._zod).toJSONSchema) == null ? void 0 : h.call(l);
  if (s)
    a.schema = s;
  else {
    const d = {
      ...r,
      schemaPath: [...r.schemaPath, e],
      path: r.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, a.schema, d);
    else {
      const p = a.schema, m = t.processors[i.type];
      if (!m)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
      m(e, t, p, d);
    }
    const f = e._zod.parent;
    f && (a.ref || (a.ref = f), ue(f, t, d), t.seen.get(f).isParent = !0);
  }
  const u = t.metadataRegistry.get(e);
  return u && Object.assign(a.schema, u), t.io === "input" && pe(e) && (delete a.schema.examples, delete a.schema.default), t.io === "input" && a.schema._prefault && ((n = a.schema).default ?? (n.default = a.schema._prefault)), delete a.schema._prefault, t.seen.get(e).schema;
}
function es(e, t) {
  var a, s, u, c;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = /* @__PURE__ */ new Map();
  for (const l of e.seen.entries()) {
    const h = (a = e.metadataRegistry.get(l[0])) == null ? void 0 : a.id;
    if (h) {
      const d = n.get(h);
      if (d && d !== l[0])
        throw new Error(`Duplicate schema id "${h}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      n.set(h, l[0]);
    }
  }
  const i = (l) => {
    var m;
    const h = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const g = (m = e.external.registry.get(l[0])) == null ? void 0 : m.id, y = e.external.uri ?? ((w) => w);
      if (g)
        return { ref: y(g) };
      const _ = l[1].defId ?? l[1].schema.id ?? `schema${e.counter++}`;
      return l[1].defId = _, { defId: _, ref: `${y("__shared")}#/${h}/${_}` };
    }
    if (l[1] === r)
      return { ref: "#" };
    const f = `#/${h}/`, p = l[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: p, ref: f + p };
  }, o = (l) => {
    if (l[1].schema.$ref)
      return;
    const h = l[1], { ref: d, defId: f } = i(l);
    h.def = { ...h.schema }, f && (h.defId = f);
    const p = h.schema;
    for (const m in p)
      delete p[m];
    p.$ref = d;
  };
  if (e.cycles === "throw")
    for (const l of e.seen.entries()) {
      const h = l[1];
      if (h.cycle)
        throw new Error(`Cycle detected: #/${(s = h.cycle) == null ? void 0 : s.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const l of e.seen.entries()) {
    const h = l[1];
    if (t === l[0]) {
      o(l);
      continue;
    }
    if (e.external) {
      const f = (u = e.external.registry.get(l[0])) == null ? void 0 : u.id;
      if (t !== l[0] && f) {
        o(l);
        continue;
      }
    }
    if ((c = e.metadataRegistry.get(l[0])) == null ? void 0 : c.id) {
      o(l);
      continue;
    }
    if (h.cycle) {
      o(l);
      continue;
    }
    if (h.count > 1 && e.reused === "ref") {
      o(l);
      continue;
    }
  }
}
function ts(e, t) {
  var a, s, u;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = (c) => {
    const l = e.seen.get(c);
    if (l.ref === null)
      return;
    const h = l.def ?? l.schema, d = { ...h }, f = l.ref;
    if (l.ref = null, f) {
      n(f);
      const m = e.seen.get(f), g = m.schema;
      if (g.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (h.allOf = h.allOf ?? [], h.allOf.push(g)) : Object.assign(h, g), Object.assign(h, d), c._zod.parent === f)
        for (const _ in h)
          _ === "$ref" || _ === "allOf" || _ in d || delete h[_];
      if (g.$ref && m.def)
        for (const _ in h)
          _ === "$ref" || _ === "allOf" || _ in m.def && JSON.stringify(h[_]) === JSON.stringify(m.def[_]) && delete h[_];
    }
    const p = c._zod.parent;
    if (p && p !== f) {
      n(p);
      const m = e.seen.get(p);
      if (m != null && m.schema.$ref && (h.$ref = m.schema.$ref, m.def))
        for (const g in h)
          g === "$ref" || g === "allOf" || g in m.def && JSON.stringify(h[g]) === JSON.stringify(m.def[g]) && delete h[g];
    }
    e.override({
      zodSchema: c,
      jsonSchema: h,
      path: l.path ?? []
    });
  };
  for (const c of [...e.seen.entries()].reverse())
    n(c[0]);
  const i = {};
  if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (a = e.external) != null && a.uri) {
    const c = (s = e.external.registry.get(t)) == null ? void 0 : s.id;
    if (!c)
      throw new Error("Schema is missing an `id` property");
    i.$id = e.external.uri(c);
  }
  Object.assign(i, r.def ?? r.schema);
  const o = ((u = e.external) == null ? void 0 : u.defs) ?? {};
  for (const c of e.seen.entries()) {
    const l = c[1];
    l.def && l.defId && (o[l.defId] = l.def);
  }
  e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
  try {
    const c = JSON.parse(JSON.stringify(i));
    return Object.defineProperty(c, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: gr(t, "input", e.processors),
          output: gr(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), c;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function pe(e, t) {
  const r = t ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e))
    return !1;
  r.seen.add(e);
  const n = e._zod.def;
  if (n.type === "transform")
    return !0;
  if (n.type === "array")
    return pe(n.element, r);
  if (n.type === "set")
    return pe(n.valueType, r);
  if (n.type === "lazy")
    return pe(n.getter(), r);
  if (n.type === "promise" || n.type === "optional" || n.type === "nonoptional" || n.type === "nullable" || n.type === "readonly" || n.type === "default" || n.type === "prefault")
    return pe(n.innerType, r);
  if (n.type === "intersection")
    return pe(n.left, r) || pe(n.right, r);
  if (n.type === "record" || n.type === "map")
    return pe(n.keyType, r) || pe(n.valueType, r);
  if (n.type === "pipe")
    return pe(n.in, r) || pe(n.out, r);
  if (n.type === "object") {
    for (const i in n.shape)
      if (pe(n.shape[i], r))
        return !0;
    return !1;
  }
  if (n.type === "union") {
    for (const i of n.options)
      if (pe(i, r))
        return !0;
    return !1;
  }
  if (n.type === "tuple") {
    for (const i of n.items)
      if (pe(i, r))
        return !0;
    return !!(n.rest && pe(n.rest, r));
  }
  return !1;
}
const Rd = (e, t = {}) => (r) => {
  const n = Xa({ ...r, processors: t });
  return ue(e, n), es(n, e), ts(n, e);
}, gr = (e, t, r = {}) => (n) => {
  const { libraryOptions: i, target: o } = n ?? {}, a = Xa({ ...i ?? {}, target: o, io: t, processors: r });
  return ue(e, a), es(a, e), ts(a, e);
}, Pd = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Fd = (e, t, r, n) => {
  const i = r;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: u, contentEncoding: c } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = Pd[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), c && (i.contentEncoding = c), u && u.size > 0) {
    const l = [...u];
    l.length === 1 ? i.pattern = l[0].source : l.length > 1 && (i.allOf = [
      ...l.map((h) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: h.source
      }))
    ]);
  }
}, Cd = (e, t, r, n) => {
  const i = r, { minimum: o, maximum: a, format: s, multipleOf: u, exclusiveMaximum: c, exclusiveMinimum: l } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof l == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = l, i.exclusiveMinimum = !0) : i.exclusiveMinimum = l), typeof o == "number" && (i.minimum = o, typeof l == "number" && t.target !== "draft-04" && (l >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = c, i.exclusiveMaximum = !0) : i.exclusiveMaximum = c), typeof a == "number" && (i.maximum = a, typeof c == "number" && t.target !== "draft-04" && (c <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof u == "number" && (i.multipleOf = u);
}, Nd = (e, t, r, n) => {
  r.type = "boolean";
}, Ad = (e, t, r, n) => {
  r.not = {};
}, xd = (e, t, r, n) => {
}, Md = (e, t, r, n) => {
  const i = e._zod.def, o = Ca(i.entries);
  o.every((a) => typeof a == "number") && (r.type = "number"), o.every((a) => typeof a == "string") && (r.type = "string"), r.enum = o;
}, jd = (e, t, r, n) => {
  const i = e._zod.def, o = [];
  for (const a of i.values)
    if (a === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof a == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      o.push(Number(a));
    } else
      o.push(a);
  if (o.length !== 0) if (o.length === 1) {
    const a = o[0];
    r.type = a === null ? "null" : typeof a, t.target === "draft-04" || t.target === "openapi-3.0" ? r.enum = [a] : r.const = a;
  } else
    o.every((a) => typeof a == "number") && (r.type = "number"), o.every((a) => typeof a == "string") && (r.type = "string"), o.every((a) => typeof a == "boolean") && (r.type = "boolean"), o.every((a) => a === null) && (r.type = "null"), r.enum = o;
}, $d = (e, t, r, n) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Ld = (e, t, r, n) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Vd = (e, t, r, n) => {
  const i = r, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = ue(o.element, t, { ...n, path: [...n.path, "items"] });
}, qd = (e, t, r, n) => {
  var c;
  const i = r, o = e._zod.def;
  i.type = "object", i.properties = {};
  const a = o.shape;
  for (const l in a)
    i.properties[l] = ue(a[l], t, {
      ...n,
      path: [...n.path, "properties", l]
    });
  const s = new Set(Object.keys(a)), u = new Set([...s].filter((l) => {
    const h = o.shape[l]._zod;
    return t.io === "input" ? h.optin === void 0 : h.optout === void 0;
  }));
  u.size > 0 && (i.required = Array.from(u)), ((c = o.catchall) == null ? void 0 : c._zod.def.type) === "never" ? i.additionalProperties = !1 : o.catchall ? o.catchall && (i.additionalProperties = ue(o.catchall, t, {
    ...n,
    path: [...n.path, "additionalProperties"]
  })) : t.io === "output" && (i.additionalProperties = !1);
}, Zd = (e, t, r, n) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, u) => ue(s, t, {
    ...n,
    path: [...n.path, o ? "oneOf" : "anyOf", u]
  }));
  o ? r.oneOf = a : r.anyOf = a;
}, Qd = (e, t, r, n) => {
  const i = e._zod.def, o = ue(i.left, t, {
    ...n,
    path: [...n.path, "allOf", 0]
  }), a = ue(i.right, t, {
    ...n,
    path: [...n.path, "allOf", 1]
  }), s = (c) => "allOf" in c && Object.keys(c).length === 1, u = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  r.allOf = u;
}, Ud = (e, t, r, n) => {
  const i = e._zod.def, o = ue(i.innerType, t, n), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, r.nullable = !0) : r.anyOf = [o, { type: "null" }];
}, Bd = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Wd = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Jd = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (r._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Gd = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  r.default = a;
}, Kd = (e, t, r, n) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  ue(o, t, n);
  const a = t.seen.get(e);
  a.ref = o;
}, Hd = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.readOnly = !0;
}, rs = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Yd = /* @__PURE__ */ E("ZodISODateTime", (e, t) => {
  th.init(e, t), H.init(e, t);
});
function Xd(e) {
  return /* @__PURE__ */ ad(Yd, e);
}
const ep = /* @__PURE__ */ E("ZodISODate", (e, t) => {
  rh.init(e, t), H.init(e, t);
});
function tp(e) {
  return /* @__PURE__ */ sd(ep, e);
}
const rp = /* @__PURE__ */ E("ZodISOTime", (e, t) => {
  nh.init(e, t), H.init(e, t);
});
function np(e) {
  return /* @__PURE__ */ ud(rp, e);
}
const ip = /* @__PURE__ */ E("ZodISODuration", (e, t) => {
  ih.init(e, t), H.init(e, t);
});
function op(e) {
  return /* @__PURE__ */ cd(ip, e);
}
const ap = (e, t) => {
  ja.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (r) => Bl(e, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => Ul(e, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => {
        e.issues.push(r), e.message = JSON.stringify(e.issues, gn, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (r) => {
        e.issues.push(...r), e.message = JSON.stringify(e.issues, gn, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, we = E("ZodError", ap, {
  Parent: Error
}), sp = /* @__PURE__ */ Un(we), up = /* @__PURE__ */ Bn(we), cp = /* @__PURE__ */ Ir(we), lp = /* @__PURE__ */ zr(we), fp = /* @__PURE__ */ Gl(we), hp = /* @__PURE__ */ Kl(we), dp = /* @__PURE__ */ Hl(we), pp = /* @__PURE__ */ Yl(we), vp = /* @__PURE__ */ Xl(we), mp = /* @__PURE__ */ ef(we), yp = /* @__PURE__ */ tf(we), gp = /* @__PURE__ */ rf(we), te = /* @__PURE__ */ E("ZodType", (e, t) => (ee.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: gr(e, "input"),
    output: gr(e, "output")
  }
}), e.toJSONSchema = Rd(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...r) => e.clone(We(t, {
  checks: [
    ...t.checks ?? [],
    ...r.map((n) => typeof n == "function" ? { _zod: { check: n, def: { check: "custom" }, onattach: [] } } : n)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (r, n) => Je(e, r, n), e.brand = () => e, e.register = ((r, n) => (r.add(e, n), e)), e.parse = (r, n) => sp(e, r, n, { callee: e.parse }), e.safeParse = (r, n) => cp(e, r, n), e.parseAsync = async (r, n) => up(e, r, n, { callee: e.parseAsync }), e.safeParseAsync = async (r, n) => lp(e, r, n), e.spa = e.safeParseAsync, e.encode = (r, n) => fp(e, r, n), e.decode = (r, n) => hp(e, r, n), e.encodeAsync = async (r, n) => dp(e, r, n), e.decodeAsync = async (r, n) => pp(e, r, n), e.safeEncode = (r, n) => vp(e, r, n), e.safeDecode = (r, n) => mp(e, r, n), e.safeEncodeAsync = async (r, n) => yp(e, r, n), e.safeDecodeAsync = async (r, n) => gp(e, r, n), e.refine = (r, n) => e.check(hv(r, n)), e.superRefine = (r) => e.check(dv(r)), e.overwrite = (r) => e.check(/* @__PURE__ */ zt(r)), e.optional = () => go(e), e.exactOptional = () => Xp(e), e.nullable = () => bo(e), e.nullish = () => go(bo(e)), e.nonoptional = (r) => ov(e, r), e.array = () => j(e), e.or = (r) => Up([e, r]), e.and = (r) => Wp(e, r), e.transform = (r) => _o(e, Hp(r)), e.default = (r) => rv(e, r), e.prefault = (r) => iv(e, r), e.catch = (r) => sv(e, r), e.pipe = (r) => _o(e, r), e.readonly = () => lv(e), e.describe = (r) => {
  const n = e.clone();
  return Mt.add(n, { description: r }), n;
}, Object.defineProperty(e, "description", {
  get() {
    var r;
    return (r = Mt.get(e)) == null ? void 0 : r.description;
  },
  configurable: !0
}), e.meta = (...r) => {
  if (r.length === 0)
    return Mt.get(e);
  const n = e.clone();
  return Mt.add(n, r[0]), n;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (r) => r(e), e)), ns = /* @__PURE__ */ E("_ZodString", (e, t) => {
  Wn.init(e, t), te.init(e, t), e._zod.processJSONSchema = (n, i, o) => Fd(e, n, i);
  const r = e._zod.bag;
  e.format = r.format ?? null, e.minLength = r.minimum ?? null, e.maxLength = r.maximum ?? null, e.regex = (...n) => e.check(/* @__PURE__ */ vd(...n)), e.includes = (...n) => e.check(/* @__PURE__ */ gd(...n)), e.startsWith = (...n) => e.check(/* @__PURE__ */ bd(...n)), e.endsWith = (...n) => e.check(/* @__PURE__ */ _d(...n)), e.min = (...n) => e.check(/* @__PURE__ */ yr(...n)), e.max = (...n) => e.check(/* @__PURE__ */ Ha(...n)), e.length = (...n) => e.check(/* @__PURE__ */ Ya(...n)), e.nonempty = (...n) => e.check(/* @__PURE__ */ yr(1, ...n)), e.lowercase = (n) => e.check(/* @__PURE__ */ md(n)), e.uppercase = (n) => e.check(/* @__PURE__ */ yd(n)), e.trim = () => e.check(/* @__PURE__ */ Ed()), e.normalize = (...n) => e.check(/* @__PURE__ */ wd(...n)), e.toLowerCase = () => e.check(/* @__PURE__ */ kd()), e.toUpperCase = () => e.check(/* @__PURE__ */ Sd()), e.slugify = () => e.check(/* @__PURE__ */ Od());
}), bp = /* @__PURE__ */ E("ZodString", (e, t) => {
  Wn.init(e, t), ns.init(e, t), e.email = (r) => e.check(/* @__PURE__ */ $h(_p, r)), e.url = (r) => e.check(/* @__PURE__ */ Qh(wp, r)), e.jwt = (r) => e.check(/* @__PURE__ */ od(xp, r)), e.emoji = (r) => e.check(/* @__PURE__ */ Uh(Ep, r)), e.guid = (r) => e.check(/* @__PURE__ */ fo(mo, r)), e.uuid = (r) => e.check(/* @__PURE__ */ Lh(rr, r)), e.uuidv4 = (r) => e.check(/* @__PURE__ */ Vh(rr, r)), e.uuidv6 = (r) => e.check(/* @__PURE__ */ qh(rr, r)), e.uuidv7 = (r) => e.check(/* @__PURE__ */ Zh(rr, r)), e.nanoid = (r) => e.check(/* @__PURE__ */ Bh(kp, r)), e.guid = (r) => e.check(/* @__PURE__ */ fo(mo, r)), e.cuid = (r) => e.check(/* @__PURE__ */ Wh(Sp, r)), e.cuid2 = (r) => e.check(/* @__PURE__ */ Jh(Op, r)), e.ulid = (r) => e.check(/* @__PURE__ */ Gh(Tp, r)), e.base64 = (r) => e.check(/* @__PURE__ */ rd(Cp, r)), e.base64url = (r) => e.check(/* @__PURE__ */ nd(Np, r)), e.xid = (r) => e.check(/* @__PURE__ */ Kh(Dp, r)), e.ksuid = (r) => e.check(/* @__PURE__ */ Hh(Ip, r)), e.ipv4 = (r) => e.check(/* @__PURE__ */ Yh(zp, r)), e.ipv6 = (r) => e.check(/* @__PURE__ */ Xh(Rp, r)), e.cidrv4 = (r) => e.check(/* @__PURE__ */ ed(Pp, r)), e.cidrv6 = (r) => e.check(/* @__PURE__ */ td(Fp, r)), e.e164 = (r) => e.check(/* @__PURE__ */ id(Ap, r)), e.datetime = (r) => e.check(Xd(r)), e.date = (r) => e.check(tp(r)), e.time = (r) => e.check(np(r)), e.duration = (r) => e.check(op(r));
});
function b(e) {
  return /* @__PURE__ */ jh(bp, e);
}
const H = /* @__PURE__ */ E("ZodStringFormat", (e, t) => {
  J.init(e, t), ns.init(e, t);
}), _p = /* @__PURE__ */ E("ZodEmail", (e, t) => {
  Bf.init(e, t), H.init(e, t);
}), mo = /* @__PURE__ */ E("ZodGUID", (e, t) => {
  Qf.init(e, t), H.init(e, t);
}), rr = /* @__PURE__ */ E("ZodUUID", (e, t) => {
  Uf.init(e, t), H.init(e, t);
}), wp = /* @__PURE__ */ E("ZodURL", (e, t) => {
  Wf.init(e, t), H.init(e, t);
}), Ep = /* @__PURE__ */ E("ZodEmoji", (e, t) => {
  Jf.init(e, t), H.init(e, t);
}), kp = /* @__PURE__ */ E("ZodNanoID", (e, t) => {
  Gf.init(e, t), H.init(e, t);
}), Sp = /* @__PURE__ */ E("ZodCUID", (e, t) => {
  Kf.init(e, t), H.init(e, t);
}), Op = /* @__PURE__ */ E("ZodCUID2", (e, t) => {
  Hf.init(e, t), H.init(e, t);
}), Tp = /* @__PURE__ */ E("ZodULID", (e, t) => {
  Yf.init(e, t), H.init(e, t);
}), Dp = /* @__PURE__ */ E("ZodXID", (e, t) => {
  Xf.init(e, t), H.init(e, t);
}), Ip = /* @__PURE__ */ E("ZodKSUID", (e, t) => {
  eh.init(e, t), H.init(e, t);
}), zp = /* @__PURE__ */ E("ZodIPv4", (e, t) => {
  oh.init(e, t), H.init(e, t);
}), Rp = /* @__PURE__ */ E("ZodIPv6", (e, t) => {
  ah.init(e, t), H.init(e, t);
}), Pp = /* @__PURE__ */ E("ZodCIDRv4", (e, t) => {
  sh.init(e, t), H.init(e, t);
}), Fp = /* @__PURE__ */ E("ZodCIDRv6", (e, t) => {
  uh.init(e, t), H.init(e, t);
}), Cp = /* @__PURE__ */ E("ZodBase64", (e, t) => {
  ch.init(e, t), H.init(e, t);
}), Np = /* @__PURE__ */ E("ZodBase64URL", (e, t) => {
  fh.init(e, t), H.init(e, t);
}), Ap = /* @__PURE__ */ E("ZodE164", (e, t) => {
  hh.init(e, t), H.init(e, t);
}), xp = /* @__PURE__ */ E("ZodJWT", (e, t) => {
  ph.init(e, t), H.init(e, t);
}), is = /* @__PURE__ */ E("ZodNumber", (e, t) => {
  Wa.init(e, t), te.init(e, t), e._zod.processJSONSchema = (n, i, o) => Cd(e, n, i), e.gt = (n, i) => e.check(/* @__PURE__ */ po(n, i)), e.gte = (n, i) => e.check(/* @__PURE__ */ Jr(n, i)), e.min = (n, i) => e.check(/* @__PURE__ */ Jr(n, i)), e.lt = (n, i) => e.check(/* @__PURE__ */ ho(n, i)), e.lte = (n, i) => e.check(/* @__PURE__ */ Wr(n, i)), e.max = (n, i) => e.check(/* @__PURE__ */ Wr(n, i)), e.int = (n) => e.check(yo(n)), e.safe = (n) => e.check(yo(n)), e.positive = (n) => e.check(/* @__PURE__ */ po(0, n)), e.nonnegative = (n) => e.check(/* @__PURE__ */ Jr(0, n)), e.negative = (n) => e.check(/* @__PURE__ */ ho(0, n)), e.nonpositive = (n) => e.check(/* @__PURE__ */ Wr(0, n)), e.multipleOf = (n, i) => e.check(/* @__PURE__ */ vo(n, i)), e.step = (n, i) => e.check(/* @__PURE__ */ vo(n, i)), e.finite = () => e;
  const r = e._zod.bag;
  e.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), e.isFinite = !0, e.format = r.format ?? null;
});
function I(e) {
  return /* @__PURE__ */ ld(is, e);
}
const Mp = /* @__PURE__ */ E("ZodNumberFormat", (e, t) => {
  vh.init(e, t), is.init(e, t);
});
function yo(e) {
  return /* @__PURE__ */ fd(Mp, e);
}
const jp = /* @__PURE__ */ E("ZodBoolean", (e, t) => {
  mh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Nd(e, r, n);
});
function me(e) {
  return /* @__PURE__ */ hd(jp, e);
}
const $p = /* @__PURE__ */ E("ZodUnknown", (e, t) => {
  yh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => xd();
});
function Jt() {
  return /* @__PURE__ */ dd($p);
}
const Lp = /* @__PURE__ */ E("ZodNever", (e, t) => {
  gh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ad(e, r, n);
});
function Vp(e) {
  return /* @__PURE__ */ pd(Lp, e);
}
const qp = /* @__PURE__ */ E("ZodArray", (e, t) => {
  bh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Vd(e, r, n, i), e.element = t.element, e.min = (r, n) => e.check(/* @__PURE__ */ yr(r, n)), e.nonempty = (r) => e.check(/* @__PURE__ */ yr(1, r)), e.max = (r, n) => e.check(/* @__PURE__ */ Ha(r, n)), e.length = (r, n) => e.check(/* @__PURE__ */ Ya(r, n)), e.unwrap = () => e.element;
});
function j(e, t) {
  return /* @__PURE__ */ Td(qp, e, t);
}
const Zp = /* @__PURE__ */ E("ZodObject", (e, t) => {
  wh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => qd(e, r, n, i), Z(e, "shape", () => t.shape), e.keyof = () => ze(Object.keys(e._zod.def.shape)), e.catchall = (r) => e.clone({ ...e._zod.def, catchall: r }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Jt() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Jt() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Vp() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (r) => Ll(e, r), e.safeExtend = (r) => Vl(e, r), e.merge = (r) => ql(e, r), e.pick = (r) => jl(e, r), e.omit = (r) => $l(e, r), e.partial = (...r) => Zl(os, e, r[0]), e.required = (...r) => Ql(as, e, r[0]);
});
function k(e, t) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...P(t)
  };
  return new Zp(r);
}
const Qp = /* @__PURE__ */ E("ZodUnion", (e, t) => {
  Eh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Zd(e, r, n, i), e.options = t.options;
});
function Up(e, t) {
  return new Qp({
    type: "union",
    options: e,
    ...P(t)
  });
}
const Bp = /* @__PURE__ */ E("ZodIntersection", (e, t) => {
  kh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Qd(e, r, n, i);
});
function Wp(e, t) {
  return new Bp({
    type: "intersection",
    left: e,
    right: t
  });
}
const _n = /* @__PURE__ */ E("ZodEnum", (e, t) => {
  Sh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (n, i, o) => Md(e, n, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const r = new Set(Object.keys(t.entries));
  e.extract = (n, i) => {
    const o = {};
    for (const a of n)
      if (r.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new _n({
      ...t,
      checks: [],
      ...P(i),
      entries: o
    });
  }, e.exclude = (n, i) => {
    const o = { ...t.entries };
    for (const a of n)
      if (r.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new _n({
      ...t,
      checks: [],
      ...P(i),
      entries: o
    });
  };
});
function ze(e, t) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((n) => [n, n])) : e;
  return new _n({
    type: "enum",
    entries: r,
    ...P(t)
  });
}
const Jp = /* @__PURE__ */ E("ZodLiteral", (e, t) => {
  Oh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => jd(e, r, n), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function Gp(e, t) {
  return new Jp({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...P(t)
  });
}
const Kp = /* @__PURE__ */ E("ZodTransform", (e, t) => {
  Th.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ld(e, r), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      throw new Pa(e.constructor.name);
    r.addIssue = (o) => {
      if (typeof o == "string")
        r.issues.push(Wt(o, r.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = r.value), a.inst ?? (a.inst = e), r.issues.push(Wt(a));
      }
    };
    const i = t.transform(r.value, r);
    return i instanceof Promise ? i.then((o) => (r.value = o, r)) : (r.value = i, r);
  };
});
function Hp(e) {
  return new Kp({
    type: "transform",
    transform: e
  });
}
const os = /* @__PURE__ */ E("ZodOptional", (e, t) => {
  Ka.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => rs(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function go(e) {
  return new os({
    type: "optional",
    innerType: e
  });
}
const Yp = /* @__PURE__ */ E("ZodExactOptional", (e, t) => {
  Dh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => rs(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function Xp(e) {
  return new Yp({
    type: "optional",
    innerType: e
  });
}
const ev = /* @__PURE__ */ E("ZodNullable", (e, t) => {
  Ih.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ud(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function bo(e) {
  return new ev({
    type: "nullable",
    innerType: e
  });
}
const tv = /* @__PURE__ */ E("ZodDefault", (e, t) => {
  zh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Wd(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function rv(e, t) {
  return new tv({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Aa(t);
    }
  });
}
const nv = /* @__PURE__ */ E("ZodPrefault", (e, t) => {
  Rh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Jd(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function iv(e, t) {
  return new nv({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Aa(t);
    }
  });
}
const as = /* @__PURE__ */ E("ZodNonOptional", (e, t) => {
  Ph.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Bd(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function ov(e, t) {
  return new as({
    type: "nonoptional",
    innerType: e,
    ...P(t)
  });
}
const av = /* @__PURE__ */ E("ZodCatch", (e, t) => {
  Fh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Gd(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function sv(e, t) {
  return new av({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const uv = /* @__PURE__ */ E("ZodPipe", (e, t) => {
  Ch.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Kd(e, r, n, i), e.in = t.in, e.out = t.out;
});
function _o(e, t) {
  return new uv({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const cv = /* @__PURE__ */ E("ZodReadonly", (e, t) => {
  Nh.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => Hd(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function lv(e) {
  return new cv({
    type: "readonly",
    innerType: e
  });
}
const fv = /* @__PURE__ */ E("ZodCustom", (e, t) => {
  Ah.init(e, t), te.init(e, t), e._zod.processJSONSchema = (r, n, i) => $d(e, r);
});
function hv(e, t = {}) {
  return /* @__PURE__ */ Dd(fv, e, t);
}
function dv(e) {
  return /* @__PURE__ */ Id(e);
}
const ss = k({
  id: b(),
  name: b(),
  slug: b(),
  status: ze(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: k({}).partial().passthrough(),
  output: k({}).partial().passthrough().nullable(),
  createdAt: b(),
  startedAt: b().nullable(),
  endedAt: b().nullable()
}).passthrough(), pv = k({ analyses: j(ss) }).passthrough(), vv = k({
  name: b().min(1).max(100),
  outputLocation: k({ fsId: b(), path: b().optional() }).passthrough(),
  analysisSchemaId: I().int().gt(0).lte(9007199254740991),
  version: I(),
  input: Jt(),
  labId: I().optional()
}).passthrough(), mv = k({
  analysisId: b().nullable(),
  analysisSlug: b().nullable(),
  success: me()
}).passthrough(), us = k({ id: I(), name: b(), versions: j(I()) }).passthrough(), yv = k({ analysisSchemas: j(us) }).passthrough(), Jn = k({
  id: I(),
  name: b(),
  schema: k({}).partial().passthrough()
}).passthrough(), wn = k({ id: I(), name: b(), valueSchema: Jn }).passthrough(), cs = k({
  analysisSchemaId: I(),
  version: I(),
  createdAt: b(),
  description: k({ short: b().nullable(), long: b().nullable() }).partial().passthrough(),
  inputs: j(wn),
  outputs: j(wn)
}).passthrough(), gv = k({ versions: j(cs) }).passthrough(), bv = k({ logs: j(b()) }).passthrough(), ls = k({
  id: b(),
  taskArn: b(),
  name: b(),
  status: b(),
  analysisId: b(),
  startedAt: b(),
  endedAt: b(),
  memory: I(),
  vcpus: I()
}).passthrough(), _v = k({ tasks: j(ls) }).passthrough(), wv = k({
  totalCost: I(),
  tasks: j(
    k({ name: b(), cost: I() }).passthrough()
  ),
  runner: I(),
  storageCost: I(),
  vpcCost: I()
}).passthrough(), fs = k({
  analysisSchemaId: I(),
  version: I(),
  name: b()
}).passthrough(), Ev = k({ next: j(fs) }).passthrough(), kv = k({ success: me() }).passthrough(), Sv = k({ valueSchemas: j(Jn) }).passthrough(), hs = ze([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), Gn = ze([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update",
  "notebook_read",
  "notebook_write"
]), Kn = k({
  id: b(),
  firstname: b().nullable(),
  lastname: b().nullable(),
  email: b().nullable(),
  keyPairId: I(),
  roles: j(hs),
  permissions: j(Gn)
}).passthrough(), Ov = k({ user: Kn }).partial().passthrough(), Tv = k({ email: b() }).passthrough(), Dv = k({ success: me() }).passthrough(), Iv = k({ otp: b() }).passthrough(), zv = k({ token: b() }).passthrough(), Rv = k({
  token: b(),
  tokenType: Gp("Bearer"),
  expiresIn: I(),
  expiresAt: b().datetime({ offset: !0 })
}).passthrough(), Pv = k({ token: b() }).passthrough(), Fv = k({ valid: me() }).passthrough(), Cv = k({ name: b(), permissions: j(Gn) }).passthrough(), ds = k({
  id: I(),
  instanceProfile: b().nullable(),
  securityGroup: b().nullable()
}).passthrough(), Kt = k({
  id: I(),
  name: b(),
  labId: I().nullish(),
  userId: b().nullish(),
  status: ze([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: b().nullish(),
  lastLogin: b().nullish(),
  keypairId: I().nullish()
}).passthrough(), Nv = k({
  infra: j(ds),
  keyPairs: j(b()),
  tinkerBoxes: j(Kt)
}).passthrough(), Av = k({ count: I().gte(1).lte(15) }).passthrough(), xv = k({
  firstname: b().min(1),
  lastname: b().min(1),
  email: b().regex(
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/
  ).email(),
  password: b().min(8)
}).passthrough(), Mv = k({ users: j(Kn) }).passthrough(), jv = k({
  firstname: b().nullable(),
  lastname: b().nullable(),
  email: b().nullable()
}).partial().passthrough(), ps = k({ tinkerBox: Kt, keyMaterial: b() }).passthrough(), $v = k({ tinkerBoxes: j(ps) }).passthrough(), vs = k({
  labName: b(),
  ec2Cost: I(),
  s3Cost: I(),
  efsCost: I(),
  totalCost: I()
}).passthrough(), Lv = k({ clients: j(vs) }).passthrough(), ms = k({
  name: b(),
  labName: b(),
  usage: b(),
  cost: I()
}).passthrough(), Vv = k({ tinkerBoxes: j(ms) }).passthrough(), qv = k({ tinkerboxes: j(Kt) }).passthrough(), Zv = k({ tinkerBox: Kt }).passthrough(), Qv = k({ name: b() }).passthrough(), ys = k({
  id: I(),
  date: b(),
  tinkerBoxName: b(),
  lastLoginDate: b().nullable(),
  lastCommandDate: b().nullable(),
  lastCommand: b().nullable(),
  activeProcesses: me(),
  status: ze([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  tinkerBoxId: I(),
  autoStopTime: b().nullable()
}).passthrough(), Uv = k({ allLastActivity: j(ys) }).passthrough(), Bv = k({ name: b().nullable() }).partial().passthrough(), Hn = k({ id: b(), name: b(), isReadOnly: me() }).passthrough(), gs = k({
  id: I(),
  name: b(),
  fileSystems: j(Hn),
  keyPairId: I()
}).passthrough(), Wv = k({ labs: j(gs) }).passthrough(), Jv = k({
  name: b(),
  numTinkerBoxes: I().optional().default(1)
}).passthrough(), Gv = k({ labId: I(), taskId: b() }).passthrough(), Kv = k({ id: b(), labId: I(), logs: b() }).passthrough(), Yn = k({
  id: I(),
  labId: I(),
  userId: b(),
  role: ze(["OWNER", "MEMBER"]),
  user: k({
    firstname: b().nullable(),
    lastname: b().nullable(),
    email: b().nullable(),
    id: b()
  }).partial().passthrough()
}).passthrough(), Hv = k({ labMember: Yn.nullable() }).passthrough(), Yv = k({ labMembers: j(Yn) }).passthrough(), bs = k({
  id: I(),
  labId: I(),
  userId: b(),
  role: ze(["OWNER", "MEMBER"])
}).passthrough(), Xv = k({ labMember: bs }).passthrough(), em = k({ role: b() }).passthrough(), tm = k({ labMemberId: I(), role: b() }).passthrough(), rm = k({ success: me() }).passthrough(), nm = k({
  client_secret: b().nullable(),
  status: b().nullable(),
  payment_status: b()
}).passthrough(), im = k({
  name: b(),
  email: b().regex(
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/
  ).email(),
  message: b()
}).passthrough(), om = k({
  path: b(),
  fsId: b().optional(),
  s3BucketId: I().optional()
}).passthrough(), am = k({ success: me() }).passthrough(), sm = k({ fileSystems: j(Hn) }).passthrough(), um = k({ url: b() }).passthrough(), _s = k({ isFolder: me(), fsId: b(), path: b() }).passthrough(), cm = k({ contents: j(_s) }).passthrough(), lm = k({ files: j(b()) }).passthrough(), fm = k({
  buckets: j(
    k({
      id: I().int().gte(-9007199254740991).lte(9007199254740991),
      bucket: b(),
      region: b(),
      prefix: b().nullish()
    }).passthrough()
  )
}).passthrough(), hm = k({
  fsId: b().optional(),
  source: k({ isFolder: me(), fsId: b(), path: b() }).passthrough(),
  target: k({ isFolder: me(), fsId: b(), path: b() }).passthrough()
}).passthrough(), dm = k({
  fileTransfers: j(
    k({
      id: I().int().gte(-9007199254740991).lte(9007199254740991),
      name: b(),
      userId: b(),
      progress: I(),
      user: Jt()
    })
  )
}).passthrough(), ws = k({
  id: I(),
  name: b(),
  analysisSchemaId: I(),
  analysisSchemaVersion: I(),
  config: k({}).partial().passthrough()
}).passthrough(), pm = k({ templates: j(ws) }).passthrough(), vm = k({
  name: b().min(1).max(255),
  analysisSchemaId: I().int().gte(-9007199254740991).lte(9007199254740991),
  analysisSchemaVersion: I().int().gt(0).lte(9007199254740991),
  triggerLocation: k({
    bucketId: I().int().gt(0).lte(9007199254740991),
    folderPath: b().max(2048)
  }).passthrough(),
  config: Jt()
}).passthrough(), mm = k({
  id: I(),
  name: b(),
  s3BucketId: I(),
  triggerFolder: b(),
  analysisSchemaId: I(),
  analysisSchemaVersion: I(),
  config: k({}).partial().passthrough()
}).passthrough(), ym = k({
  id: I(),
  name: b(),
  schema: k({}).partial().passthrough()
}).passthrough(), gm = k({
  id: I(),
  formId: I(),
  data: k({}).partial().passthrough(),
  dateCreated: b()
}).passthrough(), bm = k({
  id: I(),
  name: b(),
  displayName: b(),
  hichip: b(),
  source: b(),
  bucket: b(),
  bedpeKey: b(),
  hicKey: b(),
  category: b()
}).passthrough(), _m = k({
  id: I(),
  sampleId: I(),
  cluster: b(),
  chr: b(),
  start: I(),
  end: I(),
  size: I(),
  genes: b()
}).passthrough(), wm = k({
  plotId: b(),
  status: ze(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: b(),
  outputKey: b(),
  inputs: k({}).partial().passthrough(),
  endedAt: b().nullable(),
  downloadUrl: b().nullable()
}).passthrough(), Em = k({
  sample: b(),
  range: b(),
  genomeBuild: ze(["hg19", "hg38"]),
  color: b().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: b(),
  flank: I(),
  bedpe: b()
}).passthrough(), Xn = k({
  id: I(),
  title: b(),
  content: b(),
  createdAt: b(),
  updatedAt: b(),
  isActive: me()
}).passthrough(), km = k({ announcements: j(Xn) }).passthrough(), Sm = k({ announcement: Xn.nullable() }).passthrough(), Es = k({
  id: b(),
  title: b(),
  createdAt: b(),
  updatedAt: b(),
  language: b(),
  userId: b().nullable(),
  readonly: me()
}).passthrough(), Om = k({ notebooks: j(Es) }).passthrough(), Tm = k({ language: b() }).passthrough(), ei = k({
  id: b(),
  title: b(),
  createdAt: b(),
  updatedAt: b(),
  language: b(),
  content: b(),
  userId: b().nullable(),
  readonly: me()
}).passthrough(), Dm = k({ notebook: ei }).passthrough(), Im = k({ success: me() }).passthrough(), zm = k({ content: b() }).passthrough(), Rm = k({ title: b() }).passthrough(), Pm = k({ notebook: ei }).passthrough(), Fm = k({ title: b() }).passthrough(), br = {
  AnalysisDto: ss,
  AnalysesDto: pv,
  CreateAnalysisBodyDto: vv,
  CreateAndLaunchAnalysisResponseDto: mv,
  AnalysisSchemaDto: us,
  AnalysisSchemasDto: yv,
  ValueSchemaDto: Jn,
  AnalysisSchemaInputOutput: wn,
  AnalysisSchemaVersionDto: cs,
  AnalysisSchemaVersionsDto: gv,
  AnalysisLogsDto: bv,
  TaskDto: ls,
  TasksDto: _v,
  AnalysisCostBreakdownDto: wv,
  AnalysisNextDto: fs,
  AnalysisNextListDto: Ev,
  SuccessDto: kv,
  ValueSchemasDto: Sv,
  UserRole: hs,
  Permission: Gn,
  UserDto: Kn,
  MeResponse: Ov,
  RequestOtpBody: Tv,
  RequestOtpResponse: Dv,
  LoginBody: Iv,
  LoginCliResponse: zv,
  IssueTokenResponse: Rv,
  VerifyTokenBody: Pv,
  VerifyTokenResponse: Fv,
  RoleDto: Cv,
  Infra: ds,
  TinkerBox: Kt,
  InfraPool: Nv,
  CreateInfraPoolBody: Av,
  CreateUserBody: xv,
  UsersDto: Mv,
  UpdateUserBody: jv,
  TinkerBoxInventory: ps,
  TinkerBoxInventoryList: $v,
  ClientUsage: vs,
  ClientsUsage: Lv,
  TinkerBoxWithUsage: ms,
  TinkerBoxesWithUsage: Vv,
  GetTinkerBoxesResponse: qv,
  LaunchTinkerBoxResponse: Zv,
  UpdateTinkerBoxBodyDto: Qv,
  TinkerBoxLastActivityDto: ys,
  AllLastActivityDto: Uv,
  LaunchLabTinkerBoxBody: Bv,
  FileSystemDto: Hn,
  Lab: gs,
  LabsResponse: Wv,
  CreateLabBody: Jv,
  CreateLabResponse: Gv,
  GetLabTaskResponse: Kv,
  LabMemberDto: Yn,
  LabMemberResponse: Hv,
  LabMembersResponse: Yv,
  LabMember: bs,
  AddLabMemberResponse: Xv,
  UpdateLabMemberBody: em,
  UpdateLabMemberResponse: tm,
  DeleteLabMemberResponse: rm,
  CheckoutSession: nm,
  ContactBody: im,
  CreateDirectoryBody: om,
  CreateDirectoryResponse: am,
  FileSystemsDto: sm,
  PresignedUrlResponse: um,
  FilePath: _s,
  ContentsResponse: cm,
  DeleteFilesResponse: lm,
  GetBucketsResponse: fm,
  MoveFileBody: hm,
  FileTransfersResponse: dm,
  ActionTemplateDto: ws,
  ActionTemplatesDto: pm,
  CreateActionBodyDto: vm,
  ActionDto: mm,
  FormSchema: ym,
  FormSubmission: gm,
  SampleDto: bm,
  SampleClusterDto: _m,
  PlotDto: wm,
  PlotContactsArgs: Em,
  Announcement: Xn,
  ActiveAnnouncements: km,
  LatestAnnouncement: Sm,
  NotebookWithoutContentDto: Es,
  GetNotebooksDto: Om,
  CreateNotebookBody: Tm,
  NotebookDto: ei,
  CreateNotebookDto: Dm,
  DeleteNotebookDto: Im,
  SaveNotebookBody: zm,
  DuplicateNotebookBody: Rm,
  DuplicateNotebookDto: Pm,
  EditNotebookTitleBody: Fm
};
class Lm {
  constructor(t) {
    at(this, "fetch");
    this.fetch = t;
  }
  async download(t, r, n = null, i = !0) {
    let a = `/files/presigned/${encodeURIComponent(r)}/url?method=download`;
    t && (a += `&bucket=${t}`), n && (a += `&limit=${n}`);
    const u = (await this.fetch(
      a,
      { method: "GET" },
      br.PresignedUrlResponse
    )).url;
    if (i) {
      const c = document.createElement("a");
      c.href = u, c.download = "", c.target = "_blank", c.click(), document.body.appendChild(c), c.click(), setTimeout(() => {
        document.body.removeChild(c);
      });
    }
    return u;
  }
  async upload(t, r, n) {
    const i = [];
    let a = `/files/presigned/${encodeURIComponent(n)}/url?method=upload`;
    r && (a = a += `&bucket=${r}`);
    const u = (await this.fetch(
      a,
      { method: "GET" },
      br.PresignedUrlResponse
    )).url, c = new XMLHttpRequest();
    return c.open("PUT", u), c.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), c.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, c.upload.addEventListener("progress", (l) => {
      const h = l.loaded / l.total;
      for (const d of i)
        d.onProgress(h);
    }), c.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      c.upload.removeEventListener("progress", () => null);
    }), c.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
const Cm = async (e) => {
  if (!(await fetch(e, {
    method: "GET",
    credentials: "include"
  })).ok)
    throw new Error("Failed to refresh token");
};
function Vm(e) {
  async function t(r, n = {}, i, o = !0) {
    const a = { "Content-Type": "application/json", ...n.headers }, s = await fetch(`${e}${r}`, {
      ...n,
      headers: a,
      credentials: "include"
    });
    if ((s.status === 401 || s.status === 403) && o)
      return await Cm(`${e}/auth/token/refresh`), t(
        r,
        { headers: a, ...n, credentials: "include" },
        i,
        !1
      );
    if (!s.ok) {
      const u = await s.text();
      throw new Error(u);
    }
    if (i) {
      const u = await s.json();
      return i.parse(u);
    } else
      return s;
  }
  return t;
}
class qm {
  constructor(t) {
    at(this, "fetch");
    this.fetch = t;
  }
  async download(t, r, n = null, i = !0) {
    let a = `/files/presigned/${encodeURIComponent(r)}/url?method=download&fsId=${t}`;
    n && (a += `&limit=${n}`);
    const u = (await this.fetch(
      a,
      { method: "GET" },
      br.PresignedUrlResponse
    )).url;
    if (i) {
      const c = document.createElement("a");
      c.href = u, c.download = "", c.target = "_blank", c.click(), document.body.appendChild(c), c.click(), setTimeout(() => {
        document.body.removeChild(c);
      });
    }
    return u;
  }
  async upload(t, r, n) {
    const i = [];
    let a = `/files/presigned/${encodeURIComponent(n)}/url?method=upload&fsId=${r}`;
    const u = (await this.fetch(
      a,
      { method: "GET" },
      br.PresignedUrlResponse
    )).url, c = new XMLHttpRequest();
    return c.open("PUT", u), c.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), c.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, c.upload.addEventListener("progress", (l) => {
      const h = l.loaded / l.total;
      for (const d of i)
        d.onProgress(h);
    }), c.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      c.upload.removeEventListener("progress", () => null);
    }), c.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
export {
  $m as APIClient,
  qm as FSClient,
  Lm as S3,
  Vm as createFetch,
  Cm as refreshToken,
  br as schemas
};
//# sourceMappingURL=client.js.map
